{
  "app": {
    "name": "HMS",
    "fullName": "ระบบบริหารจัดการโรงพยาบาล",
    "tagline": "การดูแลที่เชื่อมโยงกัน"
  },
  "common": {
    "save": "บันทึก",
    "saving": "กำลังบันทึก…",
    "cancel": "ยกเลิก",
    "close": "ปิด",
    "edit": "แก้ไข",
    "delete": "ลบ",
    "add": "เพิ่ม",
    "create": "สร้าง",
    "search": "ค้นหา",
    "searchPlaceholder": "ค้นหา…",
    "loading": "กำลังโหลด…",
    "retry": "ลองใหม่",
    "back": "ย้อนกลับ",
    "next": "ถัดไป",
    "previous": "ก่อนหน้า",
    "confirm": "ยืนยัน",
    "yes": "ใช่",
    "no": "ไม่",
    "actions": "การดำเนินการ",
    "status": "สถานะ",
    "details": "รายละเอียด",
    "none": "ไม่มี",
    "all": "ทั้งหมด",
    "optional": "ไม่บังคับ",
    "required": "จำเป็น",
    "notes": "หมายเหตุ",
    "reason": "เหตุผล",
    "date": "วันที่",
    "time": "เวลา",
    "from": "จาก",
    "to": "ถึง",
    "filter": "ตัวกรอง",
    "clear": "ล้าง",
    "refresh": "รีเฟรช",
    "print": "พิมพ์",
    "export": "ส่งออก",
    "import": "นำเข้า",
    "reset": "รีเซ็ต",
    "view": "ดู",
    "open": "เปิด",
    "submit": "ส่ง",
    "select": "เลือก",
    "selectPlaceholder": "เลือก…",
    "noResults": "ไม่พบข้อมูล",
    "total": "รวม",
    "showing": "{{from}}–{{to}} จาก {{total}}",
    "unknown": "ไม่ทราบ",
    "saved": "บันทึกแล้ว",
    "today": "วันนี้",
    "name": "ชื่อ",
    "code": "รหัส",
    "type": "ประเภท",
    "description": "รายละเอียด",
    "createdAt": "สร้างเมื่อ",
    "updatedAt": "อัปเดตเมื่อ",
    "yearsShort": "{{count}} ปี",
    "dash": "—",
    "more": "เพิ่มเติม",
    "active": "ใช้งาน",
    "inactive": "ไม่ใช้งาน",
    "first": "หน้าแรก",
    "last": "หน้าสุดท้าย",
    "pageOf": "หน้า {{page}} จาก {{pages}}",
    "rowsPerPage": "แถวต่อหน้า",
    "pagination": "การแบ่งหน้า",
    "viewAs": "แสดงแบบ",
    "views": {
      "list": "รายการ",
      "cards": "การ์ด",
      "grid": "ตาราง"
    },
    "datePlaceholder": "วว/ดด/ปปปป",
    "pickDate": "เลือกวันที่",
    "change": "เปลี่ยน",
    "goToPage": "ไปที่หน้า",
    "jumpBack": "ย้อนกลับ {{count}} หน้า",
    "jumpForward": "ถัดไป {{count}} หน้า",
    "cancelled": "ยกเลิกแล้ว",
    "choose": "เลือก…",
    "selectAll": "เลือกทั้งหมด"
  },
  "nav": {
    "dashboard": "แดชบอร์ด",
    "patients": "ผู้ป่วย",
    "appointments": "นัดหมาย",
    "queue": "คิว",
    "encounters": "การตรวจรักษา",
    "pharmacy": "ห้องยา",
    "laboratory": "ห้องปฏิบัติการ",
    "billing": "ใบแจ้งหนี้และรับเงิน",
    "administration": "การดูแลระบบ",
    "users": "ผู้ใช้",
    "departments": "แผนก",
    "practitioners": "แพทย์และบุคลากร",
    "hospital": "โรงพยาบาล",
    "auditLog": "บันทึกการตรวจสอบ",
    "translations": "การแปลภาษา",
    "languages": "ภาษา",
    "settings": "ตั้งค่า",
    "notifications": "การแจ้งเตือน",
    "signOut": "ออกจากระบบ",
    "menu": "เมนู",
    "home": "หน้าแรก",
    "eyeCenter": "ศูนย์จักษุ",
    "treatmentCycles": "วงจรการรักษา",
    "patientApp": "แอปผู้ป่วย",
    "reports": "รายงาน",
    "locations": "สถานที่",
    "inventory": "คลังสินค้า",
    "inpatient": "ผู้ป่วยใน",
    "bedBoard": "ผังเตียง",
    "admissions": "การรับเข้ารักษา",
    "wardSetup": "หอผู้ป่วย ห้อง และเตียง",
    "specialServices": "บริการพิเศษ",
    "serviceWorklist": "รายการงาน",
    "serviceCatalog": "บริการและราคา",
    "pos": "ร้านขายยา POS",
    "posCounter": "ขาย",
    "salesHistory": "ประวัติการขาย",
    "itemsPrices": "รายการและราคา",
    "finance": "การเงินและบัญชี",
    "collapseMenu": "ย่อเมนู",
    "expandMenu": "ขยายเมนู",
    "posStock": "สต็อกและการเติม",
    "posCatalog": "รายการสินค้าและราคา",
    "diseases": "โรค",
    "nationalReporting": "รายงานระดับชาติ",
    "area": {
      "patientAdmin": "งานทะเบียนผู้ป่วย",
      "clinical": "การตรวจรักษา",
      "eye": "ศูนย์ตา",
      "inpatient": "ผู้ป่วยใน",
      "supplies": "ยาและพัสดุ",
      "finance": "การเงิน",
      "reporting": "ผลงานและรายงานระดับชาติ",
      "engagement": "การสื่อสารกับผู้ป่วย",
      "platform": "ระบบและการบริหาร"
    },
    "tenants": "องค์กรและโรงพยาบาล",
    "referrals": "การส่งต่อ",
    "followUps": "การนัดติดตาม",
    "duplicates": "ผู้ป่วยซ้ำ",
    "roles": "บทบาทและสิทธิ์",
    "appointmentDashboard": "แดชบอร์ด",
    "appointmentList": "รายการนัดหมาย",
    "disabilityTypes": "ประเภทความพิการ",
    "queueDashboard": "หน้าจอเจ้าหน้าที่",
    "queueKiosk": "ตู้บริการตนเอง",
    "queueDisplay": "จอแสดงคิว",
    "queueReport": "เวลารอคอย",
    "queueServices": "จุดบริการคิว",
    "staffKpi": "KPI บุคลากร",
    "staffDashboard": "แดชบอร์ด",
    "staffLeaderboard": "อันดับ",
    "staffTargets": "เป้าหมาย"
  },
  "auth": {
    "signIn": "เข้าสู่ระบบ",
    "signInTitle": "ยินดีต้อนรับกลับ",
    "signInSubtitle": "เข้าสู่ระบบเพื่อใช้งานระบบโรงพยาบาล",
    "username": "ชื่อผู้ใช้หรืออีเมล",
    "password": "รหัสผ่าน",
    "signingIn": "กำลังเข้าสู่ระบบ…",
    "sessionExpired": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    "changePassword": "เปลี่ยนรหัสผ่าน",
    "currentPassword": "รหัสผ่านปัจจุบัน",
    "newPassword": "รหัสผ่านใหม่",
    "confirmPassword": "ยืนยันรหัสผ่านใหม่",
    "passwordMismatch": "รหัสผ่านไม่ตรงกัน",
    "passwordChanged": "เปลี่ยนรหัสผ่านแล้ว กรุณาเข้าสู่ระบบใหม่",
    "passwordPolicy": "อย่างน้อย 8 ตัวอักษร มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และตัวเลข",
    "switchHospital": "เปลี่ยนโรงพยาบาล",
    "hospital": "โรงพยาบาล",
    "demoAccounts": "บัญชีทดลอง",
    "showPassword": "แสดงรหัสผ่าน",
    "hidePassword": "ซ่อนรหัสผ่าน",
    "usernamePlaceholder": "เช่น doctor",
    "featureClinical": "ผู้ป่วย การตรวจ ห้องยา แล็บ และการเงิน ในที่เดียว",
    "featureAnalytics": "แดชบอร์ดแบบเรียลไทม์และการวิเคราะห์เทียบรายปี",
    "featureLanguages": "ลาว ไทย อังกฤษ จีน และเวียดนาม — ปรับแต่งข้อความได้",
    "featureSecurity": "สิทธิ์ตามบทบาท พร้อมบันทึกการตรวจสอบครบถ้วน",
    "stats": {
      "title": "สถิติล่าสุด",
      "patients": "ผู้ป่วยที่ลงทะเบียน",
      "newThisMonth": "+{{count}} เดือนนี้",
      "visitsThisYear": "การมารับบริการปีนี้",
      "today": "วันนี้ {{count}}",
      "eyeExams": "การตรวจตา",
      "surgeries": "ผ่าตัดตา {{count}} ครั้ง",
      "villages": "หมู่บ้านที่ได้รับบริการ",
      "provinces": "ใน {{count}} แขวง",
      "departments": "แผนกรักษา",
      "practitioners": "แพทย์ {{count}} คน",
      "appAccounts": "ผู้ใช้แอปผู้ป่วย",
      "patientApp": "ผ่านแอปมือถือ",
      "visitsByMonth": "การมารับบริการต่อเดือน (12 เดือนล่าสุด)"
    },
    "app": {
      "title": "แอปมือถือ",
      "download": "ดาวน์โหลด APK",
      "scan": "สแกนด้วยมือถือ",
      "howTo": "วิธีติดตั้ง",
      "step1": "ดาวน์โหลด APK ลงมือถือ Android (Android 7.0 ขึ้นไป)",
      "step2": "เปิดไฟล์ แล้วอนุญาตการติดตั้งแอปจากแหล่งนี้เมื่อระบบถาม",
      "step3": "เปิดแอป: ผู้ป่วยสร้างบัญชีด้วยเบอร์โทรหรืออีเมล เจ้าหน้าที่เข้าสู่ระบบด้วยชื่อผู้ใช้",
      "version": "Android · เวอร์ชัน {{version}} · {{date}}",
      "patient": {
        "name": "HMS ผู้ป่วย",
        "desc": "สำหรับผู้ป่วย: สมัครด้วยเบอร์โทรหรืออีเมล ดูประวัติ คิว และบิล"
      },
      "staff": {
        "name": "HMS เจ้าหน้าที่",
        "desc": "สำหรับเจ้าหน้าที่โรงพยาบาล: เข้าสู่ระบบด้วยบัญชี HMS"
      }
    }
  },
  "errors": {
    "generic": "เกิดข้อผิดพลาด กรุณาลองใหม่",
    "network": "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาตรวจสอบการเชื่อมต่อ",
    "UNAUTHORIZED": "กรุณาเข้าสู่ระบบเพื่อดำเนินการต่อ",
    "INVALID_CREDENTIALS": "ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง",
    "ACCOUNT_LOCKED": "บัญชีถูกล็อกชั่วคราวเนื่องจากเข้าสู่ระบบผิดหลายครั้ง กรุณาลองใหม่ภายหลัง",
    "ACCOUNT_DISABLED": "บัญชีนี้ถูกปิด กรุณาติดต่อโรงพยาบาล",
    "TOKEN_INVALID": "เซสชันไม่ถูกต้องแล้ว กรุณาเข้าสู่ระบบใหม่",
    "TOKEN_REUSED": "เซสชันถูกปิดเพื่อความปลอดภัย กรุณาเข้าสู่ระบบใหม่",
    "SESSION_EXPIRED": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    "NO_HOSPITAL_ACCESS": "บัญชีของคุณยังไม่มีสิทธิ์เข้าใช้โรงพยาบาลใด",
    "HOSPITAL_ACCESS_DENIED": "คุณไม่มีสิทธิ์เข้าใช้โรงพยาบาลนั้น",
    "FORBIDDEN": "คุณไม่มีสิทธิ์ดำเนินการนี้",
    "NOT_FOUND": "ไม่พบข้อมูลที่ต้องการ",
    "VALIDATION_FAILED": "กรุณาแก้ไขช่องที่ระบุ",
    "INVALID_JSON": "ไม่สามารถอ่านคำขอได้",
    "INVALID_PARAMETER": "ค่าตัวกรองไม่ถูกต้อง",
    "DUPLICATE": "มีข้อมูลที่มีค่าเดียวกันอยู่แล้ว",
    "CONFLICT": "ข้อมูลนี้ขัดแย้งกับข้อมูลที่มีอยู่",
    "VERSION_CONFLICT": "มีผู้อื่นแก้ไขข้อมูลนี้แล้ว กรุณาโหลดใหม่แล้วลองอีกครั้ง",
    "SCHEDULE_CONFLICT": "เวลานี้ซ้อนกับนัดหมายอื่นของแพทย์ท่านนี้",
    "INVALID_STATE": "ไม่สามารถดำเนินการนี้ในสถานะปัจจุบัน",
    "INVALID_TRANSITION": "ไม่สามารถดำเนินการนี้ในสถานะปัจจุบัน",
    "MRN_EXISTS": "เลขเวชระเบียนนี้ถูกใช้แล้ว",
    "DUPLICATE_IDENTIFIER": "มีผู้ป่วยที่ใช้เลขประจำตัวนี้แล้ว",
    "POTENTIAL_DUPLICATE": "มีผู้ป่วยที่คล้ายกันอยู่แล้ว",
    "ALLERGY_WARNING": "ยานี้ตรงกับประวัติการแพ้ที่บันทึกไว้",
    "OVERPAYMENT": "จำนวนเงินเกินยอดค้างชำระ",
    "TOO_MANY_REQUESTS": "มีคำขอมากเกินไป กรุณารอสักครู่",
    "INTERNAL_ERROR": "เกิดข้อผิดพลาดที่เซิร์ฟเวอร์",
    "UNSIGNED_NOTES": "กรุณาลงนามหรือลบบันทึกฉบับร่างก่อนปิดการตรวจ",
    "ENCOUNTER_CLOSED": "การตรวจรักษานี้ปิดแล้ว",
    "ENCOUNTER_EXISTS": "มีการตรวจรักษาสำหรับนัดหมายนี้แล้ว",
    "ENCOUNTER_HAS_ACTIVITY": "ไม่สามารถยกเลิกการตรวจที่มีบันทึกลงนามหรือมีคำสั่งแล้ว",
    "QUEUE_CLOSED": "คิวของแผนกนี้ปิดแล้ว",
    "INVOICE_HAS_PAYMENTS": "กรุณาคืนเงินก่อนยกเลิกใบแจ้งหนี้",
    "EMPTY_INVOICE": "กรุณาเพิ่มรายการอย่างน้อยหนึ่งรายการ",
    "SPECIMEN_NOT_COLLECTED": "กรุณาเก็บสิ่งส่งตรวจก่อนบันทึกผล",
    "RESULT_VERIFIED": "ผลที่ยืนยันแล้วต้องแก้ไขผ่านการแก้ผล ไม่ใช่บันทึกใหม่",
    "NOTHING_TO_DISPENSE": "ไม่มียาที่ต้องจ่ายแล้ว",
    "QUANTITY_EXCEEDED": "จำนวนเกินกว่าที่สั่ง",
    "CANNOT_DISABLE_SELF": "คุณไม่สามารถปิดบัญชีของตนเองได้",
    "CONSTRAINT_VIOLATION": "ข้อมูลขัดกับกฎทางคลินิกหรือทางธุรกิจ",
    "INVALID_REFERENCE": "ไม่พบข้อมูลที่อ้างอิง",
    "PATIENT_INACTIVE": "เวชระเบียนผู้ป่วยนี้ไม่ได้ใช้งาน",
    "PATIENT_MISMATCH": "ข้อมูลที่เลือกเป็นของผู้ป่วยรายอื่น",
    "NOTE_SIGNED": "บันทึกที่ลงนามแล้วแก้ไขไม่ได้ กรุณาสร้างบันทึกแก้ไขเพิ่มเติม",
    "NOTE_NOT_SIGNED": "แก้ไขเพิ่มเติมได้เฉพาะบันทึกที่ลงนามแล้ว",
    "NO_DEPARTMENT": "กรุณาเลือกแผนกก่อน",
    "IDEMPOTENCY_KEY_REUSED": "คำขอชำระเงินนี้ถูกใช้กับใบแจ้งหนี้อื่นแล้ว",
    "LOCALE_REQUIRED": "ไม่สามารถปิดภาษาอังกฤษได้",
    "RETRY": "ข้อมูลกำลังถูกใช้งาน กรุณาลองใหม่",
    "EXAM_SIGNED": "การตรวจนี้ลงนามแล้ว กรุณาสร้างฉบับแก้ไข",
    "EXAM_EMPTY": "กรุณาบันทึกผลตรวจอย่างน้อยหนึ่งรายการก่อนลงนาม",
    "EXAM_EXISTS": "การมาตรวจนี้มีการตรวจตาที่เปิดอยู่แล้ว",
    "EXAM_NOT_SIGNED": "แก้ไขได้เฉพาะการตรวจที่ลงนามแล้ว",
    "EYE_SIDE_MISMATCH": "ข้างตาไม่ตรงกัน: ไม่ตรงกับแผนหรือผลการวัด",
    "PREOP_NOT_CONFIRMED": "กรุณาทำรายการตรวจความปลอดภัยก่อนผ่าตัดให้เสร็จก่อน",
    "BIOMETRY_REQUIRED": "การผ่าตัดต้อกระจกต้องมีผลวัดไบโอเมตรีของตาที่จะผ่า",
    "IOL_NOT_SELECTED": "กรุณาเลือกเลนส์แก้วตาเทียมก่อนยืนยัน",
    "IOL_POWER_MISMATCH": "กำลังเลนส์ที่ใส่ไม่ตรงกับแผนที่เลือกไว้",
    "IMPLANT_EXPIRED": "อุปกรณ์ฝังหมดอายุแล้ว",
    "MEDICATION_EXPIRED": "ยาล็อตนี้หมดอายุแล้ว",
    "IOL_OUT_OF_RANGE": "ค่าที่วัดได้อยู่นอกช่วงของสูตร",
    "BIOMETRY_LOCKED": "ผลวัดนี้ถูกใช้ในการผ่าตัดแล้ว",
    "DATE_IN_PAST": "วันที่ผ่านมาแล้ว",
    "PATHWAY_SHARED": "แม่แบบที่ใช้ร่วมกันแก้ไขไม่ได้ กรุณาคัดลอกไปยังโรงพยาบาลของคุณ",
    "STAGE_IN_USE": "ลบขั้นตอนที่มีผู้ป่วยอยู่ไม่ได้",
    "PATHWAY_ARCHIVED": "วงจรนี้ถูกเก็บถาวรแล้ว",
    "ACTIVATION_INVALID": "รหัสเปิดใช้งานไม่ถูกต้องหรือหมดอายุ",
    "OTP_INVALID": "รหัสไม่ถูกต้อง",
    "OTP_EXPIRED": "รหัสหมดอายุ กรุณาขอใหม่",
    "OTP_LOCKED": "ใส่ผิดหลายครั้ง กรุณาขอรหัสใหม่",
    "OTP_RATE_LIMITED": "ขอรหัสมากเกินไป ลองใหม่ภายหลัง",
    "VERIFICATION_REQUIRED": "กรุณาแสดงบัตรประชาชนที่โต๊ะลงทะเบียนก่อน",
    "QUEUE_PAUSED": "แผนกนี้หยุดรับบัตรคิวผ่านแอปชั่วคราว",
    "EID_INVALID": "QR ไม่ถูกต้องหรือหมดอายุ ให้ผู้ป่วยรีเฟรช",
    "EID_OTHER_HOSPITAL": "QR นี้เป็นของโรงพยาบาลอื่น",
    "PHOTO_TOO_LARGE": "รูปต้องมีขนาดไม่เกิน 2 MB",
    "PHOTO_INVALID": "กรุณาอัปโหลดรูป JPEG, PNG หรือ WebP",
    "SUBDISTRICT_IN_USE": "มีผู้ป่วยอยู่ในตำบลนี้ จึงลบไม่ได้",
    "INSUFFICIENT_STOCK": "สต็อกที่ใช้ได้ไม่เพียงพอ",
    "SELF_APPROVAL": "ต้องให้ผู้อื่นตรวจหรืออนุมัติเอกสารที่คุณจัดทำเอง",
    "NO_DISPENSING_STORE": "ยังไม่ได้ตั้งคลังจ่ายยา",
    "NOTHING_APPROVED": "อนุมัติอย่างน้อยหนึ่งรายการ หรือไม่อนุมัติใบขอ",
    "DUPLICATE_LINE": "แต่ละรายการใส่ได้ครั้งเดียว",
    "DISCOUNT_EXCEEDS_BALANCE": "ส่วนลดทำให้ยอดบิลต่ำกว่าที่ชำระแล้ว",
    "BED_UNAVAILABLE": "เตียงนี้ไม่ว่าง",
    "BED_OCCUPIED": "มีผู้ป่วยอยู่ที่เตียงนี้",
    "ALREADY_ADMITTED": "ผู้ป่วยอยู่ระหว่างรักษาตัวแล้ว",
    "WARD_OCCUPIED": "ยังมีผู้ป่วยในหอนี้",
    "ROOM_OCCUPIED": "มีเตียงในห้องนี้มีผู้ป่วย",
    "DISCHARGE_PENDING": "ยังมีงานที่ยังไม่เสร็จ",
    "ADMISSION_HAS_ACTIVITY": "มีคำสั่งหรือบิลแล้ว ให้จำหน่ายแทน",
    "SAME_BED": "ผู้ป่วยอยู่เตียงนี้แล้ว",
    "ALREADY_BILLED": "ออกบิลแล้ว กรุณายกเลิกบิลก่อน",
    "NOT_FOR_SALE": "รายการนี้ไม่ได้ขาย",
    "PATIENT_REQUIRED": "กรุณาเลือกผู้ป่วยสำหรับยาควบคุม",
    "NO_CASH_SESSION": "กรุณาเปิดลิ้นชักเงินก่อน",
    "SESSION_OPEN": "คุณมีลิ้นชักเงินเปิดอยู่แล้ว",
    "SESSION_CLOSED": "ลิ้นชักเงินนั้นปิดแล้ว ให้บันทึกการคืนแทน",
    "STORE_INACTIVE": "คลังนี้ไม่ได้ใช้งาน",
    "TOO_MANY_IMAGES": "รูปภาพมากเกินไป",
    "POS_REFILL_ONLY": "สินค้าไปจุดขาย POS ต้องส่งตามคำขอเติมสินค้า POS",
    "POS_OUTLET": "สต็อกจุดขาย POS เปลี่ยนได้ผ่านการเติมและการขายเท่านั้น",
    "NOT_A_POS_OUTLET": "การขายต้องทำจากจุดขาย POS",
    "NOT_IN_CATALOG": "ขอได้เฉพาะสินค้าในรายการ POS",
    "NOTHING_TO_SEND": "ไม่มีสินค้าให้ส่ง: คลังไม่มีสินค้าที่ขอ",
    "EXCEEDS_SENT": "รับมากกว่าที่ส่งมา",
    "DUPLICATE_CODE": "รหัสนี้ถูกใช้แล้ว",
    "TYPE_IN_USE": "ประเภทนี้ยังมีโรคอยู่ ให้ย้ายโรคหรือปิดใช้งานแทน",
    "SEGREGATION_OF_DUTIES": "ต้องให้ผู้อื่นที่ไม่ใช่ผู้สร้างเป็นผู้อนุมัติ",
    "NOT_DRAFT": "ทำได้เฉพาะฉบับร่าง",
    "NOT_VALIDATED": "โปรดตรวจสอบก่อน",
    "NOT_APPROVED": "ต้องอนุมัติก่อน",
    "SNAPSHOT_HAS_ERRORS": "ฉบับรายงานมีข้อผิดพลาด แก้ไขแล้วสร้างฉบับใหม่",
    "HASH_MISMATCH": "เนื้อหาฉบับรายงานไม่ตรงกับลายนิ้วมือข้อมูล",
    "SNAPSHOT_FINAL": "ฉบับรายงานนี้เปลี่ยนแปลงไม่ได้อีก",
    "SNAPSHOT_NOT_APPROVED": "ฉบับรายงานต้องได้รับการอนุมัติ",
    "OPEN_BATCH_EXISTS": "มีชุดข้อมูลอื่นสำหรับข้อมูลเดียวกันที่ยังเปิดอยู่",
    "MAPPING_OVERLAP": "มีการจับคู่อื่นครอบคลุมวันที่เหล่านี้แล้ว ให้เลิกใช้อันนั้นก่อน",
    "METADATA_MISSING": "โปรดดึง metadata DHIS2 ก่อน",
    "INSTANCE_DISABLED": "การเชื่อมต่อ DHIS2 นี้ถูกปิด",
    "NOT_RETRYABLE": "ชุดนี้ส่งใหม่ไม่ได้",
    "NOT_RECONCILABLE": "ตรวจเทียบได้เฉพาะชุดที่ส่งแล้ว",
    "NOT_CANCELLABLE": "ชุดนี้ยกเลิกไม่ได้แล้ว",
    "INVALID_PERIOD": "ใส่ช่วงเวลาเช่น 202610, 2026Q4 หรือ 2026",
    "PERIOD_TYPE_MISMATCH": "ช่วงเวลาไม่ตรงกับความถี่ของรายงาน",
    "REPORT_RETIRED": "รายงานนี้เลิกใช้แล้ว",
    "REPORT_EMPTY": "รายงานนี้ไม่มี KPI ที่ใช้งาน",
    "NO_DIRECTION": "กำหนดก่อนว่าสูงดีหรือต่ำดี",
    "DUPLICATE_NAME": "ชื่อนี้ถูกใช้แล้ว",
    "UNKNOWN_CALCULATOR": "ไม่รู้จักตัวคำนวณ",
    "CONCURRENT_CHANGE": "มีการเปลี่ยนแปลงระหว่างนี้ ลองใหม่",
    "ALREADY_RETIRED": "เลิกใช้แล้ว",
    "OWN_TENANT": "คุณไม่สามารถระงับองค์กรที่คุณกำลังใช้อยู่",
    "OWN_HOSPITAL": "คุณไม่สามารถปิดใช้โรงพยาบาลที่คุณกำลังใช้อยู่",
    "REFERRAL_CLOSED": "การส่งต่อที่เสร็จแล้วแก้ไขไม่ได้",
    "PATIENT_MERGED": "ระเบียนผู้ป่วยนี้ถูกรวมเข้าระเบียนอื่นแล้ว",
    "MERGE_PENDING": "การรวมสองระเบียนนี้กำลังรออนุมัติอยู่แล้ว",
    "BOTH_ADMITTED": "ทั้งสองระเบียนกำลังนอนโรงพยาบาล ให้จำหน่ายหนึ่งระเบียนก่อน",
    "FOLLOW_UP_CLOSED": "การนัดติดตามนี้สิ้นสุดแล้ว",
    "NOT_REQUESTED": "คำขอนี้ถูกตัดสินแล้ว",
    "ROLE_LOCKED": "ผู้ดูแลสูงสุดมีทุกสิทธิ์เสมอ",
    "ROLE_BUILT_IN": "บทบาทที่มีในระบบลบไม่ได้ ให้นำสิทธิ์ออกแทน",
    "ROLE_IN_USE": "บทบาทนี้ยังมอบให้ผู้ใช้อยู่",
    "DISABILITY_TYPE_IN_USE": "มีผู้ป่วยที่มีประเภทความพิการนี้ ให้ปิดการใช้งานแทน",
    "DISABILITY_TYPE_HAS_SUB_TYPES": "ลบหรือย้ายประเภทย่อยก่อน"
  },
  "validation": {
    "required": "จำเป็นต้องกรอก",
    "invalid": "ค่าไม่ถูกต้อง",
    "invalidType": "ค่าไม่ถูกต้อง",
    "tooLong": "ยาวเกินไป",
    "invalidOption": "กรุณาเลือกตัวเลือกที่ถูกต้อง",
    "invalidDate": "กรุณากรอกวันที่ที่ถูกต้อง",
    "invalidDateTime": "กรุณากรอกวันที่และเวลาที่ถูกต้อง",
    "invalidNumber": "กรุณากรอกตัวเลข",
    "invalidInteger": "กรุณากรอกจำนวนเต็ม",
    "outOfRange": "ค่าอยู่นอกช่วงที่กำหนด",
    "invalidEmail": "กรุณากรอกอีเมลที่ถูกต้อง",
    "invalidPhone": "กรุณากรอกเบอร์โทรที่ถูกต้อง",
    "implausibleDate": "วันที่ไม่สมเหตุสมผล",
    "weakPassword": "รหัสผ่านไม่ปลอดภัยพอ",
    "incorrect": "ไม่ถูกต้อง",
    "inPast": "เวลาที่เลือกผ่านไปแล้ว",
    "invalidKey": "รหัสข้อความไม่ถูกต้อง",
    "invalidValue": "ข้อความแปลไม่ถูกต้อง",
    "tooMany": "รายการมากเกินไป",
    "mustConfirm": "ต้องยืนยัน",
    "eyeSideMismatch": "ข้างตาไม่ตรงกับการตรวจ",
    "beforeStart": "ต้องหลังวันเริ่ม",
    "invalidUrl": "กรุณาใส่ลิงก์ที่ถูกต้อง",
    "exceedsOutstanding": "มากกว่าจำนวนที่ค้างอยู่",
    "expired": "หมดอายุแล้ว",
    "exceedsAvailable": "มากกว่าที่มีอยู่",
    "insufficient": "ไม่เพียงพอ",
    "duplicate": "ซ้ำกัน",
    "min": "น้อยเกินไป",
    "max": "มากเกินไป",
    "notDiscountable": "ค่าธรรมเนียมนี้ลดไม่ได้",
    "belowMin": "ต้องไม่ต่ำกว่าขั้นต่ำ",
    "inFuture": "ต้องไม่เป็นเวลาในอนาคต",
    "tooOld": "ย้อนหลังนานเกินไป (ไม่เกิน 30 วัน)",
    "beforeAdmission": "ต้องไม่ก่อนเวลารับเข้าหรือการย้ายเตียงครั้งล่าสุด",
    "httpsRequired": "ระบบจริงต้องใช้ https",
    "notFound": "ไม่พบ",
    "notAllowed": "ไม่อนุญาตที่นี่",
    "platformOnly": "สิทธิ์ระดับแพลตฟอร์มมีได้เฉพาะผู้ดูแลสูงสุด",
    "disabilityAlone": "ประเภทนี้เลือกร่วมกับประเภทอื่นไม่ได้",
    "disabilityOneSubtype": "เลือกประเภทย่อยได้เพียงข้อเดียว",
    "tooDeep": "มีหลายระดับเกินไป"
  },
  "enums": {
    "sex": {
      "MALE": "ชาย",
      "FEMALE": "หญิง",
      "OTHER": "อื่น ๆ",
      "UNKNOWN": "ไม่ทราบ"
    },
    "maritalStatus": {
      "SINGLE": "โสด",
      "MARRIED": "สมรส",
      "DIVORCED": "หย่าร้าง",
      "WIDOWED": "หม้าย",
      "SEPARATED": "แยกกันอยู่",
      "UNKNOWN": "ไม่ทราบ"
    },
    "patientStatus": {
      "ACTIVE": "ใช้งาน",
      "INACTIVE": "ไม่ใช้งาน",
      "DECEASED": "เสียชีวิต",
      "MERGED": "รวมเวชระเบียนแล้ว"
    },
    "appointmentStatus": {
      "BOOKED": "จองแล้ว",
      "CONFIRMED": "ยืนยันแล้ว",
      "CHECKED_IN": "ลงทะเบียนมาถึง",
      "IN_PROGRESS": "กำลังตรวจ",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก",
      "NO_SHOW": "ไม่มาตามนัด"
    },
    "encounterStatus": {
      "PLANNED": "วางแผน",
      "IN_PROGRESS": "กำลังดำเนินการ",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "encounterType": {
      "OPD": "ผู้ป่วยนอก",
      "IPD": "ผู้ป่วยใน",
      "EMERGENCY": "ฉุกเฉิน",
      "TELEMEDICINE": "การแพทย์ทางไกล",
      "HOME_VISIT": "เยี่ยมบ้าน"
    },
    "ticketStatus": {
      "WAITING": "รอ",
      "CALLED": "เรียกแล้ว",
      "SERVING": "กำลังให้บริการ",
      "SERVED": "ให้บริการแล้ว",
      "SKIPPED": "ข้าม",
      "CANCELLED": "ยกเลิก",
      "TRANSFERRED": "ส่งต่อแล้ว"
    },
    "queuePriority": {
      "NORMAL": "ปกติ",
      "URGENT": "ด่วน",
      "EMERGENCY": "ฉุกเฉิน",
      "PRIORITY": "สิทธิพิเศษ"
    },
    "labPriority": {
      "ROUTINE": "ปกติ",
      "URGENT": "ด่วน",
      "STAT": "ด่วนที่สุด"
    },
    "labOrderStatus": {
      "ORDERED": "สั่งแล้ว",
      "COLLECTED": "เก็บสิ่งส่งตรวจแล้ว",
      "IN_PROGRESS": "กำลังตรวจวิเคราะห์",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "labItemStatus": {
      "ORDERED": "สั่งแล้ว",
      "RESULTED": "มีผลแล้ว",
      "VERIFIED": "ยืนยันแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "resultStatus": {
      "PRELIMINARY": "ผลเบื้องต้น",
      "VERIFIED": "ยืนยันแล้ว",
      "CORRECTED": "แก้ไขแล้ว"
    },
    "resultFlag": {
      "N": "ปกติ",
      "L": "ต่ำ",
      "H": "สูง",
      "LL": "ต่ำวิกฤต",
      "HH": "สูงวิกฤต",
      "A": "ผิดปกติ"
    },
    "prescriptionStatus": {
      "ISSUED": "ออกใบสั่งแล้ว",
      "PARTIALLY_DISPENSED": "จ่ายยาบางส่วน",
      "DISPENSED": "จ่ายยาแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "invoiceStatus": {
      "DRAFT": "ฉบับร่าง",
      "ISSUED": "ยังไม่ชำระ",
      "PARTIALLY_PAID": "ชำระบางส่วน",
      "PAID": "ชำระแล้ว",
      "VOID": "ยกเลิก"
    },
    "paymentStatus": {
      "PENDING": "รอดำเนินการ",
      "COMPLETED": "สำเร็จ",
      "FAILED": "ล้มเหลว",
      "REFUNDED": "คืนเงินแล้ว"
    },
    "paymentMethod": {
      "CASH": "เงินสด",
      "CARD": "บัตร",
      "BANK_TRANSFER": "โอนผ่านธนาคาร",
      "QR": "ชำระผ่าน QR",
      "MOBILE_MONEY": "กระเป๋าเงินมือถือ",
      "INSURANCE": "ประกัน"
    },
    "allergySeverity": {
      "MILD": "เล็กน้อย",
      "MODERATE": "ปานกลาง",
      "SEVERE": "รุนแรง",
      "LIFE_THREATENING": "อันตรายถึงชีวิต"
    },
    "allergyStatus": {
      "ACTIVE": "ยังมีอยู่",
      "INACTIVE": "ไม่มีแล้ว",
      "RESOLVED": "หายแล้ว",
      "ENTERED_IN_ERROR": "บันทึกผิดพลาด"
    },
    "alertSeverity": {
      "INFO": "ข้อมูล",
      "WARNING": "คำเตือน",
      "CRITICAL": "วิกฤต"
    },
    "noteType": {
      "SOAP": "SOAP",
      "PROGRESS": "ความก้าวหน้า",
      "ADMISSION": "รับเข้ารักษา",
      "DISCHARGE": "จำหน่าย",
      "NURSING": "การพยาบาล",
      "CONSULT": "ปรึกษา",
      "PROCEDURE": "หัตถการ"
    },
    "noteStatus": {
      "DRAFT": "ฉบับร่าง",
      "SIGNED": "ลงนามแล้ว",
      "AMENDED": "ถูกแก้ไขเพิ่มเติม"
    },
    "diagnosisType": {
      "PRIMARY": "หลัก",
      "SECONDARY": "รอง",
      "ADMITTING": "แรกรับ",
      "DISCHARGE": "จำหน่าย",
      "DIFFERENTIAL": "วินิจฉัยแยกโรค"
    },
    "verificationStatus": {
      "PROVISIONAL": "เบื้องต้น",
      "CONFIRMED": "ยืนยันแล้ว",
      "REFUTED": "ตัดออก",
      "ENTERED_IN_ERROR": "บันทึกผิดพลาด"
    },
    "departmentType": {
      "CLINICAL": "คลินิก",
      "DIAGNOSTIC": "วินิจฉัย",
      "SUPPORT": "สนับสนุน",
      "ADMINISTRATIVE": "บริหาร"
    },
    "userStatus": {
      "ACTIVE": "ใช้งาน",
      "LOCKED": "ถูกล็อก",
      "DISABLED": "ปิดใช้งาน"
    },
    "role": {
      "SUPER_ADMIN": "ผู้ดูแลระบบสูงสุด",
      "HOSPITAL_ADMIN": "ผู้ดูแลโรงพยาบาล",
      "DOCTOR": "แพทย์",
      "NURSE": "พยาบาล",
      "RECEPTIONIST": "เจ้าหน้าที่เวชระเบียน",
      "PHARMACIST": "เภสัชกร",
      "LAB_TECHNICIAN": "เจ้าหน้าที่ห้องแล็บ",
      "CASHIER": "เจ้าหน้าที่การเงิน",
      "OPTOMETRIST": "นักทัศนมาตร",
      "INVENTORY_MANAGER": "ผู้จัดการคลัง",
      "PROCUREMENT_APPROVER": "ผู้อนุมัติการจัดซื้อ",
      "IMAGING_TECHNICIAN": "นักรังสีเทคนิค",
      "ACCOUNTANT": "เจ้าหน้าที่การเงิน",
      "POS_MANAGER": "ผู้จัดการร้านขายยา",
      "REPORTING_OFFICER": "เจ้าหน้าที่รายงานระดับชาติ",
      "REPORTING_APPROVER": "ผู้อนุมัติรายงาน",
      "SYSTEM_ADMIN": "ผู้ดูแลระบบ",
      "HOSPITAL_DIRECTOR": "ผู้อำนวยการโรงพยาบาล",
      "MEDICAL_DIRECTOR": "ผู้อำนวยการฝ่ายการแพทย์",
      "OPHTHALMOLOGIST": "จักษุแพทย์",
      "OPHTHALMIC_SURGEON": "จักษุศัลยแพทย์",
      "OPHTHALMIC_NURSE": "พยาบาลจักษุ",
      "DIAGNOSTIC_TECHNICIAN": "นักเทคนิคการตรวจวินิจฉัย",
      "MEDICAL_RECORDS_OFFICER": "เจ้าหน้าที่เวชระเบียน",
      "AUDITOR": "ผู้ตรวจสอบ",
      "QUEUE_DEVICE": "อุปกรณ์ตู้บริการ / จอแสดง"
    },
    "medicationOrderStatus": {
      "ACTIVE": "รอจ่าย",
      "COMPLETED": "จ่ายแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "eyeExamStatus": {
      "DRAFT": "ร่าง",
      "IN_PROGRESS": "กำลังตรวจ",
      "SIGNED": "ลงนามแล้ว",
      "AMENDED": "ถูกแก้ไขแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "surgeryStatus": {
      "PLANNED": "วางแผนแล้ว",
      "CONFIRMED": "ยืนยันรายการตรวจแล้ว",
      "IN_PROGRESS": "กำลังผ่าตัด",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "followUpStatus": {
      "SCHEDULED": "นัดแล้ว",
      "COMPLETED": "เสร็จ",
      "MISSED": "ไม่มา",
      "CANCELLED": "ยกเลิก"
    },
    "eyeMedStatus": {
      "ACTIVE": "กำลังใช้",
      "COMPLETED": "ครบกำหนด",
      "STOPPED": "หยุดแล้ว"
    },
    "carePlanStatus": {
      "ACTIVE": "กำลังดำเนินการ",
      "COMPLETED": "เสร็จสิ้น",
      "STOPPED": "หยุดแล้ว"
    },
    "portalStatus": {
      "ACTIVE": "แอปใช้งานได้",
      "DISABLED": "แอปถูกปิด"
    },
    "portalVerification": {
      "VERIFIED": "ยืนยันตัวตนแล้ว",
      "PENDING_VERIFICATION": "รอตรวจบัตร"
    },
    "queueStatus": {
      "OPEN": "เปิด",
      "PAUSED": "หยุดรับบัตรผ่านแอป",
      "CLOSED": "ปิด"
    },
    "inventoryItemType": {
      "DRUG": "ยา",
      "SUPPLY": "เวชภัณฑ์",
      "EQUIPMENT": "เครื่องมือ",
      "DEVICE": "อุปกรณ์การแพทย์ (ขาย)"
    },
    "stockStatus": {
      "OUT": "หมด",
      "LOW": "ใกล้หมด",
      "OK": "เพียงพอ",
      "OVER": "เกิน",
      "ASSET": "รายเครื่อง",
      "EXPIRING": "ใกล้หมดอายุ ≤ 90 วัน"
    },
    "expiryStatus": {
      "EXPIRED": "หมดอายุ",
      "EXPIRING": "ใกล้หมดอายุ"
    },
    "lotStatus": {
      "AVAILABLE": "พร้อมใช้",
      "QUARANTINE": "กักไว้"
    },
    "movementType": {
      "OPENING": "ยอดยกมา",
      "RECEIPT": "รับสินค้า",
      "DISPENSE": "จ่ายยาตามใบสั่ง",
      "ISSUE": "เบิกให้แผนก",
      "TRANSFER_OUT": "โอนออก",
      "TRANSFER_IN": "โอนเข้า",
      "ADJUSTMENT_IN": "ปรับเพิ่ม",
      "ADJUSTMENT_OUT": "ปรับลด",
      "WRITE_OFF": "ตัดจำหน่าย",
      "RETURN_TO_SUPPLIER": "คืนผู้จำหน่าย",
      "SALE": "ขายหน้าร้าน",
      "SALE_RETURN": "รับคืนจากการขาย"
    },
    "adjustmentReason": {
      "OPENING_BALANCE": "ยอดยกมา",
      "COUNT_CORRECTION": "แก้ไขจากการตรวจนับ",
      "DONATION": "ได้รับบริจาค",
      "FOUND": "พบเพิ่ม",
      "EXPIRED": "หมดอายุ",
      "DAMAGED": "ชำรุดเสียหาย",
      "LOST": "สูญหาย",
      "RECALLED": "ถูกเรียกคืน",
      "DEFECTIVE": "บกพร่อง",
      "OTHER": "อื่นๆ"
    },
    "prStatus": {
      "DRAFT": "ฉบับร่าง",
      "SUBMITTED": "รออนุมัติ",
      "APPROVED": "อนุมัติแล้ว",
      "REJECTED": "ไม่อนุมัติ",
      "ORDERED": "สั่งซื้อแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "prPriority": {
      "NORMAL": "ปกติ",
      "URGENT": "ด่วน"
    },
    "poStatus": {
      "DRAFT": "ฉบับร่าง",
      "APPROVED": "อนุมัติแล้ว",
      "SENT": "ส่งผู้จำหน่ายแล้ว",
      "PARTIALLY_RECEIVED": "รับแล้วบางส่วน",
      "RECEIVED": "รับครบแล้ว",
      "CLOSED": "ปิดแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "storeType": {
      "MAIN": "คลังกลาง",
      "PHARMACY": "ห้องยา",
      "WARD": "คลังหอผู้ป่วย",
      "CLINIC": "คลังคลินิก",
      "POS": "จุดขาย POS"
    },
    "assetStatus": {
      "IN_SERVICE": "ใช้งานได้",
      "UNDER_MAINTENANCE": "กำลังซ่อมบำรุง",
      "OUT_OF_SERVICE": "ใช้งานไม่ได้",
      "DISPOSED": "จำหน่ายแล้ว"
    },
    "assetEvent": {
      "MAINTENANCE": "บำรุงรักษาเชิงป้องกัน",
      "CALIBRATION": "สอบเทียบ",
      "INSPECTION": "ตรวจสภาพ",
      "REPAIR": "ซ่อม",
      "STATUS_CHANGE": "เปลี่ยนสถานะ",
      "TRANSFER": "ย้าย"
    },
    "maintenanceStatus": {
      "OK": "ตามกำหนด",
      "DUE": "ถึงกำหนด ≤ 30 วัน",
      "OVERDUE": "เลยกำหนด",
      "NONE": "—"
    },
    "stockUnit": {
      "TABLET": "เม็ด",
      "CAPSULE": "แคปซูล",
      "BOTTLE": "ขวด",
      "VIAL": "ไวอัล",
      "AMPOULE": "แอมพูล",
      "SACHET": "ซอง",
      "TUBE": "หลอด",
      "INHALER": "ยาพ่น",
      "PIECE": "ชิ้น",
      "BOX": "กล่อง",
      "PACK": "แพ็ค",
      "ROLL": "ม้วน",
      "SYRINGE": "หลอดฉีด",
      "SET": "ชุด",
      "UNIT": "หน่วย"
    },
    "bedStatus": {
      "AVAILABLE": "ว่าง",
      "OCCUPIED": "มีผู้ป่วย",
      "CLEANING": "กำลังทำความสะอาด",
      "RESERVED": "จองแล้ว",
      "OUT_OF_SERVICE": "งดใช้งาน"
    },
    "roomType": {
      "STANDARD": "ห้องรวม",
      "PRIVATE": "ห้องพิเศษ",
      "VIP": "VIP",
      "ICU": "ห้องไอซียู",
      "OBSERVATION": "ห้องสังเกตอาการ",
      "ISOLATION": "ห้องแยกโรค"
    },
    "wardType": {
      "GENERAL": "ทั่วไป",
      "SURGICAL": "ศัลยกรรม",
      "PEDIATRIC": "เด็ก",
      "MATERNITY": "สูติกรรม",
      "ICU": "ไอซียู",
      "OBSERVATION": "สังเกตอาการ",
      "ISOLATION": "แยกโรค",
      "PRIVATE": "ห้องพิเศษ"
    },
    "bedType": {
      "STANDARD": "มาตรฐาน",
      "ELECTRIC": "เตียงไฟฟ้า",
      "ICU": "ไอซียู",
      "PEDIATRIC": "เด็ก",
      "CRIB": "เปลเด็ก"
    },
    "admissionType": {
      "EMERGENCY": "ฉุกเฉิน",
      "ELECTIVE": "นัดล่วงหน้า",
      "TRANSFER_IN": "รับส่งต่อ",
      "DAY_CASE": "ผู้ป่วยรายวัน",
      "MATERNITY": "คลอดบุตร"
    },
    "admissionStatus": {
      "ADMITTED": "กำลังรักษา",
      "DISCHARGED": "จำหน่ายแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "dischargeType": {
      "HOME": "กลับบ้าน",
      "REFERRED": "ส่งต่อ",
      "AGAINST_ADVICE": "ไม่สมัครใจอยู่",
      "TRANSFERRED": "ย้ายโรงพยาบาล",
      "DECEASED": "เสียชีวิต"
    },
    "stayReason": {
      "ADMISSION": "รับเข้า",
      "TRANSFER": "ย้ายเตียง"
    },
    "serviceCategory": {
      "XRAY": "เอกซเรย์",
      "CT": "ซีทีสแกน",
      "MRI": "เอ็มอาร์ไอ",
      "ULTRASOUND": "อัลตราซาวด์",
      "ECG": "คลื่นไฟฟ้าหัวใจ",
      "ECHO": "อัลตราซาวด์หัวใจ",
      "ENDOSCOPY": "ส่องกล้อง",
      "PHYSIOTHERAPY": "กายภาพบำบัด",
      "DENTAL": "ทันตกรรม",
      "PROCEDURE": "หัตถการ",
      "OTHER": "อื่นๆ"
    },
    "serviceOrderStatus": {
      "ORDERED": "สั่งแล้ว",
      "IN_PROGRESS": "กำลังดำเนินการ",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "serviceItemStatus": {
      "ORDERED": "รอดำเนินการ",
      "IN_PROGRESS": "กำลังทำ",
      "REPORTED": "รายงานแล้ว",
      "VERIFIED": "ยืนยันแล้ว",
      "CANCELLED": "ยกเลิก"
    },
    "saleStatus": {
      "COMPLETED": "ชำระแล้ว",
      "PARTIALLY_RETURNED": "คืนบางส่วน",
      "RETURNED": "คืนแล้ว",
      "VOIDED": "ยกเลิกการขาย"
    },
    "stockDocType": {
      "RECEIPT": "รับสินค้า",
      "OPENING": "ยอดยกมา",
      "ADJUSTMENT_IN": "ปรับเพิ่ม",
      "ISSUE": "ใบเบิก",
      "TRANSFER": "โอนย้าย",
      "ADJUSTMENT_OUT": "ปรับลด",
      "WRITE_OFF": "ตัดจำหน่าย",
      "RETURN_TO_SUPPLIER": "คืนผู้จำหน่าย"
    },
    "stockDocStatus": {
      "DRAFT": "ร่าง",
      "SUBMITTED": "รอตรวจสอบ",
      "POSTED": "ลงบัญชีแล้ว",
      "REJECTED": "ถูกปฏิเสธ",
      "CANCELLED": "ยกเลิก",
      "IN_TRANSIT": "ระหว่างขนส่ง"
    },
    "expenseCategory": {
      "SUPPLIES": "วัสดุสิ้นเปลือง",
      "UTILITIES": "ค่าไฟและน้ำ",
      "SALARIES": "เงินเดือน",
      "MAINTENANCE": "ซ่อมบำรุง",
      "RENT": "ค่าเช่า",
      "TRANSPORT": "ขนส่ง",
      "MARKETING": "การตลาด",
      "TRAINING": "ฝึกอบรม",
      "TAXES": "ภาษีและค่าธรรมเนียม",
      "OTHER": "อื่นๆ"
    },
    "expenseStatus": {
      "SUBMITTED": "รออนุมัติ",
      "APPROVED": "อนุมัติแล้ว",
      "REJECTED": "ถูกปฏิเสธ",
      "CANCELLED": "ยกเลิก"
    },
    "cashSessionStatus": {
      "OPEN": "เปิดอยู่",
      "CLOSED": "ปิดแล้ว – รอตรวจ",
      "VERIFIED": "ตรวจแล้ว"
    },
    "priceType": {
      "CHARGE_ITEM": "ค่าธรรมเนียม",
      "SERVICE": "บริการพิเศษ",
      "MEDICATION": "ยา",
      "LAB_TEST": "การตรวจแล็บ",
      "ROOM": "ค่าเตียง",
      "INVENTORY_ITEM": "ราคาแนะนำจากคลัง",
      "POS_PRODUCT": "ร้านขายยา POS"
    },
    "priceStatus": {
      "ACTIVE": "ใช้งาน",
      "INACTIVE": "ไม่ใช้งาน",
      "DISCONTINUED": "เลิกจำหน่าย",
      "NOT_FOR_SALE": "ไม่ขาย"
    },
    "discountType": {
      "AMOUNT": "จำนวนเงิน",
      "PERCENT": "เปอร์เซ็นต์"
    },
    "plSection": {
      "REVENUE": "รายได้",
      "COST": "ต้นทุนสินค้า",
      "EXPENSES": "ค่าใช้จ่าย",
      "RESULT": "ผลประกอบการ"
    },
    "plLine": {
      "INVOICES": "บิลผู้ป่วย",
      "POS_SALES": "ขายหน้าร้าน",
      "REFUNDS": "คืนเงิน",
      "TOTAL_REVENUE": "รายได้รวม",
      "COST_OF_GOODS": "ยาและเวชภัณฑ์ที่ใช้",
      "GROSS_PROFIT": "กำไรขั้นต้น",
      "TOTAL_EXPENSES": "ค่าใช้จ่ายรวม",
      "NET_PROFIT": "กำไรสุทธิ"
    },
    "posLevel": {
      "OK": "เพียงพอ",
      "LOW": "ใกล้หมด",
      "OUT": "หมด"
    },
    "posProductStatus": {
      "PUBLISHED": "แสดงที่ POS",
      "HIDDEN": "ซ่อน"
    },
    "outletStatus": {
      "ACTIVE": "ใช้งาน",
      "INACTIVE": "ไม่ใช้งาน"
    },
    "refillStatus": {
      "DRAFT": "ฉบับร่าง",
      "SUBMITTED": "รอคลัง",
      "PREPARING": "กำลังจัดเตรียม",
      "IN_TRANSIT": "กำลังจัดส่ง",
      "RECEIVED": "รับแล้ว",
      "REJECTED": "ถูกปฏิเสธ",
      "CANCELLED": "ยกเลิก"
    },
    "patientTitle": {
      "MR": "นาย (ທ້າວ)",
      "MRS": "นาง (ນາງ)",
      "MISS": "นางสาว (ນາງສາວ)",
      "BOY": "เด็กชาย (ເດັກຊາຍ)",
      "GIRL": "เด็กหญิง (ເດັກຍິງ)",
      "DR": "ดร. (ດຣ.)",
      "MONK": "พระ (ພຣະ)",
      "NOVICE": "สามเณร (ສາມະເນນ)",
      "NUN": "แม่ชี (ແມ່ຂາວ)"
    },
    "reporting": {
      "ACHIEVED": "บรรลุ",
      "WARNING": "เตือน",
      "MISSED": "ไม่บรรลุ",
      "INSUFFICIENT_DATA": "ข้อมูลไม่เพียงพอ",
      "NOT_APPLICABLE": "ไม่มีเป้าหมาย",
      "PENDING_REVIEW": "รอทบทวน",
      "OK": "ปกติ",
      "INCOMPLETE": "ไม่ครบ",
      "INVALID": "ไม่ถูกต้อง",
      "DRAFT": "ร่าง",
      "VALIDATED": "ตรวจสอบแล้ว",
      "APPROVED": "อนุมัติแล้ว",
      "SUPERSEDED": "ถูกแทนที่",
      "INVALIDATED": "ถูกยกเลิก",
      "ACTIVE": "ใช้งาน",
      "RETIRED": "เลิกใช้",
      "QUEUED": "รอส่ง",
      "SUBMITTING": "กำลังส่ง",
      "ACCEPTED": "รับแล้ว",
      "PARTIALLY_ACCEPTED": "รับบางส่วน",
      "REJECTED": "ถูกปฏิเสธ",
      "RETRY_PENDING": "รอส่งใหม่",
      "RECONCILIATION_REQUIRED": "ต้องตรวจเทียบ",
      "CANCELLED": "ยกเลิก",
      "PENDING": "รอ",
      "IGNORED": "ถูกข้าม"
    },
    "kpiCategory": {
      "OPERATIONS": "การบริการ",
      "CLINICAL": "คลินิก",
      "SURGERY": "การผ่าตัด",
      "EYE_HEALTH": "สุขภาพตา",
      "EPIDEMIOLOGY": "ระบาดวิทยา",
      "INPATIENT": "ผู้ป่วยใน",
      "SUPPLIES": "พัสดุ",
      "DATA_QUALITY": "คุณภาพข้อมูล",
      "STAFF": "บุคลากร"
    },
    "kpiUnit": {
      "COUNT": "จำนวน",
      "PERCENT": "เปอร์เซ็นต์",
      "MINUTES": "นาที",
      "DAYS": "วัน",
      "RATIO": "อัตราส่วน"
    },
    "kpiDirection": {
      "HIGHER_BETTER": "สูงยิ่งดี",
      "LOWER_BETTER": "ต่ำยิ่งดี",
      "INFO": "เพื่อข้อมูล"
    },
    "dimension": {
      "SEX": "เพศ",
      "AGE_BAND": "กลุ่มอายุ",
      "MALE": "ชาย",
      "FEMALE": "หญิง",
      "AGE_0_14": "0–14 ปี",
      "AGE_15_49": "15–49 ปี",
      "AGE_50P": "50 ปีขึ้นไป"
    },
    "dhis2Env": {
      "MOCK": "จำลอง",
      "STAGING": "ทดสอบ",
      "PRODUCTION": "ระบบจริง"
    },
    "mappingType": {
      "ORG_UNIT": "หน่วยงาน",
      "DATA_SET": "ชุดข้อมูล",
      "DATA_ELEMENT": "องค์ประกอบข้อมูล",
      "CATEGORY_OPTION": "ตัวเลือกหมวด"
    },
    "valueTransform": {
      "NONE": "ตามที่คำนวณ",
      "ROUND": "จำนวนเต็ม",
      "ONE_DECIMAL": "ทศนิยม 1 ตำแหน่ง"
    },
    "metadataKind": {
      "ORG_UNIT": "หน่วยงาน",
      "DATA_SET": "ชุดข้อมูล",
      "DATA_ELEMENT": "องค์ประกอบข้อมูล",
      "CATEGORY_OPTION_COMBO": "กลุ่มหมวด",
      "ATTRIBUTE_OPTION_COMBO": "กลุ่มคุณลักษณะ"
    },
    "tenantType": {
      "HEALTHCARE_GROUP": "กลุ่มสุขภาพ",
      "HOSPITAL": "โรงพยาบาล",
      "CLINIC": "คลินิก",
      "GOVERNMENT": "ภาครัฐ",
      "NGO": "องค์กรพัฒนาเอกชน"
    },
    "tenantStatus": {
      "ACTIVE": "ใช้งาน",
      "SUSPENDED": "ระงับ",
      "INACTIVE": "ปิดใช้"
    },
    "referralStatus": {
      "REQUESTED": "ขอส่งต่อ",
      "SENT": "ส่งแล้ว",
      "ACCEPTED": "รับแล้ว",
      "DECLINED": "ถูกปฏิเสธ",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก",
      "UNREACHABLE": "ติดต่อไม่ได้"
    },
    "referralDirection": {
      "OUT": "ส่งออก",
      "IN": "รับเข้า"
    },
    "referralPriority": {
      "ROUTINE": "ปกติ",
      "URGENT": "ด่วน",
      "EMERGENCY": "ฉุกเฉิน"
    },
    "referralTransport": {
      "SELF": "เดินทางเอง",
      "FAMILY": "กับครอบครัว",
      "AMBULANCE": "รถพยาบาลฉุกเฉิน",
      "HOSPITAL_VEHICLE": "รถโรงพยาบาล",
      "OTHER": "อื่นๆ"
    },
    "referralEvent": {
      "CREATED": "สร้าง",
      "UPDATED": "แก้ไข",
      "SENT": "ส่ง",
      "ACCEPTED": "รับ",
      "DECLINED": "ปฏิเสธ",
      "CONTACT_ATTEMPT": "ติดต่อ",
      "UNREACHABLE": "ติดต่อไม่ได้",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "contactResult": {
      "REACHED": "ติดต่อได้",
      "NO_ANSWER": "ไม่มีผู้รับสาย",
      "WRONG_NUMBER": "เบอร์ผิด",
      "LEFT_MESSAGE": "ฝากข้อความ"
    },
    "followUpPriority": {
      "ROUTINE": "ปกติ",
      "URGENT": "ด่วน"
    },
    "mergeStatus": {
      "REQUESTED": "รออนุมัติ",
      "APPROVED": "รวมแล้ว",
      "REJECTED": "ปฏิเสธ",
      "CANCELLED": "ยกเลิก"
    },
    "queuePriorityReason": {
      "ELDERLY": "ผู้สูงอายุ",
      "DISABILITY": "ผู้พิการ",
      "PREGNANT": "หญิงตั้งครรภ์",
      "CHILD": "เด็กเล็ก",
      "CLINICAL": "ทางคลินิก",
      "OTHER": "อื่น ๆ"
    },
    "queueStage": {
      "REGISTRATION": "ลงทะเบียน",
      "TRIAGE": "คัดกรอง",
      "EXAMINATION": "ตรวจ",
      "CONSULTATION": "พบแพทย์",
      "DIAGNOSTICS": "ตรวจวินิจฉัย",
      "SURGERY": "ผ่าตัด",
      "PHARMACY": "ห้องยา",
      "CASHIER": "การเงิน",
      "OTHER": "อื่น ๆ"
    },
    "queueSource": {
      "DESK": "เคาน์เตอร์",
      "APPOINTMENT": "เช็กอินนัดหมาย",
      "QR": "เช็กอินด้วย QR",
      "KIOSK": "ตู้บริการ",
      "MOBILE": "แอปผู้ป่วย"
    },
    "queueEvent": {
      "ISSUED": "ออกบัตรคิว",
      "CALLED": "เรียกแล้ว",
      "RECALLED": "เรียกซ้ำ",
      "SERVING": "เริ่มให้บริการ",
      "COMPLETED": "เสร็จสิ้น",
      "SKIPPED": "ข้าม (ไม่อยู่)",
      "REQUEUED": "กลับเข้าคิว",
      "RETURNED": "กลับไปรอ",
      "CANCELLED": "ยกเลิก",
      "TRANSFERRED": "ส่งต่อ",
      "PRIORITY_CHANGED": "เปลี่ยนลำดับความสำคัญ",
      "PATIENT_LINKED": "เชื่อมระเบียนผู้ป่วย"
    },
    "queueActor": {
      "STAFF": "เจ้าหน้าที่",
      "KIOSK": "ตู้บริการ",
      "PATIENT_APP": "แอปผู้ป่วย",
      "SYSTEM": "ระบบ"
    },
    "queueVisitStatus": {
      "ACTIVE": "อยู่ในโรงพยาบาล",
      "COMPLETED": "เสร็จสิ้น",
      "CANCELLED": "ยกเลิก"
    },
    "queueServiceStatus": {
      "ACTIVE": "ใช้งาน",
      "INACTIVE": "ไม่ใช้งาน"
    }
  },
  "dashboard": {
    "title": "แดชบอร์ด",
    "welcome": "สวัสดี {{name}}",
    "subtitle": "วันนี้ที่ {{hospital}}",
    "patientsTotal": "ผู้ป่วยที่ใช้งาน",
    "registeredToday": "ลงทะเบียนวันนี้",
    "appointmentsToday": "นัดหมายวันนี้",
    "queueWaiting": "รอในคิว",
    "avgWait": "เวลารอเฉลี่ย",
    "openEncounters": "การตรวจที่กำลังดำเนินการ",
    "pendingPrescriptions": "ใบสั่งยารอจ่าย",
    "pendingLabOrders": "คำสั่งตรวจแล็บที่รอ",
    "revenueToday": "รายได้วันนี้",
    "outstanding": "ยอดค้างชำระ",
    "encountersTrend": "การตรวจ · 7 วันที่ผ่านมา",
    "revenueTrend": "รายได้ · 7 วันที่ผ่านมา",
    "appointmentsByDepartment": "นัดหมายวันนี้แยกตามแผนก",
    "minutes": "{{value}} นาที",
    "noData": "ยังไม่มีข้อมูล",
    "quickActions": "ทางลัด"
  },
  "patients": {
    "title": "ผู้ป่วย",
    "register": "ลงทะเบียนผู้ป่วย",
    "searchPlaceholder": "ค้นหาด้วยชื่อ เลข HN เบอร์โทร หรือเลขบัตรประชาชน",
    "mrn": "HN",
    "name": "ชื่อ",
    "firstName": "ชื่อ",
    "middleName": "ชื่อกลาง",
    "lastName": "นามสกุล",
    "preferredName": "ชื่อเล่น",
    "dateOfBirth": "วันเกิด",
    "age": "อายุ",
    "sex": "เพศ",
    "bloodGroup": "กรุ๊ปเลือด",
    "maritalStatus": "สถานภาพ",
    "occupation": "อาชีพ",
    "nationality": "สัญชาติ",
    "phone": "เบอร์โทร",
    "email": "อีเมล",
    "address": "ที่อยู่",
    "emergencyContactName": "ผู้ติดต่อฉุกเฉิน",
    "emergencyContactPhone": "เบอร์ผู้ติดต่อฉุกเฉิน",
    "nationalId": "เลขบัตรประชาชน",
    "preferredLanguage": "ภาษาที่ต้องการ",
    "identifiers": "เอกสารประจำตัว",
    "identifierType": "ประเภทเอกสาร",
    "identifierValue": "เลขที่เอกสาร",
    "addIdentifier": "เพิ่มเอกสารประจำตัว",
    "registeredOn": "ลงทะเบียนเมื่อ",
    "sectionPersonal": "ข้อมูลส่วนตัว",
    "sectionContact": "การติดต่อ",
    "sectionEmergency": "ผู้ติดต่อฉุกเฉิน",
    "sectionIdentifiers": "เอกสารประจำตัว",
    "created": "ลงทะเบียนผู้ป่วย {{mrn}} แล้ว",
    "updated": "อัปเดตเวชระเบียนผู้ป่วยแล้ว",
    "editTitle": "แก้ไขข้อมูลผู้ป่วย",
    "duplicateTitle": "อาจเป็นผู้ป่วยซ้ำ",
    "duplicateMessage": "เวชระเบียนเหล่านี้มีข้อมูลคล้ายกัน เปิดดูหรือยืนยันว่าเป็นคนละคน",
    "duplicateConfirm": "เป็นคนละคน — ลงทะเบียนต่อ",
    "identifierMatchTitle": "เอกสารประจำตัวนี้ลงทะเบียนแล้ว",
    "matchReason": {
      "NAME_AND_BIRTH_DATE": "ชื่อและวันเกิดตรงกัน",
      "PHONE_AND_FIRST_NAME": "เบอร์โทรและชื่อตรงกัน"
    },
    "allergies": "การแพ้",
    "noKnownAllergies": "ไม่มีประวัติแพ้",
    "addAllergy": "เพิ่มการแพ้",
    "allergen": "สิ่งที่แพ้",
    "reaction": "อาการ",
    "severity": "ความรุนแรง",
    "onsetDate": "วันที่เริ่มมีอาการ",
    "alerts": "การแจ้งเตือนผู้ป่วย",
    "addAlert": "เพิ่มการแจ้งเตือน",
    "alertType": "ประเภทการแจ้งเตือน",
    "alertMessage": "ข้อความ",
    "tabOverview": "ภาพรวม",
    "tabEncounters": "การตรวจรักษา",
    "tabAppointments": "นัดหมาย",
    "tabPrescriptions": "ใบสั่งยา",
    "tabLabs": "ผลแล็บ",
    "tabInvoices": "ใบแจ้งหนี้",
    "newEncounter": "เริ่มการตรวจ",
    "bookAppointment": "จองนัดหมาย",
    "addToQueue": "เพิ่มเข้าคิว",
    "empty": "ไม่พบผู้ป่วยที่ตรงกับการค้นหา",
    "pickerPlaceholder": "ค้นหาผู้ป่วยด้วยชื่อหรือ HN",
    "sectionPhoto": "รูปถ่าย",
    "sectionAddress": "ที่อยู่",
    "province": "แขวง (จังหวัด)",
    "district": "เมือง (อำเภอ)",
    "subdistrict": "ตำบล",
    "village": "บ้าน (หมู่บ้าน)",
    "addressLine": "บ้านเลขที่ / ถนน",
    "addressLineHint": "ไม่บังคับ: บ้านเลขที่ หน่วย ถนน หรือจุดสังเกต",
    "chooseProvinceFirst": "เลือกแขวงก่อน",
    "chooseDistrictFirst": "เลือกเมืองก่อน",
    "noSubdistricts": "ยังไม่มีตำบล",
    "disability": "ความพิการ",
    "takePhoto": "ถ่ายรูป",
    "choosePhoto": "เลือกรูป",
    "undoPhoto": "เลิกทำ",
    "removePhoto": "ลบรูป",
    "photoHint": "JPEG, PNG หรือ WebP ระบบจะย่อขนาดรูปให้อัตโนมัติ",
    "photoInvalid": "ไฟล์นี้ไม่ใช่รูปภาพที่รองรับ",
    "nameTitle": "คำนำหน้า",
    "noTitle": "— ไม่มีคำนำหน้า —",
    "titleSuggested": "แนะนำตามเพศและอายุ",
    "disabilityDetails": "รายละเอียดความพิการ"
  },
  "appointments": {
    "title": "นัดหมาย",
    "book": "จองนัดหมาย",
    "date": "วันที่",
    "start": "เริ่ม",
    "end": "สิ้นสุด",
    "time": "เวลา",
    "practitioner": "แพทย์",
    "department": "แผนก",
    "type": "ประเภทการมา",
    "reason": "เหตุผลที่มา",
    "notes": "หมายเหตุ",
    "patient": "ผู้ป่วย",
    "anyPractitioner": "แพทย์ทั้งหมด",
    "anyDepartment": "ทุกแผนก",
    "checkIn": "ลงทะเบียนมาถึง",
    "confirm": "ยืนยัน",
    "cancel": "ยกเลิกนัดหมาย",
    "noShow": "ไม่มา",
    "startEncounter": "เริ่มการตรวจ",
    "openEncounter": "เปิดการตรวจ",
    "booked": "จองนัดหมาย {{number}} แล้ว",
    "checkedIn": "ลงทะเบียนแล้ว — บัตรคิว {{ticket}}",
    "cancelled": "ยกเลิกนัดหมายแล้ว",
    "empty": "ไม่มีนัดหมายในวันนี้",
    "priority": "ลำดับความสำคัญ",
    "number": "เลขที่"
  },
  "queue": {
    "title": "คิว",
    "department": "แผนก",
    "selectDepartment": "เลือกแผนก",
    "callNext": "เรียกคิวถัดไป",
    "counter": "ช่องบริการ / ห้อง",
    "waiting": "รอ",
    "inService": "เรียกแล้ว / กำลังให้บริการ",
    "served": "ให้บริการแล้ว",
    "ticket": "บัตรคิว",
    "issuedAt": "ออกบัตรเมื่อ",
    "recall": "เรียกอีกครั้ง",
    "startService": "เริ่มให้บริการ",
    "complete": "เสร็จสิ้น",
    "skip": "ข้าม",
    "requeue": "กลับเข้าคิว",
    "cancelTicket": "ยกเลิกบัตรคิว",
    "walkIn": "บัตรคิว Walk-in",
    "display": "หน้าจอแสดงคิว",
    "nowServing": "กำลังให้บริการ",
    "nextUp": "คิวถัดไป",
    "empty": "ไม่มีผู้รอ",
    "calling": "เรียกคิว {{ticket}}",
    "waitMinutes": "{{value}} นาที",
    "scanQr": "สแกน QR ผู้ป่วย",
    "estimatedWait": "เวลารอโดยประมาณ",
    "min": "นาที",
    "fromApp": "บัตรคิวจากแอป",
    "loadDetail": "{{counters}} ช่องบริการ · รอเฉลี่ย {{avg}} นาที · นานสุด {{longest}} นาที",
    "open": "เปิด",
    "pause": "หยุดแอป",
    "pauseHelp": "หยุดรับบัตรจากแอป โต๊ะยังออกบัตรได้",
    "close": "ปิด",
    "source": {
      "MOBILE": "จากแอปผู้ป่วย",
      "QR": "ลงทะเบียนด้วย QR",
      "KIOSK": "จากตู้บริการ"
    },
    "subtitle": "เรียก เรียกซ้ำ ข้าม ส่งต่อ และปิดบริการผู้ป่วย ที่จุดบริการของคุณ",
    "kioskOpen": "ตู้บริการ",
    "report": "เวลารอคอย",
    "servicePoint": "จุดบริการ",
    "selectService": "เลือกจุดบริการ",
    "allServices": "ทุกจุดบริการ",
    "stage": "ขั้นตอน",
    "priorityWaiting": "รอแบบสิทธิพิเศษ",
    "nobodyCalled": "ยังไม่มีการเรียก กด “เรียกคิวถัดไป”",
    "skipped": "ข้าม",
    "noSkipped": "ไม่มีหมายเลขที่ถูกข้าม",
    "done": "เสร็จแล้ว",
    "noneDone": "ยังไม่มีผู้ที่เสร็จสิ้น",
    "waitingTimes": "รายงานเวลารอคอย",
    "notRegistered": "ยังไม่ได้ลงทะเบียน",
    "assistanceRequested": "ขอความช่วยเหลือที่ตู้บริการ",
    "priorityRequested": "ขอสิทธิพิเศษ: {{reason}}",
    "hasDisability": "มีบันทึกความพิการ",
    "age": "{{value}} ปี",
    "sinceCalled": "เวลานับจากถูกเรียก / เริ่มบริการ",
    "waited": "รอ {{value}} นาที",
    "recalled": "เรียกซ้ำ {{value}} ครั้ง",
    "findOrRegister": "ค้นหาหรือลงทะเบียนผู้ป่วย",
    "openEncounter": "เปิดการตรวจ",
    "transfer": "ส่งต่อ",
    "backToQueue": "กลับไปรอ",
    "backToQueueHelp": "ให้ผู้ป่วยกลับไปรอ (เช่น รอยาหยอดตาออกฤทธิ์) โดยยังคงลำดับเดิม",
    "call": "เรียก",
    "callThis": "เรียกหมายเลขนี้ทันที (นอกลำดับ)",
    "priority": "ลำดับความสำคัญ",
    "cancelTitle": "ยกเลิกบัตรคิว {{ticket}}?",
    "cancelHelp": "หมายเลขนี้จะถูกปิดและผู้ป่วยออกจากคิว ข้อมูลยังคงอยู่ในประวัติคิว",
    "cancelReason": "เหตุผล",
    "transferredIn": "มาจากคิวอื่น",
    "setPriority": "ลำดับความสำคัญของ {{ticket}}",
    "priorityHelp": {
      "NORMAL": "ตามลำดับการมาถึง",
      "PRIORITY": "ผู้สูงอายุ ผู้พิการ หญิงตั้งครรภ์ เด็กเล็ก",
      "URGENT": "ทางคลินิก: ตรวจก่อนผู้อื่น",
      "EMERGENCY": "ทางคลินิก: ตรวจทันที"
    },
    "triageOnly": "ลำดับความเร่งด่วนและฉุกเฉินกำหนดโดยบุคลากรทางการแพทย์",
    "priorityReason": "เหตุผลของสิทธิพิเศษ",
    "note": "หมายเหตุ",
    "transferTitle": "ส่งต่อ {{ticket}}",
    "transferHelp": "ผู้ป่วยใช้หมายเลขเดิมและเข้าคิวที่เลือก",
    "registerFirst": "ผู้ป่วยรายนี้ยังไม่ได้ลงทะเบียน กรุณาลงทะเบียนหรือค้นหาผู้ป่วยก่อน ระหว่างนี้ส่งได้เฉพาะจุดลงทะเบียน",
    "waitingCount": "รอ {{value}} คน",
    "handoverNote": "หมายเหตุถึงจุดบริการถัดไป",
    "handoverNoteHint": "เช่น หยอดยาขยายม่านตาเวลา 10:15",
    "transferred": "ส่ง {{ticket}} ไปที่ {{service}} แล้ว",
    "linkPatientTitle": "ผู้ป่วยของบัตรคิว {{ticket}}",
    "linkPatientHelp": "ค้นหาระเบียนผู้ป่วย หรือลงทะเบียนผู้ป่วยใหม่ (เปิดแท็บใหม่) แล้วค้นหาที่นี่",
    "findPatient": "ผู้ป่วย",
    "registerNew": "ลงทะเบียนผู้ป่วยใหม่",
    "linkPatient": "เชื่อมกับบัตรคิว",
    "patientLinked": "เชื่อมผู้ป่วยกับบัตรคิวแล้ว",
    "history": "ประวัติคิว",
    "historyTitle": "ประวัติคิวของ {{ticket}}",
    "patient": "ผู้ป่วย",
    "visitStatus": "การมาโรงพยาบาล",
    "timeInHospital": "เวลาในโรงพยาบาล",
    "encounter": "การตรวจ",
    "noHistory": "ยังไม่มีประวัติ",
    "displaySetup": "ตั้งค่าจอแสดงนี้",
    "displaySetupHelp": "เลือกจุดบริการที่จอนี้แสดง ที่อยู่ของหน้าจอจะจำการเลือกไว้ ให้บุ๊กมาร์กในเบราว์เซอร์ของจอ",
    "openDisplay": "เปิดจอแสดง",
    "displayTitle": "คิว",
    "nowCalling": "กำลังเรียก",
    "pleaseWait": "กรุณารอหมายเลขของท่าน",
    "missed": "พลาดคิว: กรุณาติดต่อเคาน์เตอร์",
    "displayFooter": "หมายเลขของท่านใช้ตลอดการมาโรงพยาบาลครั้งนี้ กรุณาเก็บบัตรคิวไว้",
    "soundOn": "เปิดเสียงประกาศ",
    "soundOff": "ปิดเสียงประกาศ",
    "fullscreen": "เต็มจอ",
    "tapForSound": "แตะเพื่อเปิดเสียง",
    "announce": "หมายเลข {{ticket}} เชิญที่ {{counter}} {{service}}",
    "rep": {
      "title": "เวลารอคิว",
      "subtitle": "เวลารอและเวลาให้บริการจากประวัติคิว แยกตามจุดบริการ",
      "today": "วันนี้",
      "week": "7 วัน",
      "month": "30 วัน",
      "noData": "ไม่มีบัตรคิวในช่วงเวลานี้",
      "avgWait": "เวลารอเฉลี่ย",
      "medianWait": "เวลารอมัธยฐาน",
      "p90Wait": "90% ถูกเรียกภายใน",
      "p90Hint": "ผู้ป่วย 9 ใน 10 รอน้อยกว่านี้",
      "maxWait": "รอนานที่สุด",
      "waitHint": "นับจากเข้าคิวถึงการเรียกครั้งแรก",
      "avgService": "เวลาบริการเฉลี่ย",
      "avgVisit": "เวลาในโรงพยาบาลเฉลี่ย",
      "visitsCompleted": "เสร็จสิ้น {{value}} จาก {{total}} ครั้ง",
      "tickets": "บัตรคิว",
      "ticketsHint": "บริการแล้ว {{served}} · ส่งต่อ {{transferred}}",
      "missed": "ข้าม (ไม่อยู่)",
      "cancelled": "ยกเลิก {{value}}",
      "kiosk": "มาผ่านตู้บริการ",
      "kioskHint": "ลงทะเบียนที่เคาน์เตอร์ {{registered}} · ขอความช่วยเหลือ {{help}}",
      "byHour": "จำนวนผู้มาถึงตามชั่วโมง",
      "arrivals": "มาถึง {{value}} คน",
      "avgWaitShort": "รอเฉลี่ย {{value}} นาที",
      "bySourcePriority": "ตามช่องทางและลำดับความสำคัญ",
      "byService": "ตามจุดบริการ",
      "transferredOn": "ส่งต่อ",
      "byDay": "ตามวัน"
    },
    "kiosk": {
      "title": "เช็กอินด้วยตนเอง",
      "welcome": "ยินดีต้อนรับ วันนี้ให้เราช่วยอะไรคะ/ครับ?",
      "haveAppointment": "ฉันมีนัดวันนี้",
      "haveAppointmentHint": "เช็กอินและรับหมายเลขคิว",
      "registeredWalkIn": "ฉันเป็นผู้ป่วยเดิม ไม่มีนัด",
      "registeredWalkInHint": "รับหมายเลขคิวสำหรับบริการ",
      "newOrHelp": "ผู้ป่วยใหม่ หรือต้องการความช่วยเหลือ",
      "newOrHelpHint": "รับหมายเลขคิวสำหรับเคาน์เตอร์ลงทะเบียน",
      "emergencyNote": "กรณีฉุกเฉิน? กรุณาไปที่แผนกฉุกเฉินโดยตรงหรือแจ้งเจ้าหน้าที่",
      "identifyTitle": "ค้นหาระเบียนของท่าน",
      "mrnOrPhone": "เลขประจำตัวผู้ป่วย (HN) หรือเบอร์โทร",
      "birthDate": "วันเกิด",
      "day": "วัน",
      "month": "เดือน",
      "year": "ปี",
      "delete": "ลบ",
      "privacy": "เราใช้ข้อมูลนี้เพื่อค้นหาระเบียนของท่านเท่านั้น ไม่มีข้อมูลส่วนตัวแสดงบนหน้าจอ",
      "continue": "ถัดไป",
      "hello": "สวัสดี {{name}}",
      "noAppointment": "ไม่พบนัดหมายของท่านในวันนี้",
      "takeWalkIn": "รับหมายเลขคิวสำหรับบริการ",
      "checkIn": "เช็กอิน",
      "chooseService": "ท่านต้องการไปที่ใด?",
      "waitInfo": "รอ {{waiting}} คน · ประมาณ {{minutes}} นาที",
      "priorityQuestion": "ท่านต้องการบริการแบบสิทธิพิเศษหรือไม่?",
      "priorityHint": "เจ้าหน้าที่จะยืนยันสิทธิพิเศษเมื่อเรียกท่าน",
      "request": {
        "ELDERLY": "อายุ 60 ปีขึ้นไป",
        "DISABILITY": "ผู้พิการ",
        "PREGNANT": "หญิงตั้งครรภ์",
        "CHILD": "มากับเด็กเล็ก"
      },
      "notSure": "ไม่แน่ใจว่าจะไปที่ใด? รับหมายเลขคิวสำหรับเคาน์เตอร์ลงทะเบียน",
      "helpTitle": "เคาน์เตอร์ลงทะเบียน",
      "helpText": "เจ้าหน้าที่เคาน์เตอร์ลงทะเบียนจะลงทะเบียนหรือช่วยเหลือท่าน แล้วส่งท่านไปยังบริการที่ถูกต้อง",
      "newPatientTicket": "ฉันเป็นผู้ป่วยใหม่",
      "needHelpTicket": "ฉันต้องการความช่วยเหลือ",
      "registrationTicket": "รับหมายเลขคิวสำหรับเคาน์เตอร์ลงทะเบียน",
      "startOver": "เริ่มใหม่",
      "yourNumber": "หมายเลขคิวของท่าน",
      "ahead": "มี {{value}} คนก่อนท่าน · ประมาณ {{minutes}} นาที",
      "slipNote": "กรุณาดูหมายเลขของท่านบนจอ หมายเลขนี้ใช้ตลอดการมาโรงพยาบาลครั้งนี้",
      "slipRegistration": "กรุณารอจนกว่าหมายเลขของท่านจะถูกเรียกไปที่เคาน์เตอร์ลงทะเบียน",
      "alreadyQueued": "ท่านมีหมายเลขคิววันนี้แล้ว นี่คือหมายเลขเดิม",
      "print": "พิมพ์บัตรคิว",
      "done": "เสร็จสิ้น",
      "error": {
        "NOT_FOUND": "ไม่พบระเบียนของท่านด้วยข้อมูลนี้",
        "TOO_MANY_REQUESTS": "ลองหลายครั้งเกินไป กรุณาติดต่อเคาน์เตอร์ลงทะเบียน",
        "QUEUE_PAUSED": "การเช็กอินด้วยตนเองหยุดชั่วคราวสำหรับบริการนี้ กรุณาติดต่อเคาน์เตอร์",
        "QUEUE_CLOSED": "บริการนี้ปิดวันนี้ กรุณาติดต่อเคาน์เตอร์",
        "NOT_TODAY": "นัดหมายนี้ไม่ใช่วันนี้",
        "INVALID_TRANSITION": "นัดหมายนี้เช็กอินที่นี่ไม่ได้ กรุณาติดต่อเคาน์เตอร์",
        "NO_DEPARTMENT": "นัดหมายนี้เช็กอินที่นี่ไม่ได้ กรุณาติดต่อเคาน์เตอร์",
        "OTHER": "เกิดข้อผิดพลาด กรุณาติดต่อเคาน์เตอร์ลงทะเบียน"
      }
    }
  },
  "encounters": {
    "title": "การตรวจรักษา",
    "mine": "ผู้ป่วยของฉัน",
    "all": "ทั้งหมด",
    "today": "วันนี้",
    "number": "เลขที่การตรวจ",
    "type": "ประเภท",
    "startedAt": "เริ่มเมื่อ",
    "endedAt": "สิ้นสุดเมื่อ",
    "chiefComplaint": "อาการสำคัญ",
    "practitioner": "แพทย์",
    "department": "แผนก",
    "complete": "ปิดการตรวจ",
    "completeConfirm": "ปิดการตรวจนี้หรือไม่? บันทึกและคำสั่งจะแก้ไขไม่ได้อีก",
    "cancel": "ยกเลิกการตรวจ",
    "cancelReason": "เหตุผลที่ยกเลิก",
    "started": "เริ่มการตรวจ {{number}} แล้ว",
    "completed": "ปิดการตรวจแล้ว",
    "vitals": "สัญญาณชีพ",
    "recordVitals": "บันทึกสัญญาณชีพ",
    "temperature": "อุณหภูมิ",
    "heartRate": "อัตราการเต้นของหัวใจ",
    "respiratoryRate": "อัตราการหายใจ",
    "bloodPressure": "ความดันโลหิต",
    "systolic": "ความดันตัวบน",
    "diastolic": "ความดันตัวล่าง",
    "spo2": "SpO₂",
    "weight": "น้ำหนัก",
    "height": "ส่วนสูง",
    "bmi": "BMI",
    "painScore": "ระดับความปวด (0–10)",
    "recordedAt": "บันทึกเมื่อ",
    "recordedBy": "โดย",
    "unitCelsius": "°C",
    "unitBpm": "ครั้ง/นาที",
    "unitPerMin": "/นาที",
    "unitMmHg": "mmHg",
    "unitPercent": "%",
    "unitKg": "กก.",
    "unitCm": "ซม.",
    "diagnoses": "การวินิจฉัย",
    "addDiagnosis": "เพิ่มการวินิจฉัย",
    "diagnosisCode": "รหัส ICD-10",
    "diagnosisDescription": "รายละเอียด",
    "diagnosisType": "ประเภท",
    "verification": "การยืนยัน",
    "markEnteredInError": "ระบุว่าบันทึกผิดพลาด",
    "notes": "บันทึกทางการแพทย์",
    "newNote": "บันทึกใหม่",
    "noteType": "ประเภทบันทึก",
    "content": "เนื้อหา",
    "saveDraft": "บันทึกฉบับร่าง",
    "saveAndSign": "บันทึกและลงนาม",
    "sign": "ลงนาม",
    "amend": "แก้ไขเพิ่มเติม",
    "amendReason": "เหตุผลที่แก้ไข",
    "amendmentOf": "การแก้ไขเพิ่มเติมของบันทึกก่อนหน้า",
    "signedBy": "ลงนามโดย {{name}} · {{time}}",
    "draftBy": "ฉบับร่างโดย {{name}}",
    "prescriptions": "ใบสั่งยา",
    "newPrescription": "สั่งยาใหม่",
    "labOrders": "คำสั่งตรวจแล็บ",
    "newLabOrder": "สั่งตรวจแล็บ",
    "noVitals": "ยังไม่มีการบันทึกสัญญาณชีพ",
    "noDiagnoses": "ยังไม่มีการวินิจฉัย",
    "noNotes": "ยังไม่มีบันทึก",
    "noPrescriptions": "ไม่มีใบสั่งยา",
    "noLabOrders": "ไม่มีคำสั่งตรวจแล็บ",
    "closedBanner": "การตรวจนี้ {{status}} และอ่านได้อย่างเดียว",
    "start": "เริ่มการตรวจ",
    "empty": "ไม่พบการตรวจรักษา",
    "soapTemplate": "S (อาการ):\nO (ตรวจพบ):\nA (ประเมิน):\nP (แผนการรักษา):"
  },
  "pharmacy": {
    "title": "ห้องยา",
    "worklist": "รอจ่ายยา",
    "history": "ประวัติ",
    "catalog": "บัญชียา",
    "prescription": "ใบสั่งยา",
    "prescriptionNumber": "เลขที่ใบสั่งยา",
    "prescriber": "ผู้สั่งยา",
    "issuedAt": "ออกเมื่อ",
    "items": "รายการ",
    "medication": "ยา",
    "selectMedication": "ค้นหายา",
    "dose": "ขนาดยา",
    "doseUnit": "หน่วย",
    "frequency": "ความถี่",
    "route": "วิธีให้ยา",
    "duration": "ระยะเวลา",
    "quantity": "จำนวน",
    "instructions": "วิธีใช้",
    "addItem": "เพิ่มยา",
    "removeItem": "นำออก",
    "issue": "ลงนามและออกใบสั่ง",
    "issued": "ออกใบสั่งยา {{number}} แล้ว",
    "dispense": "จ่ายยา",
    "dispenseAll": "จ่ายยาที่เหลือทั้งหมด",
    "dispensed": "จ่ายยาแล้ว",
    "dispensedQty": "จ่ายแล้ว",
    "remaining": "คงเหลือ",
    "cancelPrescription": "ยกเลิกใบสั่งยา",
    "allergyWarningTitle": "คำเตือนการแพ้ยา",
    "allergyWarningBody": "{{medication}} ตรงกับประวัติการแพ้ “{{allergen}}” ({{severity}})",
    "overrideAndIssue": "ยืนยันและออกใบสั่ง",
    "patientAllergies": "ประวัติการแพ้ของผู้ป่วย",
    "genericName": "ชื่อสามัญ",
    "brandName": "ชื่อการค้า",
    "strength": "ความแรง",
    "dosageForm": "รูปแบบยา",
    "unitPrice": "ราคาต่อหน่วย",
    "manufacturer": "ผู้ผลิต",
    "newMedication": "เพิ่มยาใหม่",
    "editMedication": "แก้ไขข้อมูลยา",
    "empty": "ไม่มีใบสั่งยารอจ่าย"
  },
  "lab": {
    "title": "ห้องปฏิบัติการ",
    "worklist": "รายการรอตรวจ",
    "completed": "เสร็จสิ้นแล้ว",
    "order": "คำสั่งตรวจแล็บ",
    "orderNumber": "เลขที่คำสั่ง",
    "orderedBy": "สั่งโดย",
    "orderedAt": "สั่งเมื่อ",
    "priority": "ลำดับความสำคัญ",
    "tests": "รายการตรวจ",
    "selectTests": "เลือกรายการตรวจ",
    "clinicalNotes": "ข้อมูลทางคลินิก",
    "placeOrder": "ส่งคำสั่ง",
    "orderPlaced": "ส่งคำสั่งตรวจ {{number}} แล้ว",
    "collect": "เก็บสิ่งส่งตรวจ",
    "collected": "เก็บสิ่งส่งตรวจแล้ว",
    "specimen": "สิ่งส่งตรวจ",
    "result": "ผล",
    "value": "ค่า",
    "resultText": "ผล (ข้อความ)",
    "flag": "สัญลักษณ์",
    "unit": "หน่วย",
    "referenceRange": "ค่าอ้างอิง",
    "saveResult": "บันทึกผล",
    "verify": "ยืนยันผล",
    "verified": "ยืนยันผลแล้ว",
    "correct": "แก้ไขผล",
    "correctionReason": "เหตุผลการแก้ไข",
    "corrected": "แก้ไขผลแล้ว",
    "enteredBy": "บันทึกโดย",
    "verifiedBy": "ยืนยันโดย",
    "cancelOrder": "ยกเลิกคำสั่ง",
    "empty": "ไม่มีคำสั่งตรวจในรายการนี้",
    "category": "หมวด",
    "price": "ราคา",
    "turnaround": "ระยะเวลารายงานผล",
    "awaitingResult": "รอผล"
  },
  "billing": {
    "title": "ใบแจ้งหนี้และรับเงิน",
    "invoices": "ใบแจ้งหนี้",
    "newInvoice": "สร้างใบแจ้งหนี้",
    "invoice": "ใบแจ้งหนี้",
    "invoiceNumber": "เลขที่ใบแจ้งหนี้",
    "patient": "ผู้ป่วย",
    "encounter": "การตรวจ",
    "items": "รายการ",
    "description": "รายละเอียด",
    "quantity": "จำนวน",
    "unitPrice": "ราคาต่อหน่วย",
    "discount": "ส่วนลด",
    "tax": "ภาษี",
    "subtotal": "ยอดรวมย่อย",
    "total": "ยอดรวม",
    "paid": "ชำระแล้ว",
    "balance": "ยอดค้าง",
    "issuedAt": "ออกเมื่อ",
    "chargeItems": "บริการและค่าธรรมเนียม",
    "addCharge": "เพิ่มบริการ",
    "unbilledItems": "รายการที่ยังไม่เรียกเก็บจากการตรวจ",
    "includeUnbilled": "รวมยาและการตรวจแล็บที่ยังไม่เรียกเก็บ",
    "payments": "การชำระเงิน",
    "recordPayment": "บันทึกการชำระเงิน",
    "amount": "จำนวนเงิน",
    "method": "วิธีชำระ",
    "provider": "ผู้ให้บริการชำระเงิน",
    "reference": "เลขอ้างอิง",
    "paymentRecorded": "บันทึกการชำระเงินแล้ว",
    "payInFull": "ชำระเต็มจำนวน",
    "void": "ยกเลิกใบแจ้งหนี้",
    "voidReason": "เหตุผลที่ยกเลิก",
    "refund": "คืนเงิน",
    "refundReason": "เหตุผลที่คืนเงิน",
    "receipt": "ใบเสร็จรับเงิน",
    "printReceipt": "พิมพ์ใบเสร็จ",
    "created": "สร้างใบแจ้งหนี้ {{number}} แล้ว",
    "pendingConfirmation": "รอการยืนยันจากผู้ให้บริการ",
    "outstanding": "ค้างชำระ",
    "thankYou": "ขอบคุณ ขอให้หายป่วยไว ๆ",
    "selectEncounter": "การตรวจ (ไม่บังคับ)",
    "empty": "ไม่พบใบแจ้งหนี้",
    "receivedBy": "รับเงินโดย",
    "applyDiscount": "ส่วนลด",
    "discountHint": "ส่วนลดจะถูกบันทึกพร้อมชื่อของคุณและเหตุผล และต้องมีสิทธิ์ให้ส่วนลด",
    "discountPreview": "ส่วนลด {{discount}} · ยอดใหม่ {{total}}",
    "discountSaved": "บันทึกส่วนลดแล้ว",
    "lineDiscounts": "ส่วนลดรายการ",
    "noDiscount": "ไม่มีส่วนลด",
    "billDiscount": "ส่วนลดทั้งบิล"
  },
  "admin": {
    "usersTitle": "ผู้ใช้",
    "newUser": "เพิ่มผู้ใช้",
    "editUser": "แก้ไขผู้ใช้",
    "username": "ชื่อผู้ใช้",
    "fullName": "ชื่อ-นามสกุล",
    "email": "อีเมล",
    "phone": "เบอร์โทร",
    "roles": "บทบาท",
    "password": "รหัสผ่านเริ่มต้น",
    "resetPassword": "ตั้งรหัสผ่านใหม่",
    "newPassword": "รหัสผ่านใหม่",
    "disable": "ปิดใช้งาน",
    "enable": "เปิดใช้งาน",
    "lastLogin": "เข้าระบบล่าสุด",
    "locked": "ถูกล็อก",
    "userCreated": "สร้างผู้ใช้แล้ว",
    "isPractitioner": "ผู้ใช้นี้เป็นบุคลากรทางการแพทย์",
    "employeeCode": "รหัสพนักงาน",
    "specialty": "ความเชี่ยวชาญ",
    "licenseNumber": "เลขที่ใบอนุญาต",
    "departmentsTitle": "แผนก",
    "newDepartment": "เพิ่มแผนก",
    "departmentType": "ประเภทแผนก",
    "practitionersTitle": "แพทย์และบุคลากร",
    "newPractitioner": "เพิ่มบุคลากร",
    "displayName": "ชื่อที่แสดง",
    "department": "แผนก",
    "hospitalTitle": "ตั้งค่าโรงพยาบาล",
    "hospitalName": "ชื่อโรงพยาบาล",
    "registrationNumber": "เลขทะเบียน",
    "timezone": "เขตเวลา",
    "currency": "สกุลเงิน",
    "defaultLanguage": "ภาษาเริ่มต้น",
    "organization": "องค์กร",
    "auditTitle": "บันทึกการตรวจสอบ",
    "auditAction": "การกระทำ",
    "auditResource": "ข้อมูล",
    "auditActor": "ผู้ใช้",
    "auditTime": "เวลา",
    "auditIp": "ที่อยู่ IP",
    "auditChanges": "การเปลี่ยนแปลง",
    "auditBefore": "ก่อน",
    "auditAfter": "หลัง",
    "auditResourceId": "รหัสข้อมูล",
    "hospitalDetails": "ข้อมูลทั่วไป",
    "hospitalLocation": "ที่ตั้ง",
    "addressDetails": "ถนน อาคาร และรายละเอียดอื่น",
    "addressDetailsHint": "พิมพ์บนหัวเอกสารใต้ชื่อโรงพยาบาล",
    "latitude": "ละติจูด",
    "longitude": "ลองจิจูด",
    "latitudeHint": "ระหว่าง -90 ถึง 90 ใส่ทั้งสองค่าหรือไม่ใส่เลย",
    "longitudeHint": "ระหว่าง -180 ถึง 180 ใส่ทั้งสองค่าหรือไม่ใส่เลย",
    "openMap": "เปิดในแผนที่",
    "clearPosition": "ล้างพิกัด",
    "positionHint": "องศาทศนิยม เช่น 17.966000 และ 102.600000 สำหรับเวียงจันทน์ ปุ่ม ใช้ตำแหน่งของฉัน ใช้ได้เมื่ออยู่ที่โรงพยาบาล",
    "useMyLocation": "ใช้ตำแหน่งของฉัน",
    "locateFailed": "อ่านตำแหน่งของอุปกรณ์นี้ไม่ได้",
    "hospitalPhoto": "รูปและโลโก้โรงพยาบาล",
    "changePhoto": "เปลี่ยนรูป",
    "uploadPhoto": "อัปโหลดรูป",
    "removePhoto": "ลบรูป",
    "photoHint": "JPEG, PNG หรือ WebP รูปนี้จะแสดงเป็นโลโก้โรงพยาบาลในเมนู หน้าเข้าสู่ระบบ และเอกสารที่พิมพ์ รูปสี่เหลี่ยมจัตุรัสเหมาะที่สุด",
    "noPhotoYet": "ยังไม่มีรูป: ระบบแสดงเครื่องหมาย HMS เป็นโลโก้",
    "removePhotoMessage": "ระบบจะแสดงเครื่องหมาย HMS เป็นโลโก้อีกครั้ง",
    "photoSaved": "บันทึกรูปโรงพยาบาลแล้ว",
    "photoRemoved": "ลบรูปโรงพยาบาลแล้ว",
    "hospitalNameLo": "ชื่อโรงพยาบาล (ลาว)",
    "hospitalNameEn": "ชื่อโรงพยาบาล (อังกฤษ)",
    "hospitalNameEnHint": "แสดงเมื่อใช้ภาษาอื่นที่ไม่ใช่ลาวและในเอกสารที่พิมพ์"
  },
  "translations": {
    "title": "การแปลภาษา",
    "subtitle": "ปรับแต่งข้อความทุกส่วนในระบบ การเปลี่ยนแปลงมีผลทันทีทั้งเว็บและมือถือ",
    "locale": "ภาษา",
    "scope": "ใช้กับ",
    "scopeUSER": "เฉพาะฉัน",
    "scopeHOSPITAL": "โรงพยาบาลนี้",
    "scopeGLOBAL": "ทุกโรงพยาบาล",
    "scopeHelpUSER": "ข้อความส่วนตัวที่มีแค่คุณเห็น",
    "scopeHelpHOSPITAL": "ทุกคนในโรงพยาบาลนี้จะเห็นข้อความนี้",
    "scopeHelpGLOBAL": "ข้อความเริ่มต้นสำหรับทุกโรงพยาบาล (ผู้ดูแลระบบสูงสุด)",
    "key": "รหัสข้อความ",
    "reference": "ต้นฉบับภาษาอังกฤษ",
    "baseValue": "ข้อความเริ่มต้น",
    "override": "ข้อความที่ปรับแต่ง",
    "effective": "ที่แสดงอยู่",
    "searchPlaceholder": "ค้นหารหัสหรือข้อความ",
    "onlyCustomized": "เฉพาะที่ปรับแต่ง",
    "onlyMissing": "ที่ยังไม่ได้แปล",
    "resetKey": "คืนค่าเริ่มต้น",
    "resetAll": "คืนค่าเริ่มต้นทั้งหมด",
    "resetAllConfirm": "ลบข้อความที่ปรับแต่งทั้งหมดในภาษาและขอบเขตนี้หรือไม่?",
    "importDone": "นำเข้าคำแปล {{count}} รายการแล้ว",
    "importInvalid": "ไฟล์นี้ไม่ใช่ไฟล์คำแปล JSON ที่ถูกต้อง",
    "saveAll": "บันทึกการเปลี่ยนแปลง",
    "unsaved": "{{count}} การเปลี่ยนแปลงที่ยังไม่บันทึก",
    "stats": "ปรับแต่ง {{customized}} · ทั้งหมด {{total}} ข้อความ",
    "missing": "ยังไม่ได้แปล",
    "inheritedFrom": "จาก: {{layer}}",
    "layerBundled": "ค่าเริ่มต้น",
    "saved": "บันทึกคำแปลแล้ว"
  },
  "languages": {
    "title": "ภาษา",
    "add": "เพิ่มภาษา",
    "code": "รหัสภาษา",
    "codeHelp": "รหัส ISO เช่น km หรือ zh-Hant",
    "name": "ชื่อภาษาอังกฤษ",
    "nativeName": "ชื่อในภาษาของตัวเอง",
    "fallback": "ภาษาสำรอง",
    "enabled": "เปิดใช้งาน",
    "builtin": "มาพร้อมระบบ",
    "custom": "เพิ่มเอง",
    "added": "เพิ่มภาษาแล้ว แปลได้ที่หน้าการแปลภาษา"
  },
  "settings": {
    "title": "ตั้งค่า",
    "appearance": "การแสดงผล",
    "theme": "ธีม",
    "themeHelp": "เลือกธีมสี “ตามระบบ” จะเปลี่ยนตามโหมดสว่างหรือมืดของอุปกรณ์",
    "accent": "สีหลัก",
    "accentDefault": "ตามธีม",
    "density": "ความหนาแน่น",
    "densityCompact": "กะทัดรัด",
    "densityComfortable": "สบายตา",
    "language": "ภาษา",
    "languageHelp": "เลือกภาษาสำหรับเมนูและข้อความ",
    "account": "บัญชี",
    "myTranslations": "คำศัพท์ของฉัน",
    "myTranslationsHelp": "เปลี่ยนชื่อข้อความเฉพาะตัวคุณ เช่น เรียก “การตรวจรักษา” ว่า “การมาพบแพทย์”",
    "savedOnServer": "การตั้งค่าจะถูกบันทึกไว้ในบัญชีและใช้ในแอปมือถือได้ด้วย"
  },
  "themes": {
    "system": "ตามระบบ",
    "clinical": "ฟ้าคลินิก",
    "night": "กลางคืน",
    "ocean": "มหาสมุทร",
    "forest": "ป่าไม้",
    "lotus": "ดอกบัว",
    "midnight": "เที่ยงคืน",
    "contrast": "คอนทราสต์สูง",
    "gold": "ทอง",
    "oph": "ศูนย์ตา OPH"
  },
  "notifications": {
    "title": "การแจ้งเตือน",
    "empty": "ไม่มีการแจ้งเตือนใหม่",
    "markAllRead": "ทำเครื่องหมายว่าอ่านทั้งหมด",
    "unread": "ยังไม่อ่าน {{count}}",
    "prescriptionIssued": "ใบสั่งยาใหม่รอจ่าย: {{ref}}",
    "labOrdered": "คำสั่งตรวจแล็บใหม่: {{ref}}",
    "labResultVerified": "ผลแล็บออกแล้ว: {{ref}}",
    "patientCheckedIn": "ผู้ป่วยมาถึงแล้ว: {{ref}}",
    "highIop": "ความดันลูกตาสูง: {{ref}}",
    "eyeSurgeryScheduled": "นัดผ่าตัดตา: {{ref}}",
    "lowStock": "สินค้าใกล้หมด",
    "prSubmitted": "ใบขอซื้อรออนุมัติ",
    "prApproved": "ใบขอซื้อของคุณได้รับอนุมัติ",
    "prRejected": "ใบขอซื้อของคุณไม่ได้รับอนุมัติ",
    "poApproval": "ใบสั่งซื้อรออนุมัติ",
    "stockDocSubmitted": "เอกสารคลังรอตรวจสอบ: {{ref}}",
    "patientAdmitted": "รับผู้ป่วยเข้ารักษา: {{ref}}",
    "patientDischarged": "จำหน่ายแล้ว พร้อมออกบิล: {{ref}}",
    "serviceOrdered": "คำสั่งบริการพิเศษใหม่: {{ref}}",
    "serviceReported": "ผลรอยืนยัน: {{ref}}",
    "serviceVerified": "ผลออกแล้ว: {{ref}}",
    "expenseSubmitted": "ค่าใช้จ่ายรออนุมัติ: {{ref}}",
    "cashSessionClosed": "ลิ้นชักเงินรอตรวจนับ: {{ref}}",
    "posRefillSubmitted": "คำขอเติมสินค้า POS รอจัดเตรียม: {{ref}}",
    "posRefillSent": "สินค้าเติม POS กำลังมา — โปรดยืนยันการรับ: {{ref}}"
  },
  "time": {
    "justNow": "เมื่อสักครู่",
    "minutesAgo": "{{count}} นาทีที่แล้ว",
    "hoursAgo": "{{count}} ชั่วโมงที่แล้ว",
    "daysAgo": "{{count}} วันที่แล้ว"
  },
  "mobile": {
    "serverUrl": "ที่อยู่เซิร์ฟเวอร์",
    "serverUrlHelp": "URL ของเซิร์ฟเวอร์ HMS เช่น https://hms.example.org หรือ http://192.168.1.10:8090"
  },
  "months": {
    "1": "ม.ค.",
    "2": "ก.พ.",
    "3": "มี.ค.",
    "4": "เม.ย.",
    "5": "พ.ค.",
    "6": "มิ.ย.",
    "7": "ก.ค.",
    "8": "ส.ค.",
    "9": "ก.ย.",
    "10": "ต.ค.",
    "11": "พ.ย.",
    "12": "ธ.ค."
  },
  "analytics": {
    "title": "การวิเคราะห์ข้อมูล",
    "year": "ปี",
    "today": "วันนี้",
    "periodYtd": "{{from}} – {{to}} เทียบกับช่วงเดียวกันของปี {{prevYear}}",
    "periodFull": "ทั้งปี {{year}} เทียบกับปี {{prevYear}}",
    "netRevenue": "รายได้สุทธิ",
    "collected": "เก็บเงินได้",
    "collectionRate": "เก็บได้ {{value}}",
    "visits": "จำนวนการตรวจ",
    "newPatients": "ผู้ป่วยใหม่",
    "revenuePerVisit": "รายได้ต่อการตรวจ",
    "vsLastYear": "เทียบกับปีที่แล้ว",
    "noPrevious": "ไม่มีข้อมูลปีก่อน",
    "revenueByCategory": "รายได้ตามประเภทบริการ",
    "paymentMethods": "การชำระเงินตามวิธี",
    "waterfall": "จากค่าบริการสู่เงินสด",
    "gross": "ค่าบริการรวม",
    "discounts": "ส่วนลด",
    "outstanding": "ค้างชำระ",
    "net": "รายได้สุทธิ",
    "revenueByMonth": "รายได้สุทธิรายเดือน",
    "revenueByQuarter": "รายได้รายไตรมาส",
    "revenueByMonthCategory": "รายได้รายเดือนตามประเภทบริการ",
    "revenueByDepartment": "รายได้ตามแผนก",
    "statement": "งบรายได้",
    "item": "รายการ",
    "change": "เปลี่ยนแปลง",
    "changePct": "เปลี่ยนแปลง %",
    "sectionRevenue": "รายได้",
    "totalGross": "รายได้รวม",
    "sectionOperations": "การดำเนินงาน",
    "invoices": "ใบแจ้งหนี้",
    "visitsByMonth": "การตรวจรายเดือน",
    "topDiagnoses": "โรคที่พบบ่อย",
    "demographics": "ผู้ป่วยที่มารับบริการ ตามกลุ่มอายุและเพศ",
    "quarter": "ไตรมาส {{n}}",
    "noData": "ไม่มีข้อมูลในช่วงนี้",
    "category": {
      "CONSULTATION": "ตรวจรักษา",
      "PHARMACY": "ยา",
      "LABORATORY": "แล็บ",
      "PROCEDURE": "หัตถการ",
      "SERVICE": "ฉุกเฉินและบริการ",
      "ADMINISTRATIVE": "บริหาร",
      "OTHER": "อื่น ๆ",
      "OPHTHALMOLOGY": "ศูนย์จักษุ",
      "SPECIAL_SERVICES": "บริการพิเศษ",
      "INPATIENT": "ค่าเตียงผู้ป่วยใน",
      "POS_SALES": "ขายหน้าร้าน"
    }
  },
  "eye": {
    "title": "ศูนย์จักษุ",
    "subtitle": "จักษุวิทยา: การตรวจ ผ่าตัด ฉีดยา และติดตามผล",
    "overview": "ภาพรวม",
    "eyeRecord": "แฟ้มตา",
    "generalRecord": "แฟ้มทั่วไป",
    "openPatientRecord": "เปิดแฟ้มตาของผู้ป่วย",
    "patient": "ผู้ป่วย",
    "eyeSide": "ตา",
    "eyes": "ตา",
    "side": {
      "OD": "ตาขวา (OD)",
      "OS": "ตาซ้าย (OS)",
      "OU": "ทั้งสองตา (OU)"
    },
    "examinations": "การตรวจ",
    "surgeries": "การผ่าตัด",
    "injections": "การฉีดยาเข้าตา",
    "followUps": "นัดติดตาม",
    "medications": "ยาตา",
    "imaging": "ภาพถ่าย",
    "procedures": "หัตถการ",
    "biometryIol": "ไบโอเมตรีและเลนส์",
    "trends": "แนวโน้ม",
    "currentStatus": "สถานะปัจจุบัน (ค่าล่าสุดแต่ละตา)",
    "newExam": "ตรวจตาใหม่",
    "startEyeExam": "เริ่มตรวจตา",
    "openEyeExam": "การตรวจตา",
    "useOpenEncounter": "ทำต่อในการมาตรวจที่เปิดอยู่:",
    "startWithNewEncounter": "เริ่มด้วยการมาตรวจใหม่",
    "planSurgery": "วางแผนผ่าตัด",
    "injection": "ฉีดยา",
    "followUp": "นัดติดตาม",
    "recordInjection": "บันทึกการฉีดยาเข้าวุ้นตา",
    "prescribeDrops": "สั่งยาหยอดตา",
    "scheduleFollowUp": "นัดติดตาม",
    "visualAcuity": "ระดับสายตา",
    "iop": "ความดันลูกตา (IOP)",
    "refraction": "ค่าสายตา",
    "slitLamp": "ตรวจด้วยกล้องสลิตแลมป์",
    "fundus": "ตรวจจอประสาทตา",
    "diagnoses": "การวินิจฉัยโรคตา",
    "historyAndPlan": "ประวัติ บันทึก และแผนการรักษา",
    "addVisualAcuity": "บันทึกระดับสายตา",
    "addPressure": "บันทึกความดันลูกตา",
    "addRefraction": "บันทึกค่าสายตา",
    "addDiagnosis": "เพิ่มการวินิจฉัย",
    "measurementType": "ประเภทการวัด",
    "chartType": "แผ่นวัดสายตา",
    "acuity": "สายตา",
    "acuityHint": "Snellen (6/12, 20/40), ทศนิยม, logMAR, CF, HM, LP, NLP",
    "correction": "การแก้ไขสายตา",
    "correctionPlaceholder": "เช่น แว่นตา คอนแทคเลนส์",
    "pressure": "ความดัน",
    "method": "วิธี",
    "measuredAt": "เวลาที่วัด",
    "refractionType": "ประเภท",
    "sphere": "สเฟียร์ (SPH)",
    "cylinder": "สายตาเอียง (CYL)",
    "axis": "แกน",
    "add": "ค่าเพิ่ม (ADD)",
    "pd": "ระยะห่างรูม่านตา (PD)",
    "acuityWithRx": "สายตาเมื่อใส่ค่านี้",
    "vaType": {
      "UNAIDED": "ตาเปล่า",
      "CORRECTED": "ใส่แว่น",
      "PINHOLE": "รูเข็ม (Pinhole)",
      "BEST_CORRECTED": "สายตาที่ดีที่สุดเมื่อแก้ไข (BCVA)",
      "NEAR": "ระยะใกล้"
    },
    "chart": {
      "SNELLEN": "Snellen",
      "LOGMAR": "LogMAR",
      "DECIMAL": "ทศนิยม",
      "TUMBLING_E": "ตัว E",
      "LEA": "สัญลักษณ์ LEA",
      "JAEGER": "Jaeger (ใกล้)",
      "OTHER": "อื่นๆ"
    },
    "refractionTypes": {
      "AUTO": "วัดด้วยเครื่องอัตโนมัติ",
      "RETINOSCOPY": "ส่องไฟวัดสายตา (Retinoscopy)",
      "SUBJECTIVE": "วัดแบบถามตอบ",
      "FINAL_PRESCRIPTION": "ค่าสายตาสุดท้าย"
    },
    "iopMethod": {
      "GOLDMANN": "Goldmann",
      "NON_CONTACT": "ไม่สัมผัส (เป่าลม)",
      "TONOPEN": "Tono-Pen",
      "REBOUND": "Rebound (iCare)",
      "OTHER": "อื่นๆ"
    },
    "iopLevel": {
      "LOW": "ต่ำ",
      "NORMAL": "ปกติ",
      "ELEVATED": "สูง",
      "CRITICAL": "สูงวิกฤต"
    },
    "dxType": {
      "PRIMARY": "หลัก",
      "SECONDARY": "รอง",
      "DIFFERENTIAL": "แยกโรค",
      "COMPLICATION": "ภาวะแทรกซ้อน"
    },
    "severity": "ความรุนแรง",
    "severities": {
      "MILD": "เล็กน้อย",
      "MODERATE": "ปานกลาง",
      "SEVERE": "รุนแรง",
      "EARLY": "ระยะต้น",
      "ADVANCED": "ระยะลุกลาม",
      "END_STAGE": "ระยะสุดท้าย",
      "NON_PROLIFERATIVE": "ไม่มีหลอดเลือดงอกใหม่",
      "PROLIFERATIVE": "มีหลอดเลือดงอกใหม่"
    },
    "icdCode": "รหัส ICD-10",
    "diagnosis": "การวินิจฉัย",
    "dx": {
      "H25_1": "ต้อกระจกนิวเคลียร์ตามอายุ",
      "H26_9": "ต้อกระจก ไม่ระบุ",
      "H40_1": "ต้อหินมุมเปิดปฐมภูมิ",
      "H40_2": "ต้อหินมุมปิดปฐมภูมิ",
      "E11_3": "เบาหวานขึ้นจอประสาทตา",
      "H35_3": "จุดรับภาพเสื่อมตามอายุ",
      "H33_0": "จอประสาทตาหลุดลอกจากรูฉีกขาด",
      "H34_8": "หลอดเลือดดำจอตาอุดตัน",
      "H10_0": "เยื่อบุตาอักเสบจากแบคทีเรีย",
      "H16_0": "แผลกระจกตา",
      "H11_0": "ต้อเนื้อ",
      "H04_1": "ภาวะตาแห้ง",
      "H52_1": "สายตาสั้น",
      "H52_0": "สายตายาวโดยกำเนิด",
      "H52_4": "สายตายาวตามอายุ",
      "H50_0": "ตาเหล่เข้าใน",
      "H53_0": "ตาขี้เกียจ",
      "H20_0": "ม่านตาอักเสบส่วนหน้าเฉียบพลัน",
      "H00_0": "ตากุ้งยิง",
      "H57_1": "ปวดตา"
    },
    "field": {
      "chiefComplaint": "อาการสำคัญ",
      "historyOfPresentIllness": "ประวัติการเจ็บป่วยปัจจุบัน",
      "pastOcularHistory": "ประวัติโรคตาในอดีต",
      "familyOcularHistory": "ประวัติโรคตาในครอบครัว",
      "systemicHistory": "ประวัติโรคทางระบบ",
      "clinicalNotes": "บันทึกทางคลินิก",
      "plan": "แผนการรักษา",
      "lids": "เปลือกตา",
      "lashes": "ขนตา",
      "conjunctiva": "เยื่อบุตา",
      "sclera": "ตาขาว",
      "cornea": "กระจกตา",
      "anteriorChamber": "ช่องหน้าม่านตา",
      "iris": "ม่านตา",
      "pupil": "รูม่านตา",
      "lens": "เลนส์ตา",
      "vitreous": "วุ้นตา",
      "opticDisc": "ขั้วประสาทตา",
      "cupDiscRatio": "อัตราส่วนถ้วยต่อขั้วประสาทตา (C/D)",
      "macula": "จุดรับภาพ",
      "vessels": "หลอดเลือด",
      "retina": "จอประสาทตา",
      "peripheralRetina": "จอประสาทตาส่วนรอบนอก",
      "notes": "หมายเหตุ"
    },
    "fillNormal": "เติมผลปกติ",
    "notRecorded": "ไม่ได้บันทึก",
    "noDiagnoses": "ยังไม่มีการวินิจฉัย",
    "cdrSuspicious": "C/D ตั้งแต่ 0.6 สงสัยต้อหิน",
    "worse": "แย่ลง",
    "better": "ดีขึ้น",
    "previousValue": "ครั้งก่อน: {{value}}",
    "sign": "ลงนามการตรวจ",
    "signConfirm": "การลงนามจะล็อกการตรวจนี้ การแก้ไขภายหลังทำเป็นฉบับแก้ไข ลงนามตอนนี้หรือไม่",
    "signed": "ลงนามการตรวจแล้ว",
    "amend": "แก้ไข",
    "amendHelp": "ระบบจะสร้างสำเนาเพื่อแก้ไข ฉบับเดิมยังคงอยู่ในแฟ้มโดยไม่เปลี่ยนแปลง",
    "amendReason": "เหตุผลการแก้ไข",
    "amendmentOf": "นี่คือฉบับแก้ไขของ",
    "originalExam": "การตรวจฉบับเดิม",
    "supersededBy": "การตรวจนี้ถูกแก้ไขแล้ว ดู",
    "latestAmendment": "ฉบับแก้ไขล่าสุด",
    "signedBanner": "ลงนามโดย {{name}} เมื่อ {{date}}",
    "comparedWith": "เปรียบเทียบกับการตรวจครั้งก่อน {{date}}",
    "cancelExam": "ยกเลิกการตรวจ",
    "logmarHelp": "LogMAR: 0.0 = 6/6, 0.3 = 6/12, 1.0 = 6/60 ค่ายิ่งต่ำยิ่งดี แกนถูกกลับด้านให้ขึ้นบนหมายถึงดีขึ้น",
    "drivingStandard": "6/12 (เกณฑ์ขับขี่)",
    "iopUpperNormal": "21 mmHg ค่าสูงสุดปกติ",
    "cstThreshold": "300 µm",
    "mdModerate": "−6 dB",
    "centralThickness": "ความหนาจุดรับภาพส่วนกลาง",
    "rnfl": "ความหนาชั้นใยประสาท (RNFL)",
    "sphericalEquivalent": "ค่าสายตาเฉลี่ย (SE)",
    "visualField": "ลานสายตา",
    "noTrendData": "ยังไม่มีข้อมูล",
    "treatments": "การรักษา",
    "bcva": "สายตาดีสุดเมื่อแก้ไข",
    "frequencies": {
      "qd": "วันละครั้ง",
      "bid": "วันละ 2 ครั้ง",
      "tid": "วันละ 3 ครั้ง",
      "qid": "วันละ 4 ครั้ง",
      "q2h": "ทุก 2 ชั่วโมง",
      "qhs": "ก่อนนอน"
    },
    "medication": "ยา",
    "medicationName": "ชื่อยา",
    "otherMedication": "อื่นๆ (พิมพ์ชื่อ)",
    "dose": "ขนาด",
    "frequency": "ความถี่",
    "duration": "ระยะเวลา",
    "startDate": "วันเริ่ม",
    "endDate": "วันสิ้นสุด",
    "instructions": "คำแนะนำ",
    "stop": "หยุด",
    "stopMedication": "หยุดยาตา",
    "noMedications": "ไม่มียาตา",
    "lotNumber": "เลขล็อต",
    "expiryDate": "วันหมดอายุ",
    "indication": "ข้อบ่งชี้",
    "complications": "ภาวะแทรกซ้อน",
    "confirmEyeStatement": "ข้าพเจ้ายืนยัน {{eye}} กับผู้ป่วยและตำแหน่งที่ทำเครื่องหมาย และตรวจยา ขนาด และวันหมดอายุแล้ว",
    "noInjections": "ไม่มีการฉีดยา",
    "by": "โดย",
    "modality": "ประเภทการตรวจ",
    "results": "ผล",
    "device": "เครื่อง",
    "noImaging": "ไม่มีภาพถ่าย",
    "modalities": {
      "FUNDUS_PHOTO": "ถ่ายภาพจอประสาทตา",
      "OCT": "OCT",
      "OCT_ANGIOGRAPHY": "OCT หลอดเลือด",
      "VISUAL_FIELD": "ลานสายตา",
      "CORNEAL_TOPOGRAPHY": "แผนที่กระจกตา",
      "PACHYMETRY": "วัดความหนากระจกตา",
      "B_SCAN": "อัลตราซาวด์ B-scan",
      "BIOMETRY": "ไบโอเมตรี",
      "OTHER": "อื่นๆ"
    },
    "procedure": "หัตถการ",
    "outcome": "ผลลัพธ์",
    "noExams": "ไม่มีการตรวจตา",
    "noSurgeries": "ไม่มีการผ่าตัด",
    "noFollowUps": "ไม่มีนัดติดตาม",
    "postOp": "ตรวจหลังผ่าตัด",
    "caseNumber": "เลขที่เคส",
    "biometry": "ไบโอเมตรี",
    "biometryHelp": "ไบโอเมตรีแต่ละตา เลือกผลวัดเพื่อวางแผนเลนส์แก้วตาเทียม",
    "addBiometry": "เพิ่มไบโอเมตรี",
    "noBiometry": "ไม่มีไบโอเมตรี",
    "axialLength": "ความยาวลูกตา",
    "lensThickness": "ความหนาเลนส์ตา",
    "axialAsymmetry": "ความยาวลูกตาสองข้างต่างกัน {{diff}} mm กรุณาวัดซ้ำก่อนเลือกเลนส์",
    "toricHint": "สายตาเอียงของกระจกตา {{cyl}} D พิจารณาเลนส์ toric",
    "formula": "สูตร",
    "formulas": {
      "SRK_T": "SRK/T",
      "BARRETT_UNIVERSAL_II": "Barrett Universal II",
      "HAIGIS": "Haigis",
      "HOFFER_Q": "Hoffer Q",
      "HOLLADAY": "Holladay",
      "KANE": "Kane",
      "OTHER": "อื่นๆ"
    },
    "aConstant": "ค่าคงที่ A",
    "targetRefraction": "ค่าสายตาเป้าหมาย",
    "iolModel": "รุ่นเลนส์",
    "iolPower": "กำลังเลนส์",
    "iolPowerAuto": "เว้นว่างเพื่อใช้ค่าที่แนะนำ",
    "fromBiometer": "จากใบพิมพ์ของเครื่องวัด",
    "predictedRefraction": "ค่าสายตาที่คาดการณ์",
    "saveCalculation": "บันทึกการคำนวณ",
    "suggestedPower": "กำลังเลนส์ที่แนะนำ",
    "emmetropicPower": "กำลังเลนส์สำหรับสายตาปกติ",
    "noCalculations": "ยังไม่มีการคำนวณเลนส์",
    "selected": "เลือกแล้ว",
    "select": "เลือก",
    "iolSelected": "เลือกเลนส์สำหรับผ่าตัดแล้ว",
    "operativeEye": "ตาที่จะผ่าตัด",
    "surgeryType": "ประเภทการผ่าตัด",
    "surgeryTypes": {
      "CATARACT": "ต้อกระจก",
      "GLAUCOMA": "ต้อหิน",
      "RETINA": "จอประสาทตา",
      "VITRECTOMY": "ผ่าตัดวุ้นตา",
      "CORNEA": "กระจกตา",
      "REFRACTIVE": "แก้ไขสายตา",
      "OCULOPLASTIC": "ศัลยกรรมตกแต่งรอบดวงตา",
      "STRABISMUS": "ตาเหล่",
      "PTERYGIUM": "ต้อเนื้อ",
      "LASER": "เลเซอร์",
      "OTHER": "อื่นๆ"
    },
    "procedureExample": {
      "CATARACT": "สลายต้อกระจกด้วยคลื่นเสียง + ใส่เลนส์",
      "GLAUCOMA": "ผ่าตัดทำทางระบายน้ำในลูกตา",
      "RETINA": "ผ่าตัดหนุนจอตา",
      "VITRECTOMY": "ผ่าตัดวุ้นตา (PPV)",
      "CORNEA": "ผ่าตัดเปลี่ยนกระจกตา",
      "REFRACTIVE": "LASIK",
      "OCULOPLASTIC": "ผ่าตัดเปลือกตา",
      "STRABISMUS": "ผ่าตัดกล้ามเนื้อตา",
      "PTERYGIUM": "ลอกต้อเนื้อและปลูกเยื่อบุตา",
      "LASER": "เลเซอร์ YAG",
      "OTHER": "อธิบายหัตถการ"
    },
    "anesthesia": "การระงับความรู้สึก",
    "anesthesiaTypes": {
      "TOPICAL": "หยอดยาชา",
      "LOCAL": "ฉีดยาชาเฉพาะที่",
      "PERIBULBAR": "ฉีดยาชารอบลูกตา",
      "RETROBULBAR": "ฉีดยาชาหลังลูกตา",
      "SUB_TENON": "ฉีดยาชาใต้เยื่อ Tenon",
      "GENERAL": "ดมยาสลบ"
    },
    "scheduledAt": "นัดเวลา",
    "preopDiagnosis": "การวินิจฉัยก่อนผ่าตัด",
    "noBiometryForEye": "ไม่มีไบโอเมตรีสำหรับตานี้",
    "chooseEyeFirst": "กรุณาเลือกตาก่อน",
    "cataractNeedsBiometry": "การผ่าตัดต้อกระจกต้องมีไบโอเมตรีและเลือกเลนส์ของตานี้ก่อนทำรายการตรวจก่อนผ่าตัด",
    "safetyChecklist": "รายการตรวจความปลอดภัยก่อนผ่าตัด",
    "checklistHelp": "ทำขณะผู้ป่วยรู้สึกตัวและทีมอยู่พร้อม ทีมต้องระบุข้างตาเอง ไม่คัดลอกจากแผน",
    "teamStatesEye": "ข้างตาที่ทีมระบุ",
    "eyeMismatchTitle": "ผิดข้าง!",
    "eyeMismatchBody": "แผนคือ {{planned}} แต่ทีมระบุ {{stated}} หยุดและตรวจสอบอีกครั้ง",
    "check": {
      "patientIdentityConfirmed": "ยืนยันตัวผู้ป่วย (ชื่อ + วันเกิด)",
      "procedureConfirmed": "ยืนยันหัตถการกับผู้ป่วยและใบยินยอม",
      "eyeSideConfirmed": "ยืนยันข้างตาที่จะผ่าแล้ว",
      "consentConfirmed": "มีใบยินยอมที่ลงนามแล้ว",
      "siteMarked": "ทำเครื่องหมายตำแหน่งผ่าตัดแล้ว"
    },
    "confirmChecklist": "ยืนยันรายการตรวจ",
    "checklistConfirmed": "ยืนยันรายการตรวจความปลอดภัยแล้ว",
    "confirmedBy": "ยืนยันโดย {{name}} เวลา {{date}}",
    "startSurgery": "เริ่มผ่าตัด",
    "startConfirm": "เริ่ม {{procedure}} ที่ {{eye}} หรือไม่",
    "cancelSurgery": "ยกเลิกการผ่าตัด",
    "cancelledBecause": "ยกเลิก: {{reason}}",
    "surgicalPlan": "แผนการผ่าตัด",
    "surgeon": "ศัลยแพทย์",
    "startedAt": "เริ่ม",
    "completedAt": "เสร็จ",
    "lensPlan": "แผนเลนส์",
    "openBiometry": "เปิดไบโอเมตรี",
    "noBiometryLinked": "ไม่ได้เชื่อมไบโอเมตรี",
    "selectedLens": "เลนส์ที่เลือก",
    "noLensSelected": "ยังไม่ได้เลือกเลนส์",
    "operativeRecord": "บันทึกการผ่าตัด",
    "operativeFindings": "สิ่งที่พบระหว่างผ่าตัด",
    "operativeNotes": "รายละเอียดการผ่าตัด",
    "postopNotes": "คำสั่งหลังผ่าตัด",
    "noneIfBlank": "เว้นว่างหากไม่มี",
    "implants": "อุปกรณ์ฝัง",
    "implantTypes": {
      "IOL": "เลนส์แก้วตาเทียม",
      "CAPSULAR_TENSION_RING": "วงแหวนพยุงถุงเลนส์",
      "GLAUCOMA_DRAINAGE_DEVICE": "อุปกรณ์ระบายต้อหิน",
      "STENT": "ท่อค้ำ",
      "SILICONE_OIL": "น้ำมันซิลิโคน",
      "GAS": "แก๊สกดจอตา",
      "OTHER": "อื่นๆ"
    },
    "model": "รุ่น",
    "manufacturer": "ผู้ผลิต",
    "serialNumber": "หมายเลขซีเรียล",
    "powerMismatchTitle": "กำลังเลนส์ไม่ตรงกับแผน",
    "powerMismatchBody": "เลนส์ที่เลือกคือ {{planned}} D ตรวจกล่องเลนส์เทียบกับแผน",
    "powerOverride": "ข้าพเจ้ายืนยันกำลังเลนส์นี้กับศัลยแพทย์แล้ว (บันทึกการยกเว้น)",
    "firstPostOpVisit": "นัดตรวจหลังผ่าตัดครั้งแรก",
    "completeSurgery": "เสร็จสิ้นการผ่าตัด",
    "surgeryCompleted": "ผ่าตัดเสร็จสิ้น",
    "followUpDate": "วันนัด",
    "inDays": "อีก {{count}} วัน",
    "examsToday": "การตรวจวันนี้",
    "openExams": "การตรวจที่ยังเปิด",
    "surgeriesUpcoming": "การผ่าตัดที่กำลังจะมาถึง",
    "surgeriesMonth": "การผ่าตัดเดือนนี้",
    "injectionsMonth": "การฉีดยาเดือนนี้",
    "followUpsToday": "นัดติดตามวันนี้",
    "followUpsOverdue": "นัดที่เลยกำหนด",
    "highIopPatients": "ผู้ป่วยความดันตาเกิน 21",
    "activityByMonth": "กิจกรรมศูนย์จักษุ (12 เดือนเต็มล่าสุด)",
    "activity": {
      "exams": "การตรวจ",
      "injections": "การฉีดยา",
      "surgeries": "การผ่าตัด"
    },
    "surgeriesByType": "การผ่าตัดตามประเภท (12 เดือนเต็มล่าสุด)",
    "topEyeDiagnoses": "การวินิจฉัยโรคตาสูงสุด (12 เดือน)",
    "iopControl": "การควบคุมความดันตา (ล่าสุดแต่ละตา 12 เดือน)",
    "iopControlHelp": "ปกติ 10 ถึง 21 mmHg ตาที่สูงและวิกฤตต้องทบทวน",
    "cataractOutcome": "ผลการผ่าตัดต้อกระจก",
    "cataractOutcomeHelp": "{{good}} จาก {{measured}} ตาที่วัดได้ มีสายตา 6/12 หรือดีกว่าภายใน 90 วัน ({{operated}} การผ่าตัดใน 12 เดือน)",
    "upcomingSurgeries": "การผ่าตัดที่กำลังจะมาถึง",
    "anyDate": "ทุกวันที่",
    "myCases": "เคสของฉัน",
    "due": {
      "overdue": "เลยกำหนด",
      "today": "วันนี้",
      "week": "7 วันข้างหน้า"
    },
    "phone": "โทรศัพท์",
    "doctor": "แพทย์",
    "markSeen": "มาแล้ว",
    "markMissed": "ไม่มา"
  },
  "pathways": {
    "title": "วงจรการรักษา",
    "subtitle": "วงจรการดูแลแต่ละโรคทีละขั้น สำหรับแพทย์ พยาบาล และผู้ป่วย",
    "cycles": "วงจร",
    "dueReviews": "ถึงกำหนดทบทวน",
    "new": "วงจรใหม่",
    "searchPlaceholder": "ค้นหาโรค รหัส หรือวงจร…",
    "categoryLabel": "หมวด",
    "category": {
      "EYE": "ตา",
      "CHRONIC": "โรคเรื้อรัง",
      "INFECTIOUS": "โรคติดเชื้อ",
      "MATERNAL": "แม่และเด็ก",
      "SURGICAL": "ศัลยกรรม",
      "PEDIATRIC": "เด็ก",
      "MENTAL": "สุขภาพจิต",
      "GENERAL": "ทั่วไป"
    },
    "shared": "ใช้ร่วมกัน",
    "sharedTemplate": "แม่แบบใช้ร่วมกัน",
    "sharedReadOnly": "นี่คือแม่แบบใช้ร่วมกัน คัดลอกไปยังโรงพยาบาลเพื่อปรับขั้นตอน",
    "hospital": "โรงพยาบาลนี้",
    "scope": "ขอบเขต",
    "cyclic": "วงจรซ้ำ",
    "linear": "เส้นทางทางเดียว",
    "stageCount": "{{count}} ขั้นตอน",
    "activePatients": "ผู้ป่วยขณะนี้ {{count}}",
    "disease": "โรค",
    "diseaseCode": "รหัส ICD-10",
    "stages": "ขั้นตอน",
    "stage": "ขั้นตอน",
    "patients": "ผู้ป่วย",
    "pathway": "วงจรการรักษา",
    "currentStage": "ขั้นตอนปัจจุบัน",
    "cycle": "รอบ",
    "cycleN": "รอบที่ {{n}}",
    "daysShort": "{{count}} วัน",
    "nextReview": "ทบทวนครั้งถัดไป",
    "nextReviewHint": "เว้นว่างเพื่อใช้ระยะเวลาของขั้นตอน",
    "nextReviewOn": "ทบทวน {{date}}",
    "dueToday": "วันนี้",
    "dueWeek": "7 วัน",
    "dueMonth": "30 วัน",
    "noneDue": "ไม่มีการทบทวน",
    "details": "รายละเอียด",
    "autoCode": "สร้างอัตโนมัติถ้าว่าง",
    "color": "สี",
    "inherit": "ตามวงจร",
    "isCyclicHelp": "ซ้ำ: หลังขั้นตอนสุดท้าย ผู้ป่วยเริ่มรอบใหม่",
    "translations": "ภาษาอื่น",
    "addStage": "เพิ่มขั้นตอน",
    "untitled": "ไม่มีชื่อ",
    "moveUp": "เลื่อนขึ้น",
    "moveDown": "เลื่อนลง",
    "stageName": "ชื่อขั้นตอน",
    "durationDays": "ระยะเวลา (วัน)",
    "icon": "ไอคอน",
    "actions": "สิ่งที่ทีมต้องทำ",
    "actionsHint": "รายการสำหรับแพทย์และพยาบาล",
    "patientInstructions": "คำแนะนำสำหรับผู้ป่วย",
    "patientInstructionsHint": "แสดงในแอปผู้ป่วย",
    "preview": "ตัวอย่าง",
    "previewCyclic": "คลิกขั้นตอนเพื่อแก้ไข ลูกศรแสดงวงจรซ้ำ",
    "previewLinear": "คลิกขั้นตอนเพื่อแก้ไข เส้นทางสิ้นสุดหลังขั้นตอนสุดท้าย",
    "copyToHospital": "คัดลอกไปยังโรงพยาบาลของฉัน",
    "copied": "คัดลอกแล้ว แก้ไขได้แล้ว",
    "archive": "เก็บถาวร",
    "restore": "กู้คืน",
    "archived": "เก็บถาวรแล้ว",
    "lastUpdated": "อัปเดต {{date}} โดย {{name}}",
    "patientCycles": "วงจรการรักษา",
    "enroll": "เริ่มวงจรการรักษา",
    "enrolled": "เริ่มวงจรแล้ว",
    "pickStartStage": "คลิกขั้นตอนเพื่อเริ่ม (ค่าเริ่มต้น: ขั้นแรก)",
    "noPlans": "ยังไม่มีวงจร",
    "showEnded": "แสดงที่สิ้นสุด ({{count}})",
    "hideEnded": "ซ่อนที่สิ้นสุด",
    "startedOn": "เริ่ม {{date}}",
    "since": "ตั้งแต่ {{date}}",
    "advance": "ขั้นถัดไป",
    "advanceTo": "ย้ายผู้ป่วยไปยัง",
    "startsCycle": "เริ่มรอบที่ {{n}}",
    "completesPlan": "นี่คือขั้นสุดท้าย: วงจรจะเสร็จสิ้น",
    "moveTo": "ย้ายไปขั้นตอน",
    "addNote": "บันทึก",
    "stop": "หยุดวงจร",
    "history": "ประวัติ",
    "event": {
      "STARTED": "เริ่ม",
      "ADVANCED": "ขั้นถัดไป",
      "MOVED": "ย้าย",
      "NEW_CYCLE": "รอบใหม่",
      "COMPLETED": "เสร็จสิ้น",
      "STOPPED": "หยุด",
      "NOTE": "บันทึก"
    }
  },
  "portal": {
    "cardTitle": "แอปผู้ป่วย",
    "noAccount": "ยังไม่ได้ใช้แอปผู้ป่วย",
    "contact": "โทรศัพท์ / อีเมล",
    "createdVia": "สมัครโดย",
    "via": {
      "SELF_REGISTRATION": "สมัครเอง (ผู้ป่วยใหม่)",
      "SELF_LINKED": "สมัครเอง (ตรงกับแฟ้ม)",
      "STAFF_ACTIVATION": "รหัสเปิดใช้จากโต๊ะ"
    },
    "lastLogin": "เข้าระบบล่าสุด",
    "verifiedBy": "ตรวจบัตรโดย",
    "pendingHelp": "สมัครจากแอป ตรวจบัตรประชาชนแล้วกดยืนยันตัวตน",
    "activeCode": "รหัสเปิดใช้ใช้ได้ถึง {{date}}",
    "issueActivation": "ให้สิทธิ์ใช้แอป",
    "newActivation": "รหัสเปิดใช้ใหม่",
    "verifyIdentity": "ยืนยันตัวตน",
    "verified": "ยืนยันตัวตนแล้ว",
    "disable": "ปิดการใช้แอป",
    "enable": "เปิดการใช้แอป",
    "disableConfirm": "ผู้ป่วยจะถูกออกจากทุกโทรศัพท์และเข้าไม่ได้จนกว่าจะเปิดอีกครั้ง",
    "activationTitle": "การเปิดใช้แอปผู้ป่วย",
    "activationFor": "เปิดใช้สำหรับ",
    "activationExpires": "ใช้ได้ถึง {{date}}",
    "step1": "ติดตั้งแอป HMS และเลือก \"ฉันเป็นผู้ป่วย\"",
    "step2": "แตะ \"สร้างบัญชี\" ใส่เบอร์โทรหรืออีเมลและรหัสนี้",
    "step3": "ใส่รหัส OTP ที่ส่งให้เพื่อเสร็จสิ้น",
    "activationOnce": "รหัสแสดงครั้งเดียว พิมพ์หรือให้ผู้ป่วยสแกนตอนนี้",
    "identifyTitle": "ระบุผู้ป่วยด้วย QR",
    "identifyHelp": "ให้ผู้ป่วยเปิด \"บัตรสุขภาพของฉัน\" ในแอปแล้วสแกน QR",
    "pasteCode": "หรือวางรหัสจากเครื่องสแกน",
    "identify": "ระบุ",
    "cameraUnavailable": "ใช้กล้องไม่ได้ ใช้เครื่องสแกนหรือวางรหัส",
    "stopCamera": "ปิดกล้อง",
    "startCamera": "เปิดกล้อง",
    "hasAllergies": "มีประวัติแพ้ {{count}} รายการ ตรวจก่อนรักษา",
    "checkIdCard": "สมัครจากแอป: ตรวจบัตรประชาชนก่อนรักษา",
    "appointmentsToday": "นัดหมายวันนี้",
    "checkedIn": "ลงทะเบียนมาแล้ว",
    "openRecord": "เปิดแฟ้ม",
    "giveTicket": "ออกบัตรคิว",
    "scanAnother": "สแกนอีก",
    "adminTitle": "แอปผู้ป่วย",
    "adminSubtitle": "วิธีที่ผู้ป่วยเข้าใช้และข้อความที่ส่งโดยระบบทดลอง",
    "flowActivation": "ลงทะเบียนที่โรงพยาบาลแล้ว",
    "flowActivationText": "เปิดแฟ้มผู้ป่วยแล้วกด \"ให้สิทธิ์ใช้แอป\" ผู้ป่วยสแกน QR ในแอปและยืนยันด้วยรหัส OTP",
    "flowSelf": "สมัครจากโทรศัพท์",
    "flowSelfText": "ผู้ป่วยใส่เบอร์โทรหรืออีเมล ชื่อ และวันเกิด แล้วยืนยัน OTP ถ้าตรงกับแฟ้มจะเชื่อมโยง มิฉะนั้นแฟ้มใหม่จะรอตรวจบัตรในการมาครั้งแรก",
    "flowVisit": "การมาครั้งถัดไป",
    "flowVisitText": "ผู้ป่วยแสดง QR เจ้าหน้าที่สแกนในหน้าผู้ป่วยหรือคิวเพื่อเปิดแฟ้ม ลงทะเบียน หรือออกบัตรคิว ผู้ป่วยรับบัตรคิวในแอปได้ด้วย",
    "dummyGateway": "โหมดทดลอง: SMS/อีเมล และการชำระเงินธนาคารเป็นการจำลอง รหัส OTP บันทึกด้านล่าง (ปิดบัง) และแสดงในแอป ไม่มีการตัดเงิน",
    "outbox": "กล่องข้อความขาออก (จำลอง)",
    "outboxEmpty": "ยังไม่มีข้อความ",
    "destination": "ถึง",
    "message": "ข้อความ",
    "msgStatus": {
      "SIMULATED": "จำลอง"
    },
    "appStatus": {
      "VERIFIED": "แอป · ยืนยันแล้ว",
      "PENDING_VERIFICATION": "แอป · รอตรวจบัตร",
      "DISABLED": "แอป · ปิดใช้งาน"
    },
    "appStatusHelp": {
      "VERIFIED": "ลงทะเบียนในแอปผู้ป่วยแล้ว และตรวจบัตรแล้ว",
      "PENDING_VERIFICATION": "สมัครผ่านแอป ตรวจบัตรประชาชนในครั้งถัดไป",
      "DISABLED": "การเข้าใช้แอปถูกปิด"
    },
    "appFilter": "แอปผู้ป่วย",
    "appFilterRegistered": "ลงทะเบียนในแอปแล้ว",
    "appFilterNone": "ยังไม่ลงทะเบียนในแอป"
  },
  "patientApp": {
    "iAmPatient": "ฉันเป็นผู้ป่วย",
    "iAmStaff": "เจ้าหน้าที่โรงพยาบาล",
    "welcome": "สุขภาพของคุณในมือคุณ",
    "welcomeSub": "ดูการตรวจ ผล และบิล รับบัตรคิว และแสดงบัตรสุขภาพ",
    "signIn": "เข้าสู่ระบบ",
    "register": "สร้างบัญชี",
    "hospital": "โรงพยาบาล",
    "usePhone": "โทรศัพท์",
    "useEmail": "อีเมล",
    "phone": "เบอร์มือถือ",
    "email": "ที่อยู่อีเมล",
    "sendCode": "ส่งรหัส",
    "codeSentTo": "ใส่รหัส 6 หลักที่ส่งไปยัง {{destination}}",
    "code": "รหัสยืนยัน",
    "verify": "ยืนยัน",
    "resend": "ส่งรหัสใหม่",
    "demoCode": "ทดลอง — รหัสของคุณคือ {{code}}",
    "loginHint": "หากคุณมีบัญชี จะได้รับรหัส",
    "haveActivation": "ฉันมีรหัสเปิดใช้จากโรงพยาบาล",
    "activationCode": "รหัสเปิดใช้",
    "firstName": "ชื่อ",
    "lastName": "นามสกุล",
    "dateOfBirth": "วันเกิด",
    "sex": "เพศ",
    "newHere": "ใหม่ใช่ไหม? สร้างบัญชี",
    "haveAccount": "มีบัญชีแล้ว? เข้าสู่ระบบ",
    "pendingBanner": "แสดงบัตรประชาชนที่โต๊ะลงทะเบียนครั้งแรกเพื่อใช้ทุกฟีเจอร์",
    "home": "หน้าหลัก",
    "records": "ประวัติ",
    "queue": "คิว",
    "payments": "การชำระเงิน",
    "profile": "โปรไฟล์",
    "hello": "สวัสดี {{name}}",
    "myId": "บัตรสุขภาพของฉัน",
    "idHelp": "แสดง QR นี้ที่โต๊ะโรงพยาบาลหรือแพทย์",
    "refreshesIn": "รีเฟรชใน {{s}} วิ",
    "nextAppointment": "นัดหมายถัดไป",
    "noAppointment": "ไม่มีนัดหมาย",
    "yourTicket": "บัตรคิวของคุณ",
    "position": "ลำดับที่ {{n}}",
    "eta": "ประมาณ {{min}} นาที",
    "calledNow": "ถึงคิวคุณแล้ว — {{counter}}",
    "takeTicket": "รับบัตรคิว",
    "chooseDepartment": "เลือกแผนก",
    "waitingCount": "รอ {{count}} คน",
    "noTicket": "วันนี้ไม่มีบัตรคิว รับเมื่อมาถึงโรงพยาบาล",
    "visits": "การมาตรวจ",
    "diagnoses": "การวินิจฉัย",
    "prescriptions": "ยา",
    "labResults": "ผลตรวจ",
    "eyeHealth": "สุขภาพตา",
    "treatmentCycles": "การรักษาของฉัน",
    "noRecords": "ยังไม่มีการมาตรวจ",
    "outstanding": "ต้องชำระ",
    "pay": "ชำระ",
    "choosePayment": "ต้องการชำระอย่างไร",
    "method": {
      "QR": "ชำระด้วย QR",
      "CARD": "บัตร",
      "BANK_TRANSFER": "โอนเงิน",
      "MOBILE_MONEY": "เงินมือถือ"
    },
    "dummyCheckout": "การชำระทดลอง — ไม่มีการตัดเงิน เลือกผลจากธนาคารเพื่อจำลอง",
    "approve": "จำลอง: ธนาคารอนุมัติ",
    "decline": "จำลอง: ธนาคารปฏิเสธ",
    "paymentApproved": "ชำระเงินสำเร็จ ขอบคุณ",
    "paymentDeclined": "การชำระถูกปฏิเสธ ลองใหม่หรือชำระที่แคชเชียร์",
    "bills": "บิล",
    "paymentHistory": "ประวัติการชำระ",
    "noInvoices": "ไม่มีบิล",
    "noPayments": "ยังไม่มีการชำระ",
    "balance": "ยอดค้าง",
    "total": "รวม",
    "notifications": "ข้อความ",
    "noNotifications": "ไม่มีข้อความ",
    "notify": {
      "DIAGNOSIS": "แพทย์บันทึกการวินิจฉัย ({{ref}})",
      "QUEUE_CALLED": "กำลังเรียกหมายเลข {{ref}} ของคุณ",
      "EncounterCompleted": "สรุปการมาตรวจ {{ref}} พร้อมแล้ว",
      "PrescriptionIssued": "ใบสั่งยาใหม่ {{ref}}",
      "LabResultVerified": "ผลตรวจพร้อมแล้ว ({{ref}})",
      "InvoiceCreated": "บิลใหม่ {{ref}}",
      "PaymentCompleted": "ได้รับการชำระ {{ref}}",
      "EyeExaminationSigned": "ผลตรวจตาของคุณพร้อมแล้ว",
      "EyeSurgeryScheduled": "นัดผ่าตัดตา ({{ref}})",
      "AppointmentBooked": "นัดหมายแล้ว ({{ref}})"
    },
    "allergies": "การแพ้",
    "bloodGroup": "กรุ๊ปเลือด",
    "stageNow": "ขณะนี้: {{stage}}",
    "instructions": "สิ่งที่ต้องทำ",
    "signOut": "ออกจากระบบ",
    "settings": "ภาษาและธีม",
    "verifiedAccount": "ยืนยันตัวตนแล้ว",
    "pendingAccount": "รอตรวจบัตร",
    "patientNumber": "รหัสผู้ป่วย",
    "continue": "ดำเนินการต่อ",
    "sexAge": "เพศ · อายุ",
    "address": "ที่อยู่",
    "registeredOn": "ลงทะเบียนที่โรงพยาบาล",
    "myInformation": "ข้อมูลของฉัน",
    "infoHelp": "หากต้องการแก้ไขข้อมูล กรุณาติดต่อจุดลงทะเบียน",
    "outcome": {
      "ALREADY_REGISTERED": {
        "title": "คุณลงทะเบียนแล้ว",
        "text": "เบอร์โทรหรืออีเมลนี้มีบัญชีอยู่แล้ว ({{mrn}}) คุณได้เข้าสู่ระบบแล้ว"
      },
      "LINKED": {
        "title": "สร้างบัญชีสำเร็จ",
        "text": "พบประวัติของคุณที่โรงพยาบาล {{mrn}} และเชื่อมกับบัญชีแล้ว คุณดูการรักษา ผลตรวจ และบิลได้แล้ว"
      },
      "CREATED": {
        "title": "สร้างบัญชีสำเร็จ",
        "text": "ยินดีต้อนรับ! รหัสผู้ป่วยใหม่ของคุณคือ {{mrn}}"
      },
      "ACTIVATED": {
        "title": "เปิดใช้แอปแล้ว",
        "text": "บัญชีของคุณเชื่อมกับประวัติโรงพยาบาล {{mrn}} แล้ว"
      }
    },
    "appName": "HMS ผู้ป่วย"
  },
  "print": {
    "eyeCenterName": "ศูนย์รักษาและดูแลสุขภาพตา",
    "eyeRegistration": "พิมพ์ใบลงทะเบียนตา",
    "patientCode": "รหัสผู้ป่วย",
    "queueNo": "เลขคิว",
    "fullName": "ชื่อและนามสกุล",
    "dateOfBirth": "วันเดือนปีเกิด",
    "sex": "เพศ",
    "age": "อายุ",
    "years": "{{count}} ปี",
    "occupation": "อาชีพ",
    "disability": "ผู้ป่วยพิการ",
    "village": "บ้าน",
    "district": "เมือง",
    "province": "แขวง",
    "phone": "เบอร์โทร",
    "registeredOn": "วันที่ลงทะเบียน",
    "registeredBy": "ผู้ลงทะเบียน",
    "patientInfo": "ข้อมูลผู้ป่วย",
    "newPatient": "ผู้ป่วยใหม่",
    "returningPatient": "ผู้ป่วยเก่า",
    "examDetails": "รายละเอียดการตรวจ",
    "titleFemale": "นาง",
    "titleMale": "นาย",
    "downloadPdf": "ดาวน์โหลด PDF (A4)"
  },
  "reports": {
    "title": "รายงาน",
    "subtitle": "เรียกดู พิมพ์ และส่งออกรายงานทั้งหมดของโรงพยาบาล",
    "catalog": "รายการรายงาน",
    "total": "รวม",
    "run": "เรียกรายงาน",
    "exportCsv": "ส่งออก CSV",
    "quickRange": "ช่วงเวลาด่วน",
    "thisMonth": "เดือนนี้",
    "lastMonth": "เดือนที่แล้ว",
    "thisYear": "ปีนี้",
    "pickReport": "เลือกรายงานจากรายการ",
    "pressRun": "กำหนดช่วงเวลาแล้วกด “เรียกรายงาน”",
    "period": "ช่วงเวลา",
    "rows": "แถว",
    "truncated": "แสดงเพียง 5,000 แถวแรก กรุณาลดช่วงเวลา",
    "printedAt": "พิมพ์เมื่อ",
    "noRows": "ไม่มีข้อมูลในช่วงนี้",
    "category": {
      "PATIENTS": "ผู้ป่วย",
      "CLINICAL": "คลินิก",
      "SERVICES": "บริการ",
      "FINANCE": "การเงิน",
      "OPERATIONS": "การดำเนินงาน",
      "EYE": "ศูนย์ตา",
      "INVENTORY": "คลังยาและเวชภัณฑ์",
      "PROCUREMENT": "การจัดซื้อ",
      "EQUIPMENT": "เครื่องมือแพทย์",
      "INPATIENT": "ผู้ป่วยใน",
      "SALES": "เคาน์เตอร์ขายยา"
    },
    "r": {
      "patients-registered": {
        "title": "ผู้ป่วยที่ลงทะเบียน",
        "desc": "ผู้ป่วยที่ลงทะเบียนในช่วงเวลา พร้อมที่อยู่"
      },
      "patients-by-address": {
        "title": "ผู้ป่วยตามที่อยู่",
        "desc": "จำนวนผู้ป่วยตามแขวงและเมือง"
      },
      "demographics": {
        "title": "ข้อมูลประชากร",
        "desc": "ผู้ป่วยที่มารับบริการตามกลุ่มอายุและเพศ"
      },
      "appointments": {
        "title": "การนัดหมาย",
        "desc": "การนัดหมายทั้งหมดในช่วงเวลา"
      },
      "visits-by-department": {
        "title": "การมารับบริการตามแผนก",
        "desc": "จำนวนผู้มารับบริการรายวันตามแผนกและประเภท"
      },
      "visits": {
        "title": "ทะเบียนการมารับบริการ",
        "desc": "ทุกการมารับบริการพร้อมการวินิจฉัย"
      },
      "morbidity": {
        "title": "การเจ็บป่วย (ICD-10)",
        "desc": "จำนวนผู้ป่วยตามรหัส เพศ และกลุ่มอายุ"
      },
      "medications": {
        "title": "การใช้ยา",
        "desc": "ปริมาณยาที่สั่งและจ่ายตามรายการยา"
      },
      "laboratory": {
        "title": "ภาระงานห้องแล็บ",
        "desc": "การตรวจที่สั่ง ยืนยัน และผิดปกติ"
      },
      "revenue-daily": {
        "title": "รายได้รายวัน",
        "desc": "ยอดออกใบแจ้งหนี้ ส่วนลด และเก็บได้ต่อวัน"
      },
      "revenue-by-service": {
        "title": "รายได้ตามบริการ",
        "desc": "ยอดเงินตามประเภทบริการ"
      },
      "payments": {
        "title": "การรับชำระเงิน",
        "desc": "ทุกการชำระพร้อมวิธีและผู้รับเงิน"
      },
      "outstanding": {
        "title": "ยอดค้างชำระ",
        "desc": "ใบแจ้งหนี้ที่ยังไม่ชำระพร้อมอายุหนี้"
      },
      "queue-performance": {
        "title": "ประสิทธิภาพคิว",
        "desc": "บัตรคิว เวลารอ และเวลาให้บริการ"
      },
      "care-plans": {
        "title": "รอบการรักษา",
        "desc": "ผู้ป่วยตามแผนและขั้นตอน"
      },
      "patient-app": {
        "title": "การใช้แอปผู้ป่วย",
        "desc": "บัญชี การเปิดใช้ บัตรคิว และการชำระ"
      },
      "staff-activity": {
        "title": "กิจกรรมเจ้าหน้าที่",
        "desc": "การดำเนินการที่บันทึกต่อเจ้าหน้าที่"
      },
      "eye-exams": {
        "title": "การตรวจตา",
        "desc": "การตรวจพร้อม VA, IOP และการวินิจฉัย"
      },
      "eye-surgeries": {
        "title": "การผ่าตัดตา",
        "desc": "การผ่าตัดพร้อมศัลยแพทย์ IOL และผลลัพธ์"
      },
      "eye-injections": {
        "title": "การฉีดยาเข้าวุ้นตา",
        "desc": "การฉีดพร้อมยาและเลขล็อต"
      },
      "eye-high-iop": {
        "title": "ความดันตาสูง",
        "desc": "IOP ล่าสุดสูงกว่า 21 mmHg"
      },
      "eye-follow-ups": {
        "title": "การนัดติดตามตา",
        "desc": "การนัดตรวจซ้ำและที่เลยกำหนด"
      },
      "inventory-stock": {
        "title": "สต็อกคงคลัง",
        "desc": "จำนวน ต้นทุน และมูลค่าตามรายการและคลัง"
      },
      "inventory-low-stock": {
        "title": "สต็อกใกล้หมดและการสั่งซื้อ",
        "desc": "รายการที่ถึงจุดสั่งซื้อพร้อมจำนวนแนะนำ"
      },
      "inventory-expiry": {
        "title": "รายงานวันหมดอายุ",
        "desc": "ล็อตที่หมดอายุหรือจะหมดอายุถึงวันสิ้นสุด"
      },
      "inventory-movements": {
        "title": "บัญชีเคลื่อนไหวสต็อก",
        "desc": "ทุกการเคลื่อนไหวสต็อกในช่วงเวลา"
      },
      "inventory-consumption": {
        "title": "การใช้ตามรายการ",
        "desc": "จำนวนที่จ่ายและเบิก มูลค่า และใช้ได้กี่วัน"
      },
      "inventory-consumption-department": {
        "title": "การใช้ตามแผนก",
        "desc": "มูลค่าที่ใช้ตามใบสั่งยาและแต่ละแผนก"
      },
      "inventory-valuation": {
        "title": "การประเมินมูลค่าสต็อก",
        "desc": "มูลค่าสต็อกตามประเภทและหมวด"
      },
      "inventory-adjustments": {
        "title": "การปรับปรุงและตัดจำหน่าย",
        "desc": "ยอดยกมา การแก้ไข ตัดจำหน่าย และคืนสินค้า"
      },
      "inventory-abc": {
        "title": "การวิเคราะห์ ABC",
        "desc": "จัดลำดับรายการตามมูลค่าการใช้ (A = 80% แรก)"
      },
      "purchase-requests": {
        "title": "ใบขอซื้อ",
        "desc": "ใบขอที่สร้างในช่วงเวลาพร้อมสถานะและมูลค่า"
      },
      "purchase-orders": {
        "title": "ใบสั่งซื้อ",
        "desc": "ใบสั่งซื้อในช่วงเวลา มูลค่าที่รับและค้างรับ"
      },
      "goods-receipts": {
        "title": "การรับสินค้า",
        "desc": "ทุกรายการที่รับพร้อมล็อต วันหมดอายุ และต้นทุน"
      },
      "supplier-performance": {
        "title": "ผลงานผู้จำหน่าย",
        "desc": "มูลค่าสั่งซื้อ การส่งตรงเวลา และระยะส่งตามผู้จำหน่าย"
      },
      "equipment-register": {
        "title": "ทะเบียนเครื่องมือ",
        "desc": "เครื่องมือแพทย์ทั้งหมดพร้อมสถานที่ ประกัน และการบำรุงรักษา"
      },
      "equipment-maintenance": {
        "title": "บันทึกการบำรุงรักษา",
        "desc": "การบำรุงรักษา สอบเทียบ และซ่อมในช่วงเวลา"
      },
      "equipment-due": {
        "title": "เครื่องมือถึงกำหนดบำรุงรักษา",
        "desc": "เครื่องมือที่ถึงหรือเลยกำหนดบำรุงรักษาถึงวันสิ้นสุด"
      },
      "ipd-census": {
        "title": "ผู้ป่วยในหอขณะนี้",
        "desc": "ผู้ป่วยในทุกรายพร้อมเตียง จำนวนวัน และวันคาดจำหน่าย"
      },
      "ipd-admissions": {
        "title": "การรับเข้ารักษา",
        "desc": "การรับเข้าในช่วงเวลาพร้อมประเภท หอผู้ป่วย และผลลัพธ์"
      },
      "ipd-discharges": {
        "title": "การจำหน่าย",
        "desc": "ผู้ป่วยที่จำหน่ายในช่วงเวลา จำนวนวันนอน และการนัดติดตาม"
      },
      "ipd-occupancy": {
        "title": "อัตราการครองเตียง",
        "desc": "เตียงต่อหอผู้ป่วย วันนอนที่ใช้ และอัตราครองเตียง"
      },
      "ipd-length-of-stay": {
        "title": "จำนวนวันนอน",
        "desc": "วันนอนเฉลี่ย สั้นสุด และยาวสุดต่อหอ และลักษณะการจำหน่าย"
      },
      "special-services": {
        "title": "บริการพิเศษ",
        "desc": "เอกซเรย์ อัลตราซาวด์ คลื่นไฟฟ้าหัวใจ ... ที่สั่งทั้งหมด พร้อมสถานะและเวลาออกผล"
      },
      "special-services-summary": {
        "title": "บริการพิเศษแยกตามบริการ",
        "desc": "จำนวนสั่ง เสร็จ ค้าง และรายได้ต่อบริการ"
      },
      "sales-daily": {
        "title": "ยอดขายหน้าร้านรายวัน",
        "desc": "ยอดขาย ส่วนลด คืนเงิน เงินสด และกำไรต่อวัน"
      },
      "sales-items": {
        "title": "สินค้าขายดี",
        "desc": "จำนวนขาย คืน รายได้ ต้นทุน และกำไรต่อรายการ"
      },
      "sales-transactions": {
        "title": "ใบเสร็จการขาย",
        "desc": "การขายหน้าร้านทุกรายการพร้อมพนักงาน การชำระ และการคืน"
      },
      "finance-profit-loss": {
        "title": "กำไรขาดทุน",
        "desc": "รายได้ ต้นทุนสินค้า ค่าใช้จ่าย และกำไรสุทธิ"
      },
      "finance-revenue-sources": {
        "title": "รายได้ตามแหล่ง",
        "desc": "บิลตามแผนกและการขายหน้าร้าน"
      },
      "finance-discounts": {
        "title": "ส่วนลดที่ให้",
        "desc": "ส่วนลดทุกรายการในบิลและที่เคาน์เตอร์พร้อมเหตุผล"
      },
      "finance-expenses": {
        "title": "ค่าใช้จ่าย",
        "desc": "ค่าใช้จ่ายพร้อมผู้บันทึกและผู้อนุมัติ"
      },
      "finance-cash-sessions": {
        "title": "ลิ้นชักเงิน",
        "desc": "เงินสดที่ควรมีและนับได้ ส่วนต่าง และการตรวจ"
      },
      "finance-price-list": {
        "title": "รายการราคา",
        "desc": "ค่าธรรมเนียม ยา การตรวจ บริการ ค่าเตียง และสินค้าทุกรายการ"
      },
      "finance-price-changes": {
        "title": "การเปลี่ยนราคา",
        "desc": "ราคาเดิมและใหม่ เหตุผล และผู้เปลี่ยน"
      },
      "stock-documents": {
        "title": "เอกสารคลัง",
        "desc": "รับเข้า เบิกออก และโอนย้าย พร้อมผู้จัดทำและผู้ตรวจ"
      },
      "morbidity-by-type": {
        "title": "การเจ็บป่วยตามประเภทโรค",
        "desc": "ผู้ป่วยที่วินิจฉัยจัดกลุ่มตามประเภทโรค พร้อมโรคที่ต้องรายงาน เพศ และช่วงอายุ"
      }
    },
    "col": {
      "abnormal": "ผิดปกติ",
      "abnormalRate": "% ผิดปกติ",
      "actions": "การดำเนินการ",
      "activationCodes": "รหัสเปิดใช้",
      "activePatients": "ผู้ป่วยที่กำลังรักษา",
      "administeredBy": "ผู้ฉีด",
      "age": "อายุ",
      "age15to49": "15–49",
      "age50plus": "50+",
      "age5to14": "5–14",
      "ageGroup": "กลุ่มอายุ",
      "ageing": "อายุหนี้",
      "amount": "จำนวนเงิน",
      "appPaid": "ชำระผ่านแอป",
      "appPayments": "การชำระผ่านแอป",
      "appTickets": "บัตรคิวจากแอป",
      "appointmentNumber": "เลขนัดหมาย",
      "avgServiceMinutes": "เวลาบริการเฉลี่ย (นาที)",
      "avgTurnaroundMinutes": "เวลาออกผลเฉลี่ย (นาที)",
      "avgWaitMinutes": "เวลารอเฉลี่ย (นาที)",
      "balance": "ยอดคงเหลือ",
      "caseNumber": "เลขเคส",
      "cases": "จำนวนราย",
      "category": "ประเภท",
      "code": "รหัส",
      "collected": "เก็บได้",
      "completedInRange": "เสร็จสิ้น",
      "complications": "ภาวะแทรกซ้อน",
      "creates": "สร้าง",
      "date": "วันที่",
      "dateOfBirth": "วันเกิด",
      "daysOverdue": "วันที่เกินกำหนด",
      "department": "แผนก",
      "diagnoses": "การวินิจฉัย",
      "diagnosis": "การวินิจฉัย",
      "discount": "ส่วนลด",
      "district": "เมือง",
      "doctor": "แพทย์",
      "emergency": "ฉุกเฉิน",
      "encounterNumber": "เลขการรับบริการ",
      "examinedBy": "ผู้ตรวจ",
      "eye": "ตา",
      "female": "หญิง",
      "form": "รูปแบบ",
      "fromApp": "จากแอป",
      "gross": "ยอดรวม",
      "indication": "ข้อบ่งชี้",
      "invoiceNumber": "เลขใบแจ้งหนี้",
      "invoices": "ใบแจ้งหนี้",
      "iol": "IOL",
      "iop": "IOP (mmHg)",
      "iopOd": "IOP OD",
      "iopOs": "IOP OS",
      "issuedAt": "วันที่ออก",
      "lastActivity": "กิจกรรมล่าสุด",
      "lines": "รายการ",
      "lotNumber": "เลขล็อต",
      "male": "ชาย",
      "maxWaitMinutes": "รอนานสุด (นาที)",
      "measuredAt": "วันที่วัด",
      "medication": "ยา",
      "method": "วิธีชำระ",
      "mrn": "รหัสผู้ป่วย",
      "net": "สุทธิ",
      "newAccounts": "บัญชีใหม่",
      "newInRange": "ใหม่ในช่วงนี้",
      "newPatients": "ผู้ป่วยใหม่",
      "nextFollowUp": "นัดครั้งถัดไป",
      "opd": "ผู้ป่วยนอก",
      "ordered": "สั่ง",
      "other": "อื่นๆ",
      "outstanding": "ค้างชำระ",
      "overdueReviews": "เลยนัด",
      "paidAt": "เวลาชำระ",
      "pathway": "แผนการรักษา",
      "patientName": "ผู้ป่วย",
      "patients": "ผู้ป่วย",
      "paymentNumber": "เลขใบเสร็จ",
      "phone": "เบอร์โทร",
      "postOpVa": "VA หลังผ่าตัด",
      "practitioner": "แพทย์",
      "prescriptions": "ใบสั่งยา",
      "procedureName": "หัตถการ",
      "province": "แขวง",
      "quantity": "จำนวน",
      "quantityDispensed": "จ่ายแล้ว",
      "quantityPrescribed": "สั่ง",
      "reason": "เหตุผล",
      "receivedBy": "ผู้รับเงิน",
      "registeredAt": "วันที่ลงทะเบียน",
      "registeredBy": "ผู้ลงทะเบียน",
      "scheduledStart": "เวลานัด",
      "selfRegistered": "ลงทะเบียนเอง",
      "served": "ให้บริการแล้ว",
      "sex": "เพศ",
      "share": "สัดส่วน",
      "signatures": "ลายเซ็น",
      "skipped": "ข้าม",
      "staff": "เจ้าหน้าที่",
      "stage": "ขั้นตอน",
      "startedAt": "เริ่ม",
      "startedInRange": "เริ่มในช่วงนี้",
      "status": "สถานะ",
      "surgeon": "ศัลยแพทย์",
      "test": "การตรวจ",
      "tickets": "บัตรคิว",
      "total": "รวม",
      "type": "ประเภท",
      "under5": "ต่ำกว่า 5",
      "updates": "แก้ไข",
      "vaOd": "VA OD",
      "vaOs": "VA OS",
      "value": "มูลค่า",
      "verified": "ยืนยันแล้ว",
      "views": "ดู",
      "village": "บ้าน",
      "itemCode": "รหัส",
      "item": "รายการ",
      "itemType": "ประเภท",
      "store": "คลัง",
      "unit": "หน่วย",
      "onHand": "คงคลัง",
      "usable": "ใช้ได้",
      "unitCost": "ต้นทุน/หน่วย",
      "stockValue": "มูลค่า",
      "reorderLevel": "จุดสั่งซื้อ",
      "nextExpiry": "หมดอายุถัดไป",
      "onOrder": "กำลังสั่ง",
      "avgDailyUse": "เฉลี่ย/วัน",
      "daysOfCover": "ใช้ได้ (วัน)",
      "suggestedQuantity": "แนะนำให้สั่ง",
      "estimatedCost": "ค่าใช้จ่ายประมาณ",
      "expiryDate": "วันหมดอายุ",
      "daysLeft": "เหลือ (วัน)",
      "expiryStatus": "สถานะ",
      "performedAt": "วันที่ / เวลา",
      "movementType": "การเคลื่อนไหว",
      "balanceAfter": "คงเหลือ",
      "reference": "อ้างอิง",
      "performedBy": "โดย",
      "dispensed": "จ่ายตามใบสั่ง",
      "issued": "เบิกให้แผนก",
      "totalUsed": "ใช้ทั้งหมด",
      "items": "รายการ",
      "expiredValue": "มูลค่าหมดอายุ",
      "abcClass": "กลุ่ม ABC",
      "cumulativeShare": "สัดส่วนสะสม",
      "prNumber": "เลขที่ PR",
      "createdAt": "วันที่สร้าง",
      "requestedBy": "ผู้ขอ",
      "priority": "ความเร่งด่วน",
      "estimatedTotal": "มูลค่าประมาณ",
      "decidedBy": "ผู้พิจารณา",
      "decidedAt": "วันที่พิจารณา",
      "orders": "ใบสั่งซื้อ",
      "poNumber": "เลขที่ PO",
      "orderDate": "วันที่สั่ง",
      "supplier": "ผู้จำหน่าย",
      "expectedDate": "กำหนดส่ง",
      "receivedValue": "มูลค่าที่รับ",
      "outstandingValue": "มูลค่าค้างรับ",
      "approvedBy": "ผู้อนุมัติ",
      "receivedAt": "วันที่รับ",
      "grnNumber": "เลขที่ใบรับสินค้า",
      "orderedValue": "มูลค่าสั่งซื้อ",
      "onTimeRate": "ส่งตรงเวลา",
      "avgLeadDays": "ระยะส่งเฉลี่ย (วัน)",
      "lateOrders": "ส่งล่าช้า",
      "assetTag": "เลขครุภัณฑ์",
      "serialNumber": "หมายเลขเครื่อง",
      "model": "รุ่น",
      "location": "สถานที่",
      "purchaseDate": "วันที่ซื้อ",
      "purchaseCost": "ราคาซื้อ",
      "warrantyExpiry": "รับประกันถึง",
      "nextMaintenance": "บำรุงรักษาครั้งถัดไป",
      "maintenanceStatus": "การบำรุงรักษา",
      "eventType": "ประเภท",
      "cost": "ค่าใช้จ่าย",
      "statusAfter": "สถานะหลัง",
      "nextDueDate": "กำหนดถัดไป",
      "notes": "หมายเหตุ",
      "dueDate": "วันกำหนด",
      "admissionNumber": "เลขที่รับเข้า",
      "admissionType": "ประเภท",
      "admissions": "การรับเข้า",
      "admittedAt": "วันที่รับเข้า",
      "againstAdvice": "ไม่สมัครใจอยู่",
      "attending": "แพทย์เจ้าของไข้",
      "available": "ว่าง",
      "averageDays": "วันเฉลี่ย",
      "bed": "เตียง",
      "bedDays": "วันนอน",
      "beds": "เตียง",
      "cancelled": "ยกเลิก",
      "cash": "เงินสด",
      "cashier": "พนักงานเก็บเงิน",
      "changeRate": "เปลี่ยน %",
      "changedAt": "วันที่เปลี่ยน",
      "changedBy": "เปลี่ยนโดย",
      "checkedAt": "วันที่ตรวจ",
      "checkedBy": "ตรวจโดย",
      "cleaning": "ทำความสะอาด",
      "closedAt": "วันที่ปิด",
      "completed": "เสร็จสิ้น",
      "countedCash": "นับได้",
      "customer": "ลูกค้า",
      "days": "วัน",
      "deceased": "เสียชีวิต",
      "description": "รายละเอียด",
      "destination": "ไปยัง",
      "dischargeType": "จำหน่ายไปยัง",
      "dischargedAt": "วันที่จำหน่าย",
      "dischargedBy": "จำหน่ายโดย",
      "discharges": "การจำหน่าย",
      "discountType": "ลดเป็น",
      "discountValue": "ค่า",
      "docNumber": "เลขที่เอกสาร",
      "docType": "ประเภท",
      "entityType": "ประเภท",
      "expectedCash": "ควรมี",
      "expectedDischarge": "คาดจำหน่าย",
      "expenseDate": "วันที่",
      "expenseNumber": "เลขที่ค่าใช้จ่าย",
      "followUpDate": "นัดติดตาม",
      "home": "กลับบ้าน",
      "line": "รายการ",
      "margin": "กำไร",
      "marginRate": "กำไร %",
      "maxDays": "ยาวสุด",
      "minDays": "สั้นสุด",
      "name": "ชื่อ",
      "newPrice": "ราคาใหม่",
      "nonCash": "ไม่ใช่เงินสด",
      "occupancyRate": "ครองเตียง %",
      "occupied": "มีผู้ป่วย",
      "oldPrice": "ราคาเดิม",
      "openedAt": "วันที่เปิด",
      "openingFloat": "เงินตั้งต้น",
      "orderNumber": "เลขที่คำสั่ง",
      "orderedAt": "วันที่สั่ง",
      "outOfService": "งดใช้งาน",
      "payee": "จ่ายให้",
      "paymentMethod": "การชำระ",
      "pending": "ค้าง",
      "preparedBy": "ผู้จัดทำ",
      "price": "ราคา",
      "recordedBy": "บันทึกโดย",
      "referred": "ส่งต่อ",
      "refunded": "คืนเงิน",
      "refunds": "คืนเงิน",
      "reportedBy": "รายงานโดย",
      "returned": "คืน",
      "revenue": "รายได้",
      "saleNumber": "เลขที่บิล",
      "sales": "การขาย",
      "section": "หมวด",
      "service": "บริการ",
      "sessionNumber": "ลิ้นชัก",
      "sold": "ขาย",
      "soldAt": "เวลาขาย",
      "source": "แหล่ง",
      "turnaroundMinutes": "เวลาออกผล (นาที)",
      "variance": "ส่วนต่าง",
      "verifiedBy": "ยืนยันโดย",
      "ward": "หอผู้ป่วย",
      "diseaseType": "ประเภทโรค",
      "notifiableCases": "ผู้ป่วยโรคที่ต้องรายงาน"
    },
    "from": "จาก",
    "to": "ถึง"
  },
  "locations": {
    "title": "สถานที่",
    "subtitle": "แขวง เมือง ตำบล และบ้านของ สปป.ลาว",
    "counts": "{{provinces}} แขวง · {{districts}} เมือง · {{villages}} บ้าน",
    "pickDistrict": "เลือกเมืองเพื่อจัดการตำบลและบ้าน",
    "addSubdistrict": "เพิ่มตำบล",
    "editSubdistrict": "แก้ไขตำบล",
    "noSubdistricts": "ยังไม่มีตำบล เพิ่มแล้วกำหนดบ้านให้",
    "villageCount": "{{count}} บ้าน",
    "assignVillages": "กำหนดบ้าน",
    "searchVillage": "ค้นหาบ้าน",
    "nameLa": "ชื่อ (ลาว)",
    "nameEn": "ชื่อ (อังกฤษ)",
    "inOtherSubdistrict": "อยู่ใน {{name}}"
  },
  "inventory": {
    "title": "คลังยา เภสัชกรรม และเครื่องมือแพทย์",
    "subtitle": "สต็อก ล็อตและวันหมดอายุ ใบขอซื้อและใบสั่งซื้อ ผู้จำหน่าย และเครื่องมือแพทย์",
    "item": "รายการ",
    "items": "รายการ",
    "name": "ชื่อ",
    "itemType": "ประเภท",
    "category": "หมวดหมู่",
    "unit": "หน่วย",
    "manufacturer": "ผู้ผลิต",
    "unitCost": "ต้นทุนต่อหน่วย",
    "unitCostShort": "ต้นทุน {{value}} / หน่วย",
    "reorderLevel": "จุดสั่งซื้อ",
    "reorderLevelHint": "เตือนและแนะนำให้สั่งซื้อเมื่อสต็อกที่ใช้ได้ลดลงถึงระดับนี้",
    "reorderQuantity": "จำนวนสั่งซื้อ",
    "maxLevel": "ระดับสูงสุด",
    "maxLevelHint": "หากเกินระดับนี้ถือว่าสต็อกเกิน",
    "maxShort": "สูงสุด {{value}}",
    "trackExpiry": "ติดตามล็อตและวันหมดอายุ",
    "controlled": "ยาควบคุมพิเศษ",
    "controlledShort": "ควบคุม",
    "storageCondition": "สภาพการเก็บรักษา",
    "linkMedication": "ยา (บัญชียาของเภสัชกรรม)",
    "linkMedicationHint": "ยาที่เชื่อมไว้จะถูกตัดสต็อกเมื่อจ่ายยาตามใบสั่ง",
    "noMedicationLink": "ไม่เชื่อม (ไม่จ่ายตามใบสั่งยา)",
    "fromMedication": "ใช้ข้อมูลจากยา",
    "newItem": "เพิ่มรายการ",
    "editItem": "แก้ไขรายการ",
    "searchItem": "ค้นหายา เวชภัณฑ์ หรือเครื่องมือ…",
    "noItems": "ไม่พบรายการ",
    "usable": "สต็อกที่ใช้ได้",
    "onHand": "คงคลัง",
    "onOrder": "อยู่ระหว่างสั่งซื้อ",
    "stockValue": "มูลค่าสต็อก",
    "stockStatus": "สถานะสต็อก",
    "daysOfCover": "ใช้ได้อีก (วัน)",
    "days": "{{count}} วัน",
    "daysLeft": "เหลือ {{count}} วัน",
    "expiredAgo": "หมดอายุแล้ว {{count}} วัน",
    "overdueDays": "เลยกำหนด {{count}} วัน",
    "nextExpiry": "หมดอายุถัดไป",
    "assetsCount": "{{count}} เครื่อง",
    "allStores": "ทุกคลัง",
    "allSuppliers": "ผู้จำหน่ายทั้งหมด",
    "store": "คลัง",
    "storeType": "ประเภทคลัง",
    "newStore": "เพิ่มคลัง",
    "editStore": "แก้ไขคลัง",
    "dispensing": "จ่ายยา",
    "dispensingStore": "จ่ายยาตามใบสั่งจากคลังนี้",
    "dispensingStoreHint": "สต็อกของยาที่เชื่อมไว้จะถูกตัดจากคลังนี้เมื่อห้องยาจ่ายยา",
    "fromStore": "จากคลัง",
    "toStore": "ไปยังคลัง",
    "toDepartment": "ให้แผนก",
    "department": "แผนก",
    "deliverTo": "ส่งถึง",
    "supplier": "ผู้จำหน่าย",
    "newSupplier": "เพิ่มผู้จำหน่าย",
    "editSupplier": "แก้ไขผู้จำหน่าย",
    "noSuppliers": "ยังไม่มีผู้จำหน่าย",
    "contact": "ติดต่อ",
    "contactPerson": "ผู้ติดต่อ",
    "phone": "โทรศัพท์",
    "email": "อีเมล",
    "address": "ที่อยู่",
    "taxId": "เลขประจำตัวผู้เสียภาษี",
    "paymentTerms": "เงื่อนไขการชำระ",
    "leadTimeDays": "ระยะเวลาส่ง (วัน)",
    "leadDays": "ส่งภายใน {{count}} วัน",
    "orders": "ใบสั่งซื้อ",
    "receivedValueShort": "มูลค่าที่รับแล้ว",
    "lots": "ล็อต",
    "lotNumber": "เลขล็อต",
    "expiryDate": "วันหมดอายุ",
    "noLots": "ไม่มีล็อตสินค้า",
    "lotsAndExpiry": "ล็อตและวันหมดอายุ",
    "ledger": "บัญชีเคลื่อนไหวสต็อก",
    "allLots": "ทุกล็อต",
    "expiredOnly": "หมดอายุแล้ว",
    "within": "≤ {{count}} วัน",
    "lotsTotal": "{{count}} ล็อต · {{value}}",
    "lotsCount": "{{count}} ล็อต",
    "lotSummary": "ล็อต {{lot}} ใน {{store}}: {{quantity}}",
    "receivedAt": "วันที่รับ",
    "movementType": "การเคลื่อนไหว",
    "quantity": "จำนวน",
    "balanceAfter": "คงเหลือ",
    "reference": "อ้างอิง",
    "performedAt": "วันที่ / เวลา",
    "performedBy": "โดย",
    "noMovements": "ไม่มีการเคลื่อนไหวสต็อก",
    "recentMovements": "การเคลื่อนไหวล่าสุด",
    "clearItemFilter": "แสดงทุกรายการ",
    "byStore": "สต็อกตามคลัง",
    "usageByMonth": "รับเข้าและใช้ไปต่อเดือน",
    "avgDailyUse": "ใช้เฉลี่ยต่อวัน",
    "coverDays": "ใช้ได้ประมาณ {{count}} วัน",
    "noUse": "ไม่มีการใช้ใน 90 วันที่ผ่านมา",
    "expiredQty": "สต็อกหมดอายุ",
    "equipmentHint": "เครื่องมือติดตามเป็นรายเครื่อง (ลงทะเบียน {{count}} เครื่อง)",
    "openEquipment": "เปิดทะเบียนเครื่องมือ",
    "addStock": "เพิ่มสต็อก",
    "stockAdded": "เพิ่มสต็อกแล้ว",
    "adjustmentType": "ประเภท",
    "reason": "เหตุผล",
    "removeFromLot": "ตัดออก",
    "stockRemoved": "ตัดสต็อกแล้ว",
    "issue": "เบิกจ่าย",
    "issueStock": "เบิกจ่ายให้แผนก",
    "issued": "เบิกจ่ายแล้ว {{number}}",
    "transfer": "โอนย้าย",
    "transferStock": "โอนย้ายระหว่างคลัง",
    "transferred": "โอนย้ายแล้ว {{number}}",
    "fefoHint": "ตัดสต็อกจากล็อตที่หมดอายุก่อน (FEFO)",
    "requestPurchase": "ขอซื้อ",
    "warnings": "การแจ้งเตือน",
    "noWarnings": "ไม่มีการแจ้งเตือน — สต็อก วันหมดอายุ และเครื่องมือเรียบร้อย",
    "seeAll": "ดูทั้งหมด",
    "uncategorized": "ไม่มีหมวด",
    "updatedAt": "อัปเดต {{time}}",
    "requestOnlyHint": "คุณสร้างใบขอซื้อได้ที่แท็บใบขอซื้อ",
    "purchaseRequest": "ใบขอซื้อ",
    "purchaseOrder": "ใบสั่งซื้อ",
    "prNumber": "เลขที่ PR",
    "poNumber": "เลขที่ PO",
    "newRequest": "สร้างใบขอซื้อ",
    "editRequest": "แก้ไขใบขอซื้อ {{number}}",
    "newOrder": "สร้างใบสั่งซื้อ",
    "editOrder": "แก้ไขใบสั่งซื้อ {{number}}",
    "noRequests": "ไม่มีใบขอซื้อ",
    "noOrders": "ไม่มีใบสั่งซื้อ",
    "mineOnly": "เฉพาะของฉัน",
    "createdAt": "วันที่สร้าง",
    "created": "สร้าง",
    "requestedBy": "ผู้ขอ",
    "requestedByOn": "ขอโดย {{name}} เมื่อ {{date}}",
    "requestingDepartment": "แผนกที่ขอ",
    "priority": "ความเร่งด่วน",
    "neededBy": "ต้องการภายใน",
    "reasonForRequest": "เหตุผล / ความจำเป็น",
    "estimatedUnitCost": "ราคาประมาณต่อหน่วย",
    "estimatedTotal": "มูลค่าประมาณ",
    "lineTotal": "รวม",
    "saveDraft": "บันทึกฉบับร่าง",
    "saveAndSubmit": "บันทึกและส่งขออนุมัติ",
    "submit": "ส่งขออนุมัติ",
    "approve": "อนุมัติ",
    "reject": "ไม่อนุมัติ",
    "approveRequest": "อนุมัติ {{number}}",
    "rejectRequest": "ไม่อนุมัติ {{number}}",
    "approveHint": "อนุมัติจำนวนต่อรายการ; 0 คือตัดรายการออก",
    "requested": "ขอ",
    "approvedQty": "อนุมัติ",
    "decisionNote": "หมายเหตุการพิจารณา",
    "cancelRequest": "ยกเลิกใบขอ",
    "cancelRequestConfirm": "ใบขอจะถูกยกเลิกและไม่สามารถสั่งซื้อได้อีก",
    "selfApprovalHint": "คุณเป็นผู้ขอ จึงต้องให้ผู้อนุมัติคนอื่นพิจารณา",
    "selfApprovalPoHint": "คุณเป็นผู้จัดทำใบสั่งซื้อนี้ จึงต้องให้ผู้อื่นอนุมัติ",
    "awaitingApproval": "รอการอนุมัติจากผู้อนุมัติการจัดซื้อ",
    "prSubmitted": "ส่งใบขอซื้อขออนุมัติแล้ว",
    "prApproved": "อนุมัติใบขอซื้อแล้ว",
    "prRejected": "ไม่อนุมัติใบขอซื้อแล้ว",
    "prCancelled": "ยกเลิกใบขอซื้อแล้ว",
    "createPo": "สร้างใบสั่งซื้อ",
    "poCreated": "สร้างใบสั่งซื้อ {{number}} แล้ว",
    "history": "ประวัติ",
    "details": "รายละเอียด",
    "reorderSuggestions": "รายการแนะนำให้สั่งซื้อ",
    "suggestionsHint": "รายการที่ถึงหรือต่ำกว่าจุดสั่งซื้อ (หักจำนวนที่สั่งแล้ว) จำนวนแนะนำจะเติมถึงระดับสูงสุด",
    "noSuggestions": "ขณะนี้ไม่มีรายการที่ต้องสั่งซื้อ",
    "createPrFromSelection": "สร้างใบขอ ({{count}} รายการ)",
    "reorderReason": "เติมสต็อกรายการที่ถึงจุดสั่งซื้อ",
    "orderDate": "วันที่สั่งซื้อ",
    "orderedOn": "สั่งเมื่อ {{date}}",
    "expectedDate": "กำหนดส่ง",
    "expectedDateHint": "ว่างไว้: วันนี้ + ระยะเวลาส่งของผู้จำหน่าย",
    "overdue": "เลยกำหนด",
    "total": "รวม",
    "ordered": "สั่ง",
    "received": "รับแล้ว",
    "receivedValue": "รับแล้ว {{value}}",
    "outstanding": "ค้างรับ",
    "saveOrder": "บันทึกใบสั่งซื้อ",
    "markSent": "ส่งให้ผู้จำหน่ายแล้ว",
    "receive": "รับสินค้า",
    "receiveGoods": "รับสินค้า — {{number}}",
    "receiveHint": "กรอกจำนวนที่ได้รับ ยาและสินค้าที่มีวันหมดอายุต้องมีเลขล็อตและวันหมดอายุ ไม่รับสินค้าที่หมดอายุแล้ว",
    "receiveQty": "รับครั้งนี้",
    "required": "จำเป็น",
    "deliveryNote": "เลขใบส่งของ",
    "confirmReceipt": "ยืนยันการรับ",
    "goodsReceived": "รับสินค้าเข้าคลังแล้ว",
    "goodsReceipts": "การรับสินค้า",
    "noReceipts": "ยังไม่ได้รับสินค้า",
    "closeShort": "ปิด (ส่วนที่เหลือไม่มา)",
    "closeShortConfirm": "ใบสั่งซื้อจะถูกปิดตามจำนวนที่ได้รับแล้ว",
    "cancelOrder": "ยกเลิกใบสั่งซื้อ",
    "poApproved": "อนุมัติใบสั่งซื้อแล้ว",
    "poSent": "ส่งใบสั่งซื้อแล้ว",
    "poCancelled": "ยกเลิกใบสั่งซื้อแล้ว",
    "poClosed": "ปิดใบสั่งซื้อแล้ว",
    "preparedBy": "ผู้จัดทำ",
    "approvedBy": "ผู้อนุมัติ",
    "supplierAcknowledgement": "ผู้จำหน่ายรับทราบ",
    "description": "รายละเอียด",
    "equipment": "เครื่องมือ",
    "newAsset": "ลงทะเบียนเครื่องมือ",
    "editAsset": "แก้ไขเครื่องมือ",
    "noAssets": "ยังไม่มีเครื่องมือที่ลงทะเบียน",
    "equipmentType": "ประเภทเครื่องมือ",
    "equipmentTypeHint": "รายการประเภทเครื่องมือ (สร้างที่แท็บรายการก่อน)",
    "searchEquipment": "ค้นหาเครื่องมือ เลขครุภัณฑ์ เลขเครื่อง หรือสถานที่…",
    "assetTag": "เลขครุภัณฑ์",
    "assetTagHint": "ว่างไว้: ออกเลขอัตโนมัติ",
    "serialNumber": "หมายเลขเครื่อง",
    "model": "รุ่น",
    "location": "สถานที่",
    "purchaseDate": "วันที่ซื้อ",
    "purchaseCost": "ราคาซื้อ",
    "purchasedFor": "ซื้อราคา {{value}} เมื่อ {{date}}",
    "warrantyExpiry": "รับประกันถึง",
    "underWarranty": "อยู่ในประกัน",
    "warrantyEnded": "หมดประกัน",
    "maintenanceInterval": "บำรุงรักษาทุก (วัน)",
    "lastMaintenance": "บำรุงรักษาล่าสุด",
    "lastOn": "ล่าสุด {{date}}",
    "nextMaintenance": "บำรุงรักษาครั้งถัดไป",
    "nextMaintenanceHint": "ว่างไว้: ครั้งล่าสุด + ระยะ",
    "maintenanceDueOnly": "ถึงกำหนดบำรุงรักษา",
    "maintenanceCost": "ค่าบำรุงรักษา",
    "serviceHistory": "ประวัติการบำรุงรักษาและซ่อม",
    "noEvents": "ยังไม่มีบันทึกการบำรุงรักษา",
    "logEvent": "บันทึกการบริการ — {{tag}}",
    "logEventShort": "บันทึกการบำรุงรักษา",
    "eventType": "ประเภท",
    "eventDate": "วันที่",
    "cost": "ค่าใช้จ่าย",
    "statusAfter": "สถานะหลังจากนั้น",
    "noChange": "ไม่เปลี่ยน",
    "nextDueDate": "กำหนดครั้งถัดไป",
    "nextDueHint": "ว่างไว้: วันนี้ + ระยะบำรุงรักษา",
    "recordedBy": "ผู้บันทึก",
    "tab": {
      "dashboard": "สถิติ",
      "items": "รายการ",
      "stock": "สต็อก",
      "requests": "ใบขอซื้อ",
      "orders": "ใบสั่งซื้อ",
      "suppliers": "ผู้จำหน่าย",
      "equipment": "เครื่องมือแพทย์",
      "alerts": "แจ้งเตือน",
      "stores": "คลัง",
      "stockIn": "รับเข้าคลัง",
      "stockOut": "เบิกออกคลัง",
      "transfers": "โอนย้าย",
      "toCheck": "รอตรวจสอบ",
      "posRefills": "คำขอเติมสินค้า POS"
    },
    "kpi": {
      "stockValue": "มูลค่าสต็อก",
      "itemsCount": "{{count}} รายการ",
      "outOfStock": "สินค้าหมด",
      "lowCount": "ใกล้หมด {{count}}",
      "lowStock": "ใกล้หมด",
      "overCount": "เกิน {{count}}",
      "expiring30": "ใกล้หมดอายุ ≤ 30 วัน",
      "expiredLots": "หมดอายุ {{count}} ล็อต · {{value}}",
      "prPending": "ใบขอรออนุมัติ",
      "prApproved": "อนุมัติแล้ว ยังไม่สั่ง {{count}}",
      "poOpen": "ใบสั่งซื้อที่ยังเปิด",
      "poOverdue": "เลยกำหนด {{count}} · ค้าง {{value}}",
      "equipment": "เครื่องมือแพทย์",
      "maintenance": "ถึงกำหนด {{due}} · เลย {{overdue}}"
    },
    "chart": {
      "flowByMonth": "รับเข้า ใช้ไป และตัดจำหน่ายต่อเดือน",
      "received": "รับเข้า",
      "consumed": "ใช้ไป",
      "writtenOff": "ตัดจำหน่าย",
      "valueByCategory": "มูลค่าสต็อกตามหมวด",
      "topConsumed": "ใช้มากที่สุด (90 วัน ตามมูลค่า)",
      "expiryTimeline": "มูลค่าสต็อกที่จะหมดอายุต่อเดือน",
      "expiringValue": "จะหมดอายุ",
      "spendBySupplier": "การจัดซื้อตามผู้จำหน่าย (12 เดือน)"
    },
    "severity": {
      "danger": "ด่วน {{count}}",
      "warning": "เตือน {{count}}",
      "info": "แจ้งให้ทราบ {{count}}"
    },
    "alert": {
      "OUT_OF_STOCK": "สินค้าหมด",
      "LOW_STOCK": "ใกล้หมด",
      "OVERSTOCK": "สต็อกเกิน",
      "EXPIRED": "หมดอายุ",
      "EXPIRING": "ใกล้หมดอายุ",
      "PO_OVERDUE": "ส่งล่าช้า",
      "PO_APPROVAL": "ใบสั่งซื้อรออนุมัติ",
      "PR_PENDING": "ใบขอรออนุมัติ",
      "MAINTENANCE_OVERDUE": "เลยกำหนดบำรุงรักษา",
      "MAINTENANCE_DUE": "ถึงกำหนดบำรุงรักษา",
      "WARRANTY_EXPIRING": "ประกันใกล้หมด",
      "ASSET_OUT_OF_SERVICE": "เครื่องมือใช้งานไม่ได้",
      "stockDetail": "ใช้ได้ {{usable}} · สั่งที่ {{reorder}} · กำลังสั่ง {{onOrder}}",
      "overDetail": "ใช้ได้ {{usable}} · สูงสุด {{max}}",
      "lotDetail": "ล็อต {{lot}} · {{store}} · {{quantity}} · {{date}} · {{value}}",
      "poOverdueDetail": "{{supplier}} · กำหนด {{date}} (ช้า {{count}} วัน)",
      "prDetail": "โดย {{by}} · {{priority}}"
    },
    "barcode": "บาร์โค้ด",
    "grnNumber": "ใบรับสินค้า",
    "margin": "กำไร {{value}}%",
    "noPictures": "ยังไม่มีรูปภาพ เพิ่มรูปสินค้าได้หนึ่งหรือหลายรูป",
    "notForSale": "ไม่ขาย",
    "pictures": "รูปภาพและราคาขาย",
    "salePrice": "ราคาขาย",
    "salePriceDrugHint": "ใช้ราคาเดียวกันทั้งใบสั่งยาและขายหน้าร้าน",
    "salePriceHint": "ราคาที่เคาน์เตอร์ขายยา",
    "sellable": "ขายหน้าร้านได้",
    "docs": {
      "availableNow": "คงเหลือตอนนี้",
      "cancelConfirm": "เอกสารจะถูกยกเลิก สต็อกไม่เปลี่ยนแปลง",
      "cancelTitle": "ยกเลิกเอกสาร",
      "cancelled": "ยกเลิกเอกสารแล้ว",
      "checkNote": "หมายเหตุผู้ตรวจ",
      "checkedBy": "ตรวจโดย",
      "destination": "ไปยัง",
      "fefo": "หมดอายุก่อน ออกก่อน",
      "lineCount": "{{count}} รายการ",
      "newRequisition": "สร้างใบเบิก",
      "newStockIn": "รับเข้าคลังใหม่",
      "newWriteOff": "ตัดจำหน่าย / คืน",
      "none": "ไม่มีเอกสาร",
      "nothingToCheck": "ไม่มีเอกสารรอคุณตรวจ",
      "number": "เลขที่เอกสาร",
      "pendingCheck": "รอตรวจสอบ",
      "pickItem": "เลือกรายการที่จะรับเข้า",
      "pickLotHint": "การตัดจำหน่ายและคืนสินค้าออกจากล็อตเดียว เลือกรายการ แล้วกด \"ตัดออก\" ที่ล็อต",
      "post": "ตรวจและลงบัญชี",
      "postConfirm": "สต็อกจะเปลี่ยนทันที ตรวจจำนวน ล็อต และวันหมดอายุกับสินค้าจริง",
      "postTitle": "ลงบัญชี {{number}}",
      "posted": "ลงบัญชี {{number}} แล้ว สต็อกอัปเดต",
      "receiptDocuments": "ใบรับสินค้าและการตรวจ",
      "receiptHint": "ใบรับจะรอผู้ตรวจคนที่สองตรวจสินค้าและลงบัญชี",
      "receiveFromPo": "รับจากใบสั่งซื้อ",
      "receivedBy": "ผู้รับ",
      "reference": "อ้างอิง",
      "reject": "ปฏิเสธ",
      "rejectReason": "เหตุผลที่ปฏิเสธ",
      "rejected": "ปฏิเสธเอกสารแล้ว",
      "rejectedBecause": "ถูกปฏิเสธ: {{note}}",
      "shortNow": "บางรายการสต็อกไม่พอ การลงบัญชีจะไม่สำเร็จ",
      "storeKeeper": "เจ้าหน้าที่คลัง",
      "submitForCheck": "ส่งตรวจสอบ",
      "submitRequisition": "ส่งใบเบิก",
      "submitted": "ส่ง {{number}} ตรวจสอบแล้ว",
      "type": "ประเภท",
      "value": "มูลค่า",
      "waitingForChecker": "รอผู้ตรวจคนที่สองลงบัญชี",
      "inHint": "รับเข้า: สินค้าจากใบสั่งซื้อ ยอดยกมา และการปรับยอด ทุกเอกสารต้องให้ผู้ที่สองตรวจและลงบัญชี",
      "outHint": "เบิกออก: ใบเบิกของแผนก ตัดจำหน่าย ปรับลด และคืนผู้จำหน่าย สินค้าออกเมื่อผู้ที่สองลงบัญชีเท่านั้น",
      "transferHint": "โอนย้ายสินค้าระหว่างคลังโดยคงล็อตและวันหมดอายุ ผู้ที่สองเป็นผู้ลงบัญชี",
      "checkHint": "เอกสารที่ผู้อื่นจัดทำ รอคุณตรวจกับสินค้าแล้วลงบัญชีหรือปฏิเสธ"
    }
  },
  "gallery": {
    "add": "เพิ่มรูปภาพ",
    "main": "หลัก",
    "makeMain": "ตั้งเป็นรูปหลัก",
    "next": "ถัดไป",
    "previous": "ก่อนหน้า",
    "none": "ยังไม่มีรูปภาพ",
    "open": "เปิดรูปภาพ"
  },
  "inpatient": {
    "title": "ผู้ป่วยใน",
    "subtitle": "รับเข้ารักษา ย้ายเตียง และจำหน่าย พร้อมคิดค่าเตียงรายวัน",
    "addBed": "เพิ่มเตียง",
    "addRoom": "เพิ่มห้อง",
    "admissionNumber": "เลขที่รับเข้า",
    "admissionType": "ประเภทการรับเข้า",
    "admit": "รับเข้ารักษา",
    "admitPatient": "รับผู้ป่วยเข้ารักษา",
    "admitted": "รับเข้ารักษาแล้ว: {{number}}",
    "admittedAt": "วันที่รับเข้า",
    "admittingDiagnosis": "การวินิจฉัยแรกรับ",
    "allWards": "ทุกหอผู้ป่วย",
    "attending": "แพทย์เจ้าของไข้",
    "attendingDefault": "ยังไม่ระบุ",
    "bed": "เตียง",
    "bedCharges": "ค่าเตียง",
    "bedChargesSoFar": "ค่าเตียงถึงตอนนี้",
    "bedDayRule": "นับวันนอนตามคืน (เที่ยงคืน) ตามราคาเตียง พักภายในวันเดียวนับเป็นหนึ่งวัน",
    "bedNumber": "หมายเลขเตียง",
    "bedStays": "เตียงที่ใช้",
    "bedType": "ประเภทเตียง",
    "beds": "เตียง",
    "billAfterDischarge": "ค่าเตียงออกบิลหลังจำหน่าย",
    "billed": "ออกบิลแล้ว",
    "by": "โดย {{name}}",
    "cancelAdmission": "ยกเลิกการรับเข้า",
    "cancelHint": "ใช้เฉพาะกรณีรับเข้าผิดพลาด เตียงจะว่างและไม่คิดค่าใช้จ่าย",
    "cancelled": "ยกเลิกการรับเข้าแล้ว",
    "cancelledBecause": "ยกเลิก: {{reason}}",
    "capacity": "ความจุ",
    "clinical": "ข้อมูลทางคลินิก",
    "createBill": "ออกบิล",
    "dailyRate": "ราคาต่อวัน",
    "dailyRateHint": "คิดต่อคืนสำหรับแต่ละเตียงในห้องนี้",
    "day": "วัน",
    "dayN": "วันที่ {{count}}",
    "discharge": "จำหน่าย",
    "dischargeAnyway": "จำหน่ายต่อไป",
    "dischargeDiagnosis": "การวินิจฉัยสุดท้าย",
    "dischargeHint": "เตียงจะเข้าสู่การทำความสะอาดและค่าเตียงพร้อมออกบิล",
    "dischargeMedications": "ยากลับบ้าน",
    "dischargeSummary": "สรุปการจำหน่าย",
    "dischargeTitle": "จำหน่าย {{name}}",
    "dischargeType": "จำหน่ายไปยัง",
    "discharged": "จำหน่ายผู้ป่วยแล้ว",
    "dischargedAt": "วันที่จำหน่าย",
    "editRoom": "แก้ไขห้อง",
    "editWard": "แก้ไขหอผู้ป่วย",
    "expectedDischarge": "คาดว่าจะจำหน่าย",
    "expectedShort": "คาดออก {{date}}",
    "floor": "ชั้น {{floor}}",
    "floorLabel": "ชั้น",
    "followUpDate": "วันนัดติดตาม",
    "followUpInstructions": "คำแนะนำหลังจำหน่าย",
    "from": "จาก",
    "lengthOfStay": "จำนวนวันนอน",
    "markClean": "ทำความสะอาดแล้ว",
    "moveReason": "เหตุผล",
    "newBed": "เตียงใหม่",
    "newWard": "เพิ่มหอผู้ป่วย",
    "nights": "{{count}} คืน",
    "nightsHeader": "คืน",
    "noAdmissions": "ไม่มีการรับเข้า",
    "noFreeBeds": "ไม่มีเตียงว่าง",
    "noRooms": "ยังไม่มีห้อง",
    "noWards": "ยังไม่มีหอผู้ป่วย กรุณาตั้งค่าหอ ห้อง และเตียงก่อน",
    "notBilledYet": "ยังไม่ออกบิล",
    "now": "ปัจจุบัน",
    "occupancy": "อัตราการครองเตียง",
    "occupiedOf": "{{occupied}} จาก {{total}} เตียง",
    "openChart": "เปิดแฟ้มการรักษา",
    "patient": "ผู้ป่วย",
    "patientOrRelative": "ผู้ป่วยหรือญาติ",
    "pendingWork": "ยังมีงานที่ยังไม่เสร็จ",
    "pending": {
      "serviceOrders": "บริการพิเศษ {{count}} รายการยังไม่เสร็จ",
      "labOrders": "แล็บ {{count}} รายการยังไม่เสร็จ",
      "prescriptions": "ใบสั่งยา {{count}} ใบยังไม่จ่าย",
      "draftNotes": "บันทึก {{count}} รายการยังไม่ลงนาม"
    },
    "printNote": "กรุณาเก็บสรุปนี้และนำมาในวันนัดติดตาม",
    "reason": "เหตุผลที่รับเข้า",
    "release": "ปล่อยว่าง",
    "room": "ห้อง",
    "roomN": "ห้อง {{room}}",
    "roomType": "ประเภทห้อง",
    "searchAdmissions": "ชื่อ HN หรือเลขที่รับเข้า",
    "to": "ถึง",
    "transfer": "ย้าย",
    "transferBed": "ย้ายเตียง",
    "transferHint": "ปัจจุบันอยู่ {{bed}} เตียงเดิมจะเข้าสู่การทำความสะอาด",
    "transferred": "ย้ายไป {{bed}} แล้ว",
    "visit": "การเข้ารับบริการ",
    "ward": "หอผู้ป่วย",
    "wardType": "ประเภทหอผู้ป่วย",
    "searchBeds": "ผู้ป่วย, HN, ห้อง หรือเตียง",
    "admittedToday": "รับเข้าวันนี้",
    "dueOutToday": "กำหนดออกวันนี้",
    "overdueOut": "เกินกำหนดออก {{date}}",
    "noBedsMatch": "ไม่มีเตียงที่ตรงกับตัวกรอง",
    "wardOccupied": "ใช้ {{occupied}} จาก {{total}} เตียง",
    "admittedAtField": "วันและเวลาที่รับเข้า",
    "admittedAtHint": "ค่าเริ่มต้นคือตอนนี้ ย้อนหลังได้หากบันทึกช้า (ไม่เกิน 30 วัน)",
    "dischargedAtField": "วันและเวลาจำหน่าย",
    "dischargedAtHint": "ค่าเริ่มต้นคือตอนนี้ ต้องไม่ก่อนเวลารับเข้า ({{at}})",
    "admittedShort": "รับเข้า {{at}}"
  },
  "services": {
    "title": "บริการพิเศษ",
    "subtitle": "เอกซเรย์ ซีที อัลตราซาวด์ คลื่นไฟฟ้าหัวใจ ส่องกล้อง กายภาพบำบัด และหัตถการ",
    "allCategories": "ทุกประเภท",
    "billedWithVisit": "ออกบิลพร้อมการเข้ารับบริการ",
    "cancelItem": "ยกเลิก {{name}}",
    "cancelOrder": "ยกเลิกคำสั่ง",
    "category": "ประเภท",
    "clinicalInfo": "ข้อมูลทางคลินิก",
    "complete": "เสร็จสิ้น",
    "duration": "ระยะเวลา",
    "durationMinutes": "ระยะเวลา (นาที)",
    "editReport": "แก้ไขรายงาน",
    "editService": "แก้ไขบริการ",
    "findings": "ผลการตรวจพบ",
    "impression": "สรุปผล",
    "inpatient": "ผู้ป่วยใน",
    "itemCancelled": "ยกเลิกบริการแล้ว",
    "markDone": "บันทึกเสร็จ {{name}}",
    "minutes": "{{count}} นาที",
    "newService": "เพิ่มบริการ",
    "noImages": "ไม่มีภาพ",
    "noOrders": "ไม่มีคำสั่งบริการพิเศษ",
    "noReport": "ไม่ต้องรายงานผล",
    "open": "รอดำเนินการ",
    "order": "สั่งบริการพิเศษ",
    "orderCancelled": "ยกเลิกคำสั่งแล้ว",
    "orderFor": "บริการพิเศษสำหรับ {{name}}",
    "orderNumber": "เลขที่คำสั่ง",
    "ordered": "สั่งแล้ว: {{number}}",
    "orderedAt": "วันที่สั่ง",
    "orderedBy": "สั่งโดย",
    "performedBy": "ทำโดย {{name}} {{at}}",
    "preparation": "การเตรียมผู้ป่วย",
    "preparationHint": "แสดงเมื่อสั่ง เช่น งดอาหาร",
    "prepareNote": "การเตรียม: {{text}}",
    "printReport": "พิมพ์รายงาน",
    "priority": "ความเร่งด่วน",
    "recommendation": "ข้อแนะนำ",
    "report": "รายงาน",
    "reportHint": "หลังส่ง ผู้อื่นจะยืนยันรายงานก่อนเป็นผลสุดท้ายถึงแพทย์",
    "reportTitle": "รายงานผลการตรวจ",
    "reportVerified": "รายงานและยืนยันโดยผู้ที่สอง",
    "reported": "ส่งรายงานเพื่อยืนยันแล้ว",
    "done": "บริการเสร็จสิ้น",
    "reportedBy": "รายงานโดย {{name}} {{at}}",
    "reporter": "ผู้รายงาน",
    "requiresReport": "ต้องมีรายงาน (ยืนยันโดยผู้ที่สอง)",
    "searchCatalog": "ค้นหาบริการ",
    "searchOrders": "ชื่อ HN หรือเลขที่คำสั่ง",
    "service": "บริการ",
    "services": "บริการ",
    "start": "เริ่ม",
    "started": "เริ่มแล้ว",
    "submitReport": "ส่งรายงาน",
    "verified": "ยืนยันผลแล้ว",
    "verifiedBy": "ยืนยันโดย {{name}} {{at}}",
    "verifier": "ผู้ยืนยัน",
    "verify": "ยืนยัน",
    "waitingMin": "รอ {{count}} นาที",
    "waitingVerify": "รอผู้อื่นยืนยันรายงานของคุณ",
    "writeReport": "รายงาน: {{name}}",
    "writeReportShort": "เขียนรายงาน"
  },
  "pos": {
    "title": "เคาน์เตอร์ขายยา",
    "subtitle": "ขายยา เวชภัณฑ์ และอุปกรณ์การแพทย์",
    "alreadyReturned": "คืนแล้ว",
    "cart": "ตะกร้า",
    "cartEmpty": "แตะสินค้าเพื่อเพิ่ม",
    "cashReceived": "รับเงินมา",
    "cashier": "พนักงานเก็บเงิน",
    "change": "เงินทอน",
    "charge": "รับชำระ {{total}}",
    "controlledNeedsPatient": "ยาควบคุมขายได้เฉพาะผู้ป่วยที่ลงทะเบียน",
    "customer": "ลูกค้า",
    "customerName": "ชื่อลูกค้า",
    "giveChange": "ทอนเงิน: {{value}}",
    "inStock": "คงเหลือ {{qty}}",
    "netTotal": "{{count}} รายการขาย · สุทธิ {{value}}",
    "nextCustomer": "ลูกค้าถัดไป",
    "noCashRight": "คุณไม่มีสิทธิ์รับเงินสด กรุณาเลือกวิธีชำระอื่น",
    "noProducts": "ไม่มีสินค้าขายในคลังนี้",
    "noReturns": "ไม่มีการคืนสินค้า",
    "noSales": "ไม่มีการขายในช่วงนี้",
    "openDrawerFirst": "เปิดลิ้นชักเงินก่อนรับเงินสด",
    "patientOptional": "ผู้ป่วย (ถ้ามี)",
    "purchases": "การซื้อ",
    "receipt": "ใบเสร็จรับเงิน",
    "recordReturn": "รับคืนสินค้า",
    "refundMethod": "คืนเงินด้วย",
    "refunded": "คืนเงินแล้ว",
    "returnHint": "สินค้าที่คืนจะกลับเข้าล็อตเดิม",
    "returnQty": "จำนวนคืน",
    "returnTitle": "คืนจาก {{number}}",
    "returned": "บันทึกการคืนแล้ว สินค้ากลับเข้าคลัง",
    "returns": "การคืนสินค้า",
    "saleDiscount": "ส่วนลดทั้งบิล",
    "saleDone": "ขาย {{number}} สำเร็จ",
    "saleNumber": "เลขที่บิล",
    "salesTitle": "การขายหน้าร้าน",
    "searchOrScan": "ค้นหาหรือสแกนบาร์โค้ด",
    "searchSales": "เลขบิล ลูกค้า โทรศัพท์ หรือ HN",
    "sold": "ขาย",
    "soldAt": "เวลาขาย",
    "supervisorHint": "การคืนและยกเลิกทำโดยหัวหน้า (ผู้อื่น)",
    "suppliesDevices": "เวชภัณฑ์และอุปกรณ์",
    "void": "ยกเลิกการขาย",
    "voidHint": "สินค้าทั้งหมดกลับเข้าคลังและการขายไม่นับในลิ้นชักเงิน ทำได้เมื่อลิ้นชักยังเปิดอยู่เท่านั้น",
    "voided": "ยกเลิกการขายแล้ว",
    "voidedBecause": "ยกเลิกโดย {{name}}: {{reason}}",
    "outlet": "จุดขาย POS",
    "noOutlet": "ยังไม่มีจุดขาย POS ที่ใช้งาน",
    "catalog": {
      "title": "รายการสินค้า POS",
      "subtitle": "สินค้าที่ขายหน้าร้านและราคา สินค้ามาจากรายการในคลัง",
      "tab": "รายการสินค้า",
      "search": "ชื่อ รหัส บาร์โค้ด หรือหมวด",
      "addFromWarehouse": "เพิ่มจากคลัง",
      "addHint": "เลือกสินค้าในคลังเพื่อขายที่ POS ราคาเริ่มต้นคือราคาขายที่แนะนำ เปลี่ยนราคาได้ภายหลัง",
      "allPublished": "สินค้าในคลังทั้งหมดอยู่ในรายการ POS แล้ว",
      "publishCount": "เพิ่ม {{count}} รายการเข้า POS",
      "published": "เพิ่ม {{count}} รายการเข้า POS แล้ว",
      "empty": "ไม่มีสินค้าในรายการ POS",
      "product": "สินค้า",
      "price": "ราคา POS",
      "posStock": "สต็อก POS",
      "warehouseStock": "ในคลัง",
      "levels": "เติมเมื่อ → เติมถึง",
      "hide": "ซ่อนจาก POS",
      "show": "แสดงที่ POS",
      "editTitle": "สินค้า POS: {{name}}",
      "warehouseItem": "สินค้าในคลัง",
      "displayName": "ชื่อที่แสดงที่ POS",
      "displayNameHint": "เว้นว่าง = ใช้ชื่อในคลัง",
      "suggested": "ราคาแนะนำ: {{price}}",
      "sortOrder": "ลำดับบนหน้าจอ",
      "minLevel": "เติมเมื่อเหลือหรือน้อยกว่า",
      "minLevelHint": "รวมสินค้าที่กำลังจัดส่ง",
      "parLevel": "เติมให้ถึง",
      "parLevelHint": "0 = ไม่แนะนำอัตโนมัติ",
      "parBelowMin": "ต้องไม่ต่ำกว่าจุดเติม",
      "posPicture": "รูปสำหรับ POS",
      "useWarehousePicture": "ใช้รูปจากคลัง",
      "publishedHint": "แสดงและขายที่ POS"
    },
    "outlets": {
      "title": "จุดขาย",
      "add": "จุดขายใหม่",
      "edit": "แก้ไขจุดขาย",
      "empty": "ยังไม่มีจุดขาย",
      "hint": "แต่ละจุดขายมีสต็อกของตัวเอง สินค้าจะเข้ามาเมื่อคลังส่งตามคำขอเติมและจุดขายยืนยันการรับแล้วเท่านั้น",
      "codeHint": "รหัสสั้น เช่น POS2",
      "inUse": "ใช้งาน",
      "products": "สินค้าที่มี",
      "incoming": "กำลังมา"
    },
    "stock": {
      "title": "สต็อก POS และการเติม",
      "subtitle": "สต็อกที่จุดขาย สินค้าที่กำลังมา และคำขอเติมสินค้าจากคลัง",
      "products": "สินค้า",
      "inTransit": "กำลังมา",
      "onHand": "ที่ POS",
      "nextExpiry": "หมดอายุถัดไป",
      "expired": "หมดอายุแล้ว",
      "empty": "ไม่มีข้อมูล"
    },
    "refill": {
      "request": "ขอเติมสินค้า",
      "requestHint": "เติมให้อัตโนมัติด้วยสินค้าที่ถึงจุดเติม จนถึงระดับเป้าหมาย เปลี่ยนจำนวนได้",
      "fromStore": "จากคลัง",
      "nothingLow": "ไม่มีสินค้าใดต่ำกว่าจุดเติม เพิ่มสินค้าด้านล่างได้หากต้องการ",
      "quantity": "จำนวน",
      "addProduct": "เพิ่มสินค้า",
      "saveDraft": "บันทึกเป็นร่าง",
      "send": "ส่งให้คลัง",
      "created": "สร้างคำขอเติม {{number}} แล้ว",
      "submitted": "ส่งให้คลังแล้ว",
      "listTitle": "คำขอเติมสินค้า",
      "inboxTitle": "คำขอเติมสินค้าจาก POS",
      "open": "กำลังดำเนินการ",
      "empty": "ไม่มีคำขอเติมสินค้า",
      "number": "คำขอ",
      "route": "จาก → ไป",
      "lines": "สินค้า",
      "requestedBy": "ผู้ขอ",
      "preparedBy": "ผู้จัดเตรียม (คลัง)",
      "sentAt": "ส่งเมื่อ",
      "receivedBy": "ผู้รับ",
      "transfer": "ใบโอนจากคลัง",
      "requested": "ขอ",
      "inStore": "ใน {{store}}",
      "sent": "ส่ง",
      "received": "รับ",
      "short": "ขาด",
      "toSend": "จะส่ง",
      "prepare": "จัดเตรียมใบโอน",
      "prepareTitle": "จัดเตรียมการเติม {{number}}",
      "prepareHint": "POS กำลังรอสินค้าเหล่านี้ จัดเตรียมใบโอน พนักงานคลังอีกคนตรวจและส่ง",
      "prepareDialogHint": "จำนวนเริ่มต้นตามที่ขอ ไม่เกินที่คลังมี สินค้าที่เป็น 0 จะไม่ถูกส่ง",
      "prepared": "จัดเตรียมใบโอน {{doc}} แล้ว — รอผู้ตรวจส่ง",
      "preparingHint": "คลังจัดเตรียมแล้ว พนักงานคลังอีกคนตรวจและส่งจาก คลัง → รอตรวจ:",
      "waitingWarehouse": "รอคลังจัดเตรียม",
      "sendHint": "การส่งใบโอนนี้จะตัดสินค้าออกจากคลัง สินค้าเข้าจุดขาย POS เมื่อ POS ยืนยันการรับ คำขอเติม",
      "inTransitHint": "กำลังส่งไป POS POS นับสินค้าที่มาถึงและยืนยันการรับ คำขอเติม",
      "fromRequest": "จัดเตรียมสำหรับคำขอเติม POS",
      "receive": "รับสินค้า",
      "receiveTitle": "รับสินค้าเติม {{number}}",
      "receiveHint": "สินค้ากำลังมา นับสินค้าที่มาถึงและยืนยันการรับ จากนั้นจึงขายได้",
      "receiveDialogHint": "ใส่จำนวนที่มาถึงจริง สินค้าที่ขาดจะถูกบันทึกและต้องมีหมายเหตุ",
      "receiveNote": "หมายเหตุ (เหตุผลที่ขาด)",
      "confirmReceipt": "ยืนยันการรับ",
      "receivedOk": "รับแล้ว — ขายสินค้าได้แล้ว",
      "receivedShort": "รับแล้วแต่ขาด: {{note}}",
      "shortValue": "มูลค่าที่ขาด: {{value}}",
      "moreThanSent": "มากกว่าที่ส่งมา",
      "moreThanStore": "มากกว่าที่คลังมี",
      "reject": "ปฏิเสธ",
      "rejectTitle": "ปฏิเสธคำขอเติม {{number}}",
      "rejectReason": "เหตุผล",
      "rejected": "ปฏิเสธคำขอเติมแล้ว",
      "rejectedBecause": "คลังปฏิเสธ: {{reason}}",
      "cancelTitle": "ยกเลิกคำขอเติม {{number}}",
      "cancelHint": "คลังจะไม่จัดเตรียมคำขอนี้"
    }
  },
  "finance": {
    "title": "การเงินและบัญชี",
    "subtitle": "ราคาและค่าธรรมเนียม ลิ้นชักเงิน ค่าใช้จ่าย และผลประกอบการ",
    "tab": {
      "dashboard": "ภาพรวม",
      "prices": "ราคาและค่าธรรมเนียม",
      "sessions": "ลิ้นชักเงิน",
      "expenses": "ค่าใช้จ่าย",
      "history": "ประวัติราคา"
    },
    "allCategories": "ทุกหมวด",
    "amount": "จำนวนเงิน",
    "approveExpense": "อนุมัติ {{number}}",
    "approvedTotal": "อนุมัติแล้ว: {{value}}",
    "balanced": "ยอดตรงกัน",
    "byMethod": "การชำระตามวิธี",
    "cashExpenseHint": "เงินสดที่จ่ายจากลิ้นชักจะนับในลิ้นชักที่คุณเปิดอยู่",
    "cashExpenses": "ค่าใช้จ่ายเงินสด",
    "cashPayments": "รับชำระบิลเงินสด",
    "cashRefunds": "คืนเงินสด",
    "cashSales": "ขายหน้าร้านเงินสด",
    "changePrice": "เปลี่ยนราคา",
    "changePriceOf": "ราคาของ {{name}}",
    "changeReason": "เหตุผลที่เปลี่ยน",
    "changedAt": "วันที่เปลี่ยน",
    "changedBy": "เปลี่ยนโดย",
    "closeDrawer": "ปิดลิ้นชักเงิน {{number}}",
    "closeDrawerShort": "ปิดลิ้นชัก",
    "closeNote": "หมายเหตุการนับ",
    "closed": "ปิด",
    "collected": "เงินที่เก็บได้",
    "cost": "ต้นทุน",
    "costOfGoods": "ต้นทุนยาและเวชภัณฑ์",
    "countedCash": "เงินสดที่นับได้",
    "counterSales": "ขายหน้าร้าน",
    "currentPrice": "ปัจจุบัน {{value}}",
    "dailyCash": "เงินเข้า-ออกรายวัน",
    "date": "วันที่",
    "decidedBy": "อนุมัติ / ปฏิเสธโดย",
    "discountReason": "เหตุผลของส่วนลด",
    "discountType": "ลดเป็น",
    "discountable": "ให้ส่วนลดได้",
    "discountableHint": "สามารถให้ส่วนลดค่าธรรมเนียมนี้ได้",
    "discounts": "ส่วนลดที่ให้",
    "drawerOpenShort": "ลิ้นชัก {{number}} · {{cash}}",
    "drawers": "ลิ้นชักเงินที่เปิดอยู่",
    "editFee": "แก้ไขค่าธรรมเนียม",
    "expectedCash": "เงินสดที่ควรมี",
    "expenseApprovalHint": "ผู้อื่นต้องอนุมัติค่าใช้จ่ายก่อนนับ",
    "expenseNumber": "เลขที่ค่าใช้จ่าย",
    "expenseOnlyHint": "คุณบันทึกค่าใช้จ่ายได้ ฝ่ายการเงินเป็นผู้อนุมัติ",
    "expenseRecorded": "ส่งค่าใช้จ่าย {{number}} เพื่ออนุมัติแล้ว",
    "expenses": "ค่าใช้จ่าย",
    "expensesByCategory": "ค่าใช้จ่ายตามหมวด",
    "grossProfit": "กำไรขั้นต้น {{value}}",
    "item": "รายการ",
    "lastChange": "เปลี่ยนล่าสุด",
    "margin": "กำไร",
    "myDrawer": "ลิ้นชักเงินของฉัน",
    "netProfit": "กำไรสุทธิ",
    "newExpense": "บันทึกค่าใช้จ่าย",
    "newFee": "เพิ่มค่าธรรมเนียม",
    "newPrice": "ราคาใหม่",
    "noChanges": "ไม่มีการเปลี่ยนราคา",
    "noExpenses": "ไม่มีค่าใช้จ่าย",
    "noOpenDrawer": "คุณไม่มีลิ้นชักเงินที่เปิดอยู่",
    "noSessions": "ไม่มีลิ้นชักเงิน",
    "oldPrice": "ราคาเดิม",
    "openDrawer": "เปิดลิ้นชักเงิน",
    "openDrawerHint": "นับเงินทอนในลิ้นชักแล้วกรอกเป็นเงินตั้งต้น",
    "opened": "เปิด",
    "openedAt": "เปิดเมื่อ {{at}}",
    "openingFloat": "เงินตั้งต้น",
    "otherVerifies": "ผู้อื่นต้องนับและตรวจลิ้นชักนี้",
    "outstanding": "บิลค้างชำระ",
    "payee": "จ่ายให้",
    "pendingApproval": "{{count}} รออนุมัติ",
    "percent": "เปอร์เซ็นต์",
    "percentValue": "เปอร์เซ็นต์ (%)",
    "price": "ราคา",
    "priceChangeHint": "บิลใหม่ใช้ราคาใหม่ บิลเดิมคงราคาเดิม ทุกการเปลี่ยนแปลงเก็บไว้ในประวัติราคา",
    "priceSaved": "เปลี่ยนราคาแล้ว",
    "pricesHint": "ค่าธรรมเนียม ยา แล็บ บริการพิเศษ ค่าเตียง และสินค้าทุกรายการมีราคาที่นี่ ส่วนลดเป็นจำนวนเงินหรือเปอร์เซ็นต์ให้ในบิลหรือที่เคาน์เตอร์",
    "recordedBy": "บันทึกโดย",
    "rejectExpense": "ปฏิเสธ {{number}}",
    "revenue": "รายได้",
    "revenueBySource": "รายได้ตามแหล่ง",
    "revenueSplit": "บิล {{invoices}} · หน้าร้าน {{sales}}",
    "searchPrices": "ค้นหาตามชื่อหรือรหัส",
    "session": "ลิ้นชักเงิน",
    "sessionClosed": "ปิดลิ้นชัก {{number}} แล้ว รอการตรวจ",
    "sessionOpened": "เปิดลิ้นชัก {{number}} แล้ว",
    "sessionTitle": "ลิ้นชัก {{number}} · {{name}}",
    "sessionVerified": "ตรวจลิ้นชักแล้ว",
    "submitExpense": "ส่งเพื่ออนุมัติ",
    "taxRate": "อัตราภาษี (%)",
    "toVerify": "ปิดแล้ว {{count}} รอตรวจ",
    "type": "ประเภท",
    "variance": "ส่วนต่าง",
    "varianceIs": "ส่วนต่าง {{value}} กรุณาระบุเหตุผล",
    "verifiedBy": "ตรวจโดย",
    "verifyCount": "ยืนยันการนับ"
  },
  "diseases": {
    "title": "รายการโรค",
    "subtitle": "รหัส ICD-10 ชื่อ และประเภทโรคที่ใช้ในการวินิจฉัยและรายงาน",
    "tabDiseases": "โรค",
    "tabTypes": "ประเภทโรค",
    "searchPlaceholder": "ค้นหาด้วยรหัส ICD-10 หรือชื่อ…",
    "type": "ประเภทโรค",
    "allTypes": "ทุกประเภท",
    "notifiableOnly": "เฉพาะโรคที่ต้องรายงาน",
    "newDisease": "เพิ่มโรค",
    "empty": "ไม่พบโรค",
    "code": "รหัส ICD-10",
    "codeHint": "เช่น A90 หรือ J06.9 ใช้ตัวพิมพ์ใหญ่",
    "name": "ชื่อ",
    "nameLo": "ชื่อ (ลาว)",
    "nameEn": "ชื่อ (อังกฤษ)",
    "notifiable": "ต้องรายงาน",
    "notifiableShort": "รายงาน",
    "notifiableHint": "โรคที่ต้องรายงาน: ต้องแจ้งผู้ป่วยต่อหน่วยงานสาธารณสุข",
    "notifiableWarning": "{{name}} เป็นโรคที่ต้องรายงาน อย่าลืมแจ้งผู้ป่วยรายนี้",
    "noType": "— ไม่มีประเภท —",
    "activeHint": "ใช้งาน (แสดงเมื่อเลือกการวินิจฉัย)",
    "activeTypeHint": "ใช้งาน",
    "deleteDisease": "ลบโรค",
    "deleteDiseaseMessage": "ลบ {{code}} ออกจากรายการหรือไม่? การวินิจฉัยที่บันทึกแล้วยังคงรหัสและข้อความเดิม",
    "deleted": "ลบแล้ว",
    "newType": "เพิ่มประเภทโรค",
    "noTypes": "ยังไม่มีประเภทโรค",
    "diseaseCount": "จำนวนโรค",
    "sortOrder": "ลำดับการแสดง",
    "color": "สี",
    "customColor": "สีกำหนดเอง",
    "preview": "ตัวอย่าง",
    "typeInUseHint": "มี {{count}} โรคใช้ประเภทนี้ จึงลบไม่ได้ ให้ย้ายโรคหรือปิดใช้งานประเภทนี้",
    "deleteType": "ลบประเภทโรค",
    "deleteTypeMessage": "ลบประเภทโรค {{code}} หรือไม่?",
    "pickFromCatalog": "ค้นหาในรายการโรค"
  },
  "national": {
    "title": "รายงานระดับชาติ",
    "subtitle": "ผล KPI รายงานที่อนุมัติแล้ว และการส่งข้อมูลเข้า DHIS2",
    "tab": {
      "dashboard": "ภาพรวม KPI",
      "snapshots": "ฉบับรายงาน",
      "catalog": "รายการ KPI",
      "batches": "การส่ง DHIS2",
      "mappings": "การจับคู่ DHIS2",
      "connections": "การเชื่อมต่อ DHIS2"
    },
    "period": "ช่วงเวลา",
    "calculate": "คำนวณ KPI",
    "calculated": "คำนวณ KPI แล้ว",
    "lastRun": "คำนวณล่าสุด {{at}} โดย {{by}}",
    "notCalculatedYet": "ยังไม่ได้คำนวณ KPI สำหรับช่วงนี้ กด คำนวณ KPI",
    "notCalculatedReadOnly": "ยังไม่ได้คำนวณ KPI สำหรับช่วงนี้",
    "notCalculated": "ยังไม่คำนวณ",
    "noKpis": "ไม่มี KPI",
    "target": "เป้าหมาย",
    "warning": "ระดับเตือน",
    "warningAt": "เตือนที่ {{value}}",
    "numeratorDenominator": "ตัวตั้ง / ตัวหาร",
    "formulaVersion": "สูตรฉบับที่ {{n}}",
    "trend": "หกช่วงล่าสุด",
    "breakdown": "แยกตามกลุ่ม",
    "report": "รายงาน",
    "allReports": "ทุกรายงาน",
    "allStatuses": "ทุกสถานะ",
    "allTypes": "ทุกประเภท",
    "generateSnapshot": "สร้างฉบับรายงาน",
    "generate": "สร้าง",
    "noSnapshots": "ยังไม่มีฉบับรายงาน",
    "version": "ฉบับ",
    "checks": "การตรวจสอบ",
    "clean": "ไม่มีปัญหา",
    "errors": "ข้อผิดพลาด: {{count}}",
    "warnings": "คำเตือน: {{count}}",
    "generated": "สร้างเมื่อ",
    "approvedBy": "อนุมัติโดย",
    "includesKpis": "รายงานนี้ประกอบด้วย:",
    "generateHint": "KPI จะถูกคำนวณใหม่และบันทึกเป็นฉบับใหม่ที่แก้ไขไม่ได้ ต้องให้ผู้อื่นที่ไม่ใช่คุณอนุมัติก่อนจึงจะส่งได้",
    "snapshotGenerated": "สร้างฉบับรายงานแล้ว",
    "snapshotValidated": "ตรวจสอบฉบับรายงานแล้ว",
    "snapshotApproved": "อนุมัติฉบับรายงานแล้ว",
    "snapshotInvalidated": "ยกเลิกฉบับรายงานแล้ว",
    "invalidate": "ยกเลิกความถูกต้อง",
    "validate": "ตรวจสอบ",
    "approve": "อนุมัติ",
    "prepareDhis2": "ส่งเข้า DHIS2…",
    "cannotApproveOwn": "คุณไม่สามารถอนุมัติงานของตนเอง",
    "generatedBy": "สร้างโดย {{by}} เมื่อ {{at}}",
    "approvedByAt": "อนุมัติโดย {{by}} เมื่อ {{at}}",
    "approvedByName": "อนุมัติโดย {{by}}",
    "createdByAt": "สร้างโดย {{by}} เมื่อ {{at}}",
    "needsOtherApprover": "รอผู้อื่นอนุมัติ (แบ่งแยกหน้าที่)",
    "invalidatedBecause": "ยกเลิกแล้ว: {{reason}}",
    "supersededHint": "มีฉบับใหม่ที่อนุมัติแล้วแทนฉบับนี้",
    "values": "ค่า",
    "kpi": "KPI",
    "value": "ค่า",
    "formula": "สูตร",
    "quality": "คุณภาพข้อมูล",
    "dhis2Batches": "การส่ง DHIS2",
    "invalidateMessage": "ฉบับที่ถูกยกเลิกจะส่งไม่ได้อีก ชุดที่ยังไม่ส่งจะถูกยกเลิก โปรดระบุเหตุผล",
    "reason": "เหตุผล",
    "connection": "การเชื่อมต่อ",
    "createBatch": "สร้างชุดข้อมูล",
    "noConnections": "ยังไม่ได้ตั้งค่าการเชื่อมต่อ DHIS2",
    "createBatchHint": "ค่าต่างๆ จะถูกจับคู่กับองค์ประกอบข้อมูล DHIS2 และตรวจสอบ ชุดข้อมูลจะส่งได้หลังจากผู้อื่นอนุมัติเท่านั้น",
    "batchCreated": "สร้างชุดข้อมูลแล้ว",
    "noIssues": "ไม่พบปัญหา",
    "issue": {
      "INSUFFICIENT_DATA": "ข้อมูลน้อยเกินไป",
      "NO_FORMULA": "ไม่มีสูตรที่อนุมัติ",
      "DIMENSION_TOTAL_MISMATCH": "ยอดแยกกลุ่มไม่ตรงกัน",
      "PERIOD_OPEN": "ช่วงยังไม่สิ้นสุด",
      "NO_ORG_UNIT_MAPPING": "ยังไม่จับคู่หน่วยงาน",
      "NO_DATA_SET_MAPPING": "ยังไม่จับคู่ชุดข้อมูล",
      "NO_DATA_ELEMENT_MAPPING": "ยังไม่จับคู่องค์ประกอบข้อมูล",
      "NO_VALUE": "ไม่มีค่า",
      "NOT_SENT_QUALITY": "ไม่ส่ง (คุณภาพ)",
      "NO_CATEGORY_MAPPING": "ยังไม่จับคู่หมวด",
      "NOTHING_TO_SEND": "ไม่มีข้อมูลให้ส่ง"
    },
    "catalogHint": "สูตรคือตัวคำนวณที่มีในระบบ สูตรฉบับใหม่จะใช้ได้หลังจากผู้อื่นที่ไม่ใช่ผู้เขียนอนุมัติเท่านั้น",
    "newKpi": "เพิ่ม KPI",
    "category": "หมวด",
    "unit": "หน่วย",
    "noFormula": "ไม่มีสูตรที่อนุมัติ",
    "draftVersions": "ฉบับร่าง: {{count}}",
    "nameEn": "ชื่อ (อังกฤษ)",
    "nameLo": "ชื่อ (ลาว)",
    "direction": "ทิศทาง",
    "owner": "ผู้รับผิดชอบ",
    "unitFixed": "เปลี่ยนหน่วยไม่ได้หลังจากสร้างแล้ว",
    "newKpiHint": "หลังบันทึก ให้เพิ่มสูตรและให้อนุมัติก่อน จึงจะคำนวณ KPI ได้",
    "newTarget": "เพิ่มเป้าหมาย",
    "newFormulaVersion": "เพิ่มสูตรฉบับใหม่",
    "targetNeedsDirection": "กำหนดก่อนว่าสูงดีหรือต่ำดี",
    "ownedBy": "ผู้รับผิดชอบ: {{owner}}",
    "formulaVersions": "ฉบับของสูตร",
    "definition": "คำนิยาม",
    "numerator": "ตัวตั้ง",
    "denominator": "ตัวหาร",
    "effective": "มีผล",
    "minDenominator": "ตัวหารขั้นต่ำ",
    "targets": "เป้าหมาย",
    "infoNoTarget": "KPI เพื่อข้อมูลไม่มีเป้าหมาย",
    "noTargets": "ยังไม่มีเป้าหมาย",
    "formulaApproved": "อนุมัติสูตรแล้ว",
    "formulaDrafted": "บันทึกสูตรฉบับร่างแล้ว",
    "calculator": "ตัวคำนวณ",
    "parameters": "พารามิเตอร์ (JSON)",
    "parametersInvalid": "ใส่ JSON object เช่น {\"windowDays\": 30}",
    "effectiveFrom": "มีผลตั้งแต่",
    "changeRationale": "เหตุผลของการเปลี่ยนแปลง",
    "saveDraft": "บันทึกเป็นร่าง",
    "formulaApprovalHint": "ฉบับใหม่เริ่มใช้ในวันที่มีผลหลังอนุมัติ ฉบับก่อนหน้าสิ้นสุดในวันก่อนหน้า",
    "lowerBetterHint": "ต่ำยิ่งดี: ค่าเท่ากับหรือต่ำกว่าเป้าหมายถือว่าบรรลุ สูงกว่าแต่ไม่เกินระดับเตือนถือว่าเตือน",
    "higherBetterHint": "สูงยิ่งดี: ค่าเท่ากับหรือสูงกว่าเป้าหมายถือว่าบรรลุ ต่ำกว่าแต่ไม่ต่ำกว่าระดับเตือนถือว่าเตือน",
    "batchesHint": "ชุดข้อมูลจะถูกส่งเบื้องหลัง และลองส่งใหม่อัตโนมัติเมื่อ DHIS2 ไม่พร้อม",
    "noBatches": "ยังไม่มีการส่ง DHIS2",
    "batch": "ชุดข้อมูล",
    "batchApproved": "อนุมัติชุดข้อมูลแล้ว",
    "batchQueued": "ชุดข้อมูลรอส่ง",
    "batchReconciled": "ตรวจเทียบกับ DHIS2 แล้ว",
    "batchCancelled": "ยกเลิกชุดข้อมูลแล้ว",
    "cancelBatch": "ยกเลิกชุด",
    "send": "ส่งเข้า DHIS2",
    "retry": "ส่งอีกครั้ง",
    "reconcile": "ตรวจเทียบ",
    "dataSetOrgUnit": "ชุดข้อมูล {{ds}} · หน่วยงาน {{ou}}",
    "batchHasErrors": "ชุดนี้มีข้อผิดพลาดและส่งไม่ได้ แก้ไขการจับคู่ ยกเลิกชุดนี้ แล้วสร้างชุดใหม่",
    "reconcileHint": "DHIS2 ไม่ตอบกลับทันเวลา กดตรวจเทียบเพื่ออ่านค่ากลับมาก่อนส่งใหม่",
    "nextAttempt": "ลองอัตโนมัติครั้งต่อไป {{at}}",
    "dataValues": "ค่าข้อมูล",
    "noValues": "ไม่มีค่า",
    "dataElement": "องค์ประกอบข้อมูล",
    "categoryOptionCombo": "กลุ่มหมวด (COC)",
    "importResults": "ผลการนำเข้า",
    "counts": "จำนวน",
    "countsLine": "นำเข้า {{imported}} อัปเดต {{updated}} ข้าม {{ignored}} จาก {{total}}",
    "conflicts": "ข้อขัดแย้ง",
    "activity": "กิจกรรม",
    "showPayload": "แสดงข้อมูลที่ส่ง",
    "hidePayload": "ซ่อนข้อมูลที่ส่ง",
    "mappingType": "ประเภทการจับคู่",
    "newMapping": "เพิ่มการจับคู่",
    "noMappings": "ไม่มีการจับคู่",
    "local": "รายการใน HMS",
    "onlyFor": "เฉพาะ {{report}}",
    "notInMetadata": "ไม่มีใน metadata",
    "transform": "การปรับค่า",
    "retire": "เลิกใช้",
    "mappingApproved": "อนุมัติการจับคู่แล้ว",
    "mappingRetired": "เลิกใช้การจับคู่แล้ว",
    "mappingDrafted": "บันทึกการจับคู่ฉบับร่างแล้ว",
    "dhis2Object": "รายการ DHIS2",
    "refreshMetadataFirst": "โปรดดึง metadata DHIS2 ก่อน",
    "cocHint": "ใช้เมื่อส่งค่าเป็นยอดรวม",
    "defaultCoc": "default",
    "scopeReport": "เฉพาะรายงาน",
    "scopeReportHint": "ใช้เมื่อ KPI เดียวกันส่งไปยังองค์ประกอบข้อมูลอื่นในรายงานอื่น",
    "anyReport": "ทุกรายงาน",
    "mappingApprovalHint": "การจับคู่จะใช้ได้หลังจากผู้อื่นที่ไม่ใช่ผู้สร้างอนุมัติเท่านั้น",
    "connectionsHint": "HMS ไม่เก็บรหัสผ่าน: ระบุชื่อตัวแปรสภาพแวดล้อม (environment variable) ของเซิร์ฟเวอร์ที่เก็บไว้",
    "newConnection": "เพิ่มการเชื่อมต่อ",
    "connectionOk": "เชื่อมต่อ DHIS2 สำเร็จ",
    "connectionFailed": "เชื่อมต่อ DHIS2 ไม่ได้",
    "metadataRefreshed": "ดึง metadata แล้ว",
    "auth": "การยืนยันตัวตน",
    "secretSet": "ตั้งแล้ว",
    "secretMissing": "ยังไม่ได้ตั้งในเซิร์ฟเวอร์",
    "lastHealth": "ตรวจเมื่อ {{at}}",
    "lastMetadata": "metadata {{at}}",
    "approvedMappings": "จับคู่ที่อนุมัติ: {{count}}",
    "draftMappings": "จับคู่ฉบับร่าง: {{count}}",
    "testConnection": "ทดสอบการเชื่อมต่อ",
    "refreshMetadata": "ดึง metadata",
    "baseUrl": "ที่อยู่ (URL)",
    "baseUrlHint": "เช่น https://dhis2.example.gov.la (ห้ามใส่ชื่อผู้ใช้หรือรหัสผ่านในลิงก์)",
    "environment": "สภาพแวดล้อม",
    "apiVersion": "เวอร์ชัน API",
    "authPat": "Personal access token",
    "authBasic": "ชื่อผู้ใช้และรหัสผ่าน",
    "secretReference": "ตัวแปรสภาพแวดล้อม",
    "secretHint": "ตั้งตัวแปรในเซิร์ฟเวอร์: token สำหรับ personal access token หรือ username:password สำหรับแบบชื่อผู้ใช้",
    "enabled": "เปิดใช้",
    "urlError": {
      "invalid": "ใส่ลิงก์ http(s) ที่ไม่มีชื่อผู้ใช้หรือรหัสผ่าน",
      "httpsRequired": "ระบบจริงต้องใช้ https"
    },
    "periodOpenText": "ช่วงนี้ยังไม่สิ้นสุด ค่าอาจเปลี่ยนแปลงได้อีก",
    "msg": {
      "minRecords": "มีเพียง {{count}} รายการ ต้องมีอย่างน้อย {{min}}",
      "noData": "ไม่มีข้อมูลในช่วงนี้",
      "noFormula": "ไม่มีสูตรที่อนุมัติสำหรับช่วงนี้",
      "stockPoint": "สถานะคลัง ณ เวลาที่คำนวณ",
      "medianNote": "ค่ามัธยฐานของบัตรคิวที่มีเวลาครบ",
      "breakdownGap": "ยอดแยกกลุ่มรวมได้ {{sum}} จาก {{total}} (ไม่ทราบเพศหรือวันเกิด)"
    }
  },
  "tenants": {
    "title": "องค์กรและโรงพยาบาล",
    "subtitle": "องค์กรที่ใช้ระบบนี้และโรงพยาบาลขององค์กร แต่ละโรงพยาบาลมีข้อมูลผู้ป่วย บุคลากร คลัง และการเงินของตนเอง",
    "newTenant": "เพิ่มองค์กร",
    "none": "ยังไม่มีองค์กร",
    "suspend": "ระงับ",
    "activate": "เปิดใช้",
    "deactivate": "ปิดใช้",
    "addHospital": "เพิ่มโรงพยาบาล",
    "noHospitals": "ยังไม่มีโรงพยาบาล",
    "hospital": "โรงพยาบาล",
    "users": "ผู้ใช้",
    "patients": "ผู้ป่วย",
    "created": "สร้างเมื่อ",
    "signInLink": "ลิงก์เข้าสู่ระบบ",
    "linkCopied": "คัดลอกลิงก์เข้าสู่ระบบแล้ว",
    "openHospital": "เปิด",
    "current": "กำลังใช้อยู่",
    "sharedCatalogNote": "รายการยา การตรวจแล็บ ค่าบริการ และบริการพิเศษ เป็นรายการร่วมระดับชาติรวมทั้งราคา ราคาแยกตามองค์กรจะทำในระยะปรับปรุงการแยกองค์กร",
    "codeHint": "รหัสสั้นตัวพิมพ์ใหญ่ เช่น MOH หรือ OPI",
    "type": "ประเภท",
    "nameLo": "ชื่อ (ลาว)",
    "nameEn": "ชื่อ (อังกฤษ)",
    "hospitalCodeHint": "รหัสไม่ซ้ำ ใช้ในลิงก์เข้าสู่ระบบด้วย",
    "startingData": "ข้อมูลเริ่มต้น",
    "startingDataHint": "โรงพยาบาลใหม่ทุกแห่งจะได้รายการโรค รายการ KPI และรายงานระดับชาติ ประเภทการนัดหมายและแผนก (ถ้าเลือก) จะคัดลอกจากโรงพยาบาลอื่น",
    "copyFrom": "คัดลอกการตั้งค่าจาก",
    "noTemplate": "ไม่คัดลอก",
    "copyDepartments": "คัดลอกแผนกด้วย",
    "firstAdmin": "ผู้ดูแลระบบคนแรก",
    "adminNew": "บัญชีใหม่",
    "adminExisting": "ผู้ใช้ที่มีอยู่",
    "adminLater": "ภายหลัง",
    "passwordHint": "อย่างน้อย 8 ตัวอักษร มีตัวพิมพ์ใหญ่ ตัวพิมพ์เล็ก และตัวเลข ผู้ดูแลจะเปลี่ยนหลังเข้าสู่ระบบ",
    "grantMe": "ให้ฉันเข้าถึงโรงพยาบาลนี้ (เพื่อตั้งค่า)",
    "createHospital": "สร้างโรงพยาบาล",
    "hospitalCreated": "สร้างและตั้งค่าโรงพยาบาลแล้ว"
  },
  "referrals": {
    "title": "การส่งต่อ",
    "subtitle": "ผู้ป่วยที่เราส่งไปสถานพยาบาลอื่นและผู้ป่วยที่ถูกส่งมาหาเรา พร้อมคำตอบและผล",
    "new": "สร้างการส่งต่อ",
    "refer": "ส่งต่อ",
    "none": "ไม่มีการส่งต่อ",
    "number": "เลขที่ส่งต่อ",
    "direction": "ทิศทาง",
    "patient": "ผู้ป่วย",
    "facility": "สถานพยาบาล",
    "reason": "เหตุผลการส่งต่อ",
    "priority": "ความเร่งด่วน",
    "open": "ยังไม่เสร็จ",
    "search": "ค้นหาด้วยเลขที่ ผู้ป่วย หรือสถานพยาบาล…",
    "outLong": "เราส่งผู้ป่วยออก",
    "inLong": "ถูกส่งมาหาเรา",
    "toFacility": "ส่งไปที่",
    "fromFacility": "ส่งมาจาก",
    "facilityContact": "ติดต่อสถานพยาบาล",
    "specialty": "แผนก / บริการ",
    "diagnosis": "การวินิจฉัย",
    "clinicalSummary": "สรุปทางคลินิก",
    "clinicalSummaryHint": "ประวัติ สิ่งที่ตรวจพบ ผลตรวจ และการรักษาที่ผ่านมา",
    "transport": "การเดินทาง",
    "created": "สร้างการส่งต่อแล้ว",
    "sent": "ทำเครื่องหมายว่าส่งแล้ว",
    "printLetter": "พิมพ์ใบส่งตัว",
    "printSummary": "พิมพ์สรุป",
    "logContact": "บันทึกการติดต่อ",
    "markSent": "ทำเครื่องหมายว่าส่งแล้ว",
    "markUnreachable": "ติดต่อไม่ได้",
    "decline": "ถูกปฏิเสธ",
    "accept": "รับแล้ว",
    "complete": "บันทึกผล",
    "byOn": "โดย {{by}} เมื่อ {{at}}",
    "encounter": "การตรวจ",
    "appointmentAt": "นัดหมาย",
    "contactAttempts": "จำนวนครั้งที่ติดต่อ",
    "response": "คำตอบ",
    "outcome": "ผล",
    "cancelledBecause": "ยกเลิก: {{reason}}",
    "history": "ประวัติ",
    "contactResult": "ผลการติดต่อ",
    "step": {
      "accept": "รับการส่งต่อ",
      "decline": "ปฏิเสธการส่งต่อ",
      "unreachable": "ติดต่อสถานพยาบาลไม่ได้",
      "complete": "ผลของการส่งต่อ",
      "cancel": "ยกเลิกการส่งต่อ",
      "contact": "การติดต่อกับสถานพยาบาลหรือผู้ป่วย"
    },
    "done": {
      "accept": "รับการส่งต่อแล้ว",
      "decline": "ปฏิเสธแล้ว",
      "unreachable": "ทำเครื่องหมายว่าติดต่อไม่ได้",
      "complete": "บันทึกผลแล้ว",
      "cancel": "ยกเลิกแล้ว",
      "contact": "บันทึกการติดต่อแล้ว"
    },
    "noteLabel": {
      "accept": "หมายเหตุ (ผู้รับ คำแนะนำ)",
      "decline": "เหตุผลที่ปฏิเสธ",
      "unreachable": "สิ่งที่ลองแล้ว",
      "complete": "ผล (การวินิจฉัย การรักษา แผน)",
      "cancel": "เหตุผลการยกเลิก",
      "contact": "หมายเหตุ"
    },
    "letterTitle": "ใบส่งตัวผู้ป่วย",
    "summaryTitle": "การรับผู้ป่วยส่งต่อ",
    "referringClinician": "แพทย์ผู้ส่ง",
    "receivingFacility": "สถานพยาบาลผู้รับ",
    "feedbackRequest": "การแจ้งผลกลับ",
    "feedbackText": "โปรดแจ้งผลการตรวจและแผนการรักษากลับมา เพื่อให้เราดูแลผู้ป่วยต่อได้"
  },
  "followUps": {
    "title": "การนัดติดตาม",
    "subtitle": "การนัดติดตามทุกแผนก: ที่ถึงกำหนด เกินกำหนด และเสร็จแล้ว",
    "new": "สร้างการนัดติดตาม",
    "plan": "นัดติดตาม",
    "none": "ไม่มีการนัดติดตาม",
    "due": "กำหนด",
    "patient": "ผู้ป่วย",
    "reason": "เหตุผล",
    "who": "แผนก / แพทย์",
    "outcome": "ผล",
    "done": "เสร็จ",
    "missed": "ไม่มา",
    "reopen": "เปิดใหม่",
    "overdueBy": "เกินกำหนด {{days}} วัน",
    "inDays": "อีก {{days}} วัน",
    "created": "นัดติดตามแล้ว",
    "priority": "ความเร่งด่วน",
    "department": "แผนก",
    "practitioner": "แพทย์",
    "instructions": "คำแนะนำผู้ป่วย",
    "instructionsHint": "เช่น งดอาหารก่อนมา นำยามาด้วย",
    "filter": {
      "upcoming": "ถึงกำหนดภายในสัปดาห์",
      "overdue": "เกินกำหนด",
      "today": "กำหนดวันนี้",
      "week": "7 วันข้างหน้า"
    },
    "action": {
      "complete": "ติดตามเสร็จแล้ว",
      "missed": "ผู้ป่วยไม่มา",
      "cancel": "ยกเลิกการนัด"
    },
    "noteLabel": {
      "complete": "ผล",
      "missed": "หมายเหตุ (ไม่บังคับ)",
      "cancel": "เหตุผลการยกเลิก"
    }
  },
  "duplicates": {
    "title": "ผู้ป่วยซ้ำ",
    "subtitle": "ระเบียนที่อาจเป็นคนเดียวกัน คนหนึ่งขอรวม อีกคนหนึ่งเป็นผู้อนุมัติ",
    "tabSuggestions": "อาจซ้ำกัน",
    "tabRequests": "คำขอรวม",
    "noneFound": "ไม่พบระเบียนที่อาจซ้ำกัน",
    "suggestionsHint": "{{count}} คู่ที่อาจซ้ำกัน เรียงจากที่น่าจะซ้ำที่สุด",
    "requestPending": "รออนุมัติการรวม",
    "notDuplicates": "ไม่ใช่คนเดียวกัน",
    "askMerge": "ขอรวม",
    "dismissed": "จะไม่แนะนำคู่นี้อีก",
    "dismissMessage": "สองระเบียนนี้เป็นคนละคนและจะไม่ถูกแนะนำอีก",
    "dismissReason": "เหตุผล (เช่น ฝาแฝด พ่อแม่และลูก)",
    "visits": "มาตรวจ {{count}} ครั้ง",
    "lastVisit": "ล่าสุด {{date}}",
    "registered": "ลงทะเบียน {{date}}",
    "keepThis": "เก็บระเบียนนี้",
    "keeping": "ระเบียนที่เก็บ",
    "chooseSurvivor": "เลือกระเบียนที่จะเก็บ ทุกอย่างจากอีกระเบียนจะย้ายมา",
    "mergeExplain": "{{merge}} จะถูกรวมเข้า {{keep}}: การตรวจ บิล ผลตรวจ และข้อมูลอื่นจะย้ายไป และระเบียนที่ถูกรวมจะใช้ไม่ได้อีก",
    "reasonLabel": "เหตุผล",
    "sendForApproval": "ส่งให้อนุมัติ",
    "requested": "ส่งคำขอรวมให้อนุมัติแล้ว",
    "noRequests": "ไม่มีคำขอรวม",
    "askedBy": "ขอโดย {{by}} เมื่อ {{at}}",
    "decidedBy": "ตัดสินโดย {{by}} เมื่อ {{at}}",
    "survivor": "เก็บไว้",
    "duplicate": "รวมเข้าระเบียนที่เก็บ",
    "decisionNote": "หมายเหตุการตัดสิน",
    "movedRecords": "ย้าย {{count}} รายการไปยังผู้ป่วยที่เก็บ",
    "keptOnDuplicate": "ยังอยู่กับระเบียนที่ถูกรวม (หนึ่งต่อผู้ป่วย): {{list}}",
    "cancelRequest": "ยกเลิกคำขอ",
    "reject": "ปฏิเสธ",
    "approveMerge": "อนุมัติการรวม",
    "mergeNow": "รวมตอนนี้",
    "approveNote": "หมายเหตุ (ไม่บังคับ)",
    "rejectNote": "เหตุผลที่ปฏิเสธ",
    "merged": "รวมระเบียนแล้ว",
    "rejected": "ปฏิเสธการรวมแล้ว",
    "mergedBanner": "ระเบียนนี้ถูกรวมเข้าระเบียนผู้ป่วยอื่นแล้วและใช้ไม่ได้อีก",
    "openSurvivor": "เปิดระเบียนที่เก็บ",
    "reason": {
      "NAME_DOB": "ชื่อและวันเกิดเหมือนกัน",
      "SIMILAR_NAME_DOB": "ชื่อคล้ายกัน วันเกิดเหมือนกัน",
      "PHONE_NAME": "เบอร์โทรเดียวกัน ชื่อคล้ายกัน",
      "IDENTIFIER": "เลขบัตรเดียวกัน"
    }
  },
  "registry": {
    "sectionNamesEn": "ชื่อภาษาอังกฤษและชื่อเล่น",
    "firstNameEn": "ชื่อ (อังกฤษ)",
    "lastNameEn": "นามสกุล (อังกฤษ)",
    "nickname": "ชื่อเล่น",
    "nicknameEn": "ชื่อเล่น (อังกฤษ)",
    "sectionBackground": "ข้อมูลพื้นฐาน",
    "nationality": "สัญชาติ",
    "country": "ประเทศที่ถือสัญชาติ",
    "ethnicity": "กลุ่มชาติพันธุ์",
    "religion": "ศาสนา",
    "firstLanguage": "ภาษาแม่",
    "occupation": "อาชีพ",
    "educationLevel": "ระดับการศึกษา",
    "sectionBirth": "สถานที่เกิด",
    "birthCountry": "ประเทศที่เกิด",
    "birthPlace": "สถานที่เกิด (อื่นๆ)",
    "birthPlaceHint": "โรงพยาบาลหรือสถานที่ ถ้าไม่ใช่หมู่บ้าน",
    "sectionHousehold": "ครัวเรือน",
    "houseNo": "บ้านเลขที่",
    "householdUnit": "หน่วย",
    "familyBookNo": "เลขที่ทะเบียนบ้าน",
    "relationshipToHead": "ความสัมพันธ์กับหัวหน้าครอบครัว",
    "isHouseholdHead": "เป็นหัวหน้าครอบครัว",
    "sectionParents": "บิดาและมารดา",
    "fatherName": "ชื่อบิดา",
    "motherName": "ชื่อมารดา",
    "parentOccupation": "อาชีพ",
    "parentPhone": "เบอร์โทร",
    "parentNationalId": "เลขบัตรประชาชน",
    "parentWorkplace": "สถานที่ทำงาน",
    "sectionHealth": "ประวัติสุขภาพ",
    "hearingIssue": "มีปัญหาการได้ยิน",
    "speakingIssue": "มีปัญหาการพูด",
    "visionIssue": "มีปัญหาสายตา",
    "heightCm": "ส่วนสูง (ซม.)",
    "weightKg": "น้ำหนัก (กก.)",
    "medicalIssues": "ปัญหาสุขภาพ",
    "seriousIllness": "เคยเจ็บป่วยหนัก",
    "title": "ข้อมูลทะเบียน",
    "namesEn": "ชื่อภาษาอังกฤษ",
    "heightWeight": "ส่วนสูงและน้ำหนัก",
    "sectionDisability": "ความพิการ",
    "disabilityTypes": "ประเภทความพิการ",
    "disabilityTypesHint": "เลือกทุกข้อที่เกี่ยวข้อง ประเภทย่อยจะแสดงใต้ประเภทที่เลือก \"ไม่ทราบ / ยังไม่ได้ประเมิน\" เลือกร่วมกับข้ออื่นไม่ได้",
    "disabilityChooseOne": "เลือกหนึ่งข้อ",
    "disabilityChooseAny": "เลือกได้หลายข้อ"
  },
  "staffKpi": {
    "title": "สรุปผลงาน",
    "titleFor": "สรุปผลงาน: {{name}}",
    "subtitle": "งานที่บันทึกในบัญชีนี้แต่ละเดือน แยกตามส่วนของระบบ",
    "backToUsers": "กลับไปรายชื่อผู้ใช้",
    "showAll": "แสดงงานที่ไม่มีรายการด้วย",
    "nothing": "ไม่มีงานที่บันทึกใน {{period}}",
    "vsPrevious": "ช่วงก่อน {{value}}",
    "column": "สรุปผลงาน",
    "open": "ดู",
    "mine": "สรุปผลงานของฉัน",
    "metric": {
      "PATIENTS_REGISTERED": "ลงทะเบียนผู้ป่วย",
      "APPOINTMENTS_BOOKED": "นัดหมายที่บันทึก",
      "QUEUE_CALLED": "เรียกผู้ป่วยจากคิว",
      "ENCOUNTERS_SEEN": "ตรวจผู้ป่วย (เป็นแพทย์)",
      "VITALS_RECORDED": "บันทึกสัญญาณชีพ",
      "DIAGNOSES_RECORDED": "บันทึกการวินิจฉัย",
      "NOTES_SIGNED": "ลงนามบันทึก",
      "LAB_ORDERS": "สั่งตรวจแล็บ",
      "LAB_RESULTS_ENTERED": "บันทึกผลแล็บ",
      "LAB_RESULTS_VERIFIED": "ยืนยันผลแล็บ",
      "SERVICES_REPORTED": "รายงานบริการพิเศษ",
      "REFERRALS_MADE": "ส่งต่อผู้ป่วย",
      "FOLLOW_UPS_DONE": "ติดตามเสร็จ",
      "EYE_EXAMS_SIGNED": "ลงนามการตรวจตา",
      "VA_MEASURED": "วัดสายตา",
      "SURGERIES_PERFORMED": "ผ่าตัด",
      "INJECTIONS_GIVEN": "ฉีดยา",
      "ADMISSIONS": "รับผู้ป่วยใน",
      "DISCHARGES": "จำหน่ายผู้ป่วย",
      "PRESCRIPTIONS_WRITTEN": "เขียนใบสั่งยา",
      "DISPENSED": "จ่ายยา",
      "POS_SALES": "ขายหน้าร้าน",
      "STOCK_DOCUMENTS": "เอกสารคลัง",
      "INVOICES_ISSUED": "ออกบิล",
      "PAYMENTS_RECEIVED": "รับชำระเงิน",
      "PAYMENTS_AMOUNT": "จำนวนเงินที่รับ",
      "SYSTEM_ACTIONS": "การกระทำในระบบ"
    },
    "team": {
      "title": "KPI บุคลากร",
      "subtitle": "งานที่บันทึกของแต่ละคนในแต่ละเดือน เทียบกับเป้าหมายรายเดือน",
      "leaderboard": "อันดับ",
      "targets": "เป้าหมาย",
      "metric": "ตัวชี้วัด",
      "role": "บทบาท",
      "anyRole": "ทุกบทบาท",
      "showZero": "แสดงบุคลากรที่ไม่มีงานด้วย",
      "rank": "อันดับ",
      "staff": "บุคลากร",
      "roles": "บทบาท",
      "department": "แผนก",
      "thisMonth": "ช่วงนี้",
      "lastMonth": "ช่วงก่อน",
      "target": "เป้าหมาย",
      "achievement": "บรรลุ",
      "noTarget": "ไม่มีเป้าหมาย",
      "total": "รวมทั้งทีม",
      "counted": "บุคลากรที่มีงาน",
      "withTarget": "บุคลากรที่มีเป้าหมาย",
      "metTarget": "บรรลุเป้าหมาย",
      "empty": "ไม่มีงานที่บันทึกสำหรับตัวชี้วัดและเดือนนี้",
      "supervisionNote": "ใช้เพื่อการกำกับดูแลและให้คำแนะนำเท่านั้น — KPI บุคลากรไม่ส่งเข้า DHIS2 และห้ามใช้ตัดสินเรื่องบุคลากรโดยอัตโนมัติ",
      "addTarget": "เพิ่มเป้าหมาย",
      "editTarget": "แก้ไขเป้าหมาย",
      "appliesTo": "ใช้กับ",
      "forRole": "บทบาท",
      "forPerson": "บุคคล",
      "person": "บุคคล",
      "monthlyTarget": "เป้าหมายรายเดือน",
      "monthlyTargetMoney": "เป้าหมายรายเดือน (จำนวนเงิน)",
      "targetHint": "ต่อเดือน ไตรมาส ×3 ปี ×12 วันและช่วงวันที่คิดตามสัดส่วนจำนวนวัน เป้าหมายของบุคคลจะใช้แทนเป้าหมายของบทบาท",
      "targetsHelp": "เป้าหมายของบทบาทใช้กับทุกคนในบทบาทนั้น เป้าหมายของบุคคลจะใช้แทน",
      "noTargets": "ยังไม่มีเป้าหมาย",
      "updated": "แก้ไขล่าสุด",
      "deleteTarget": "ลบเป้าหมาย"
    },
    "dash": {
      "title": "แดชบอร์ด",
      "vsLastMonth": "เทียบกับช่วงก่อน",
      "activeStaff": "บุคลากรที่มีงาน",
      "targetsMet": "บรรลุเป้าหมาย",
      "ofTargets": "{{met}} จาก {{total}}",
      "byArea": "งานตามด้านตามเวลา",
      "attainment": "เป้าหมายในช่วงนี้",
      "met": "บรรลุ",
      "close": "ใกล้ (70–99%)",
      "behind": "ต่ำกว่า (ต่ำกว่า 70%)",
      "noTargets": "ยังไม่ได้ตั้งเป้าหมาย — เพิ่มได้ที่แท็บเป้าหมาย",
      "withoutTarget": "บุคลากรที่มีงาน {{value}} คนยังไม่มีเป้าหมาย",
      "top5": "5 อันดับแรก",
      "byRole": "งานตามบทบาทในช่วงนี้",
      "byRoleHint": "ผู้ที่มีหลายบทบาทจะนับในทุกบทบาท",
      "people": "{{value}} คน",
      "workItems": "จำนวนงาน",
      "heatmap": "งานของแต่ละคนตามเวลา",
      "heatmapHint": "สีเข้ม = งานมาก คลิกแถวเพื่อดูสรุปของคนนั้น"
    },
    "period": {
      "day": "วัน",
      "month": "เดือน",
      "quarter": "ไตรมาส",
      "year": "ปี",
      "range": "ช่วงวันที่",
      "from": "จาก",
      "to": "ถึง",
      "vs": "เทียบกับ {{previous}}",
      "prorated": "เป้าหมายคิดตามสัดส่วนจำนวนวัน"
    },
    "trendTotal": "รวมในกราฟ {{value}}"
  },
  "roles": {
    "title": "บทบาทและสิทธิ์",
    "subtitle": "แต่ละบทบาทคือชุดสิทธิ์ มอบบทบาทให้บุคลากรที่หน้าผู้ใช้",
    "newRole": "เพิ่มบทบาท",
    "howItWorks": "การเปลี่ยนแปลงมีผลกับแต่ละคนภายใน 15 นาที (เมื่อเข้าสู่ระบบหรือต่ออายุ token) บทบาทใช้ร่วมกันทุกโรงพยาบาล สิทธิ์ระดับแพลตฟอร์มมีเฉพาะผู้ดูแลสูงสุด",
    "searchRoles": "ค้นหาบทบาท…",
    "permissionCount": "{{count}} สิทธิ์",
    "pick": "เลือกบทบาท",
    "locked": "ล็อก",
    "builtIn": "มีในระบบ",
    "custom": "สร้างเอง",
    "inUse": "ยังมอบให้ผู้ใช้อยู่",
    "name": "ชื่อบทบาท",
    "usersLine": "{{here}} คนในโรงพยาบาลนี้ · {{total}} คนทุกโรงพยาบาล",
    "saveDetails": "บันทึกรายละเอียด",
    "lockedHint": "ผู้ดูแลสูงสุดมีทุกสิทธิ์เสมอ",
    "permissions": "สิทธิ์ ({{count}})",
    "searchPermissions": "ค้นหาสิทธิ์…",
    "savePermissions": "บันทึกสิทธิ์",
    "platformOnly": "เฉพาะแพลตฟอร์ม",
    "deleteRole": "ลบบทบาท",
    "deleteMessage": "ลบบทบาท {{name}}? ไม่มีใครมีบทบาทนี้",
    "create": "สร้างบทบาท",
    "codeHint": "ตัวพิมพ์ใหญ่และ _ เช่น EYE_SCREENER",
    "copyFrom": "คัดลอกสิทธิ์จาก",
    "startEmpty": "เริ่มโดยไม่มีสิทธิ์",
    "saved": "บันทึกสิทธิ์แล้ว",
    "deleted": "ลบบทบาทแล้ว",
    "created": "สร้างบทบาทแล้ว"
  },
  "permGroup": {
    "appointment": "นัดหมาย",
    "audit": "บันทึกการตรวจสอบ",
    "billing": "บิล",
    "careplan": "แผนการดูแล",
    "cash": "ลิ้นชักเงินสด",
    "dhis2": "DHIS2",
    "diagnosis": "การวินิจฉัย",
    "disease": "รายการโรค",
    "encounter": "การตรวจรักษา",
    "finance": "การเงิน",
    "followup": "การนัดติดตาม",
    "i18n": "ภาษาและข้อความ",
    "inpatient": "ผู้ป่วยใน",
    "inventory": "คลัง",
    "kpi": "KPI",
    "lab": "ห้องแล็บ",
    "location": "สถานที่",
    "medication": "ยา",
    "note": "บันทึกทางการแพทย์",
    "ophthalmology": "ศูนย์ตา",
    "organization": "โรงพยาบาลและแผนก",
    "pathway": "วงจรการรักษา",
    "patient": "ผู้ป่วย",
    "payment": "การรับชำระ",
    "pharmacy": "ห้องยา",
    "portal": "แอปผู้ป่วย",
    "pos": "ร้านขายยา POS",
    "prescription": "ใบสั่งยา",
    "purchase": "การจัดซื้อ",
    "queue": "คิว",
    "referral": "การส่งต่อ",
    "report": "รายงาน",
    "role": "บทบาท",
    "sales": "การขายหน้าร้าน",
    "service": "บริการพิเศษ",
    "tenant": "องค์กร",
    "user": "ผู้ใช้",
    "ward": "หอผู้ป่วยและเตียง",
    "reference": "รายการรหัสกลาง",
    "staffkpi": "KPI บุคลากร"
  },
  "permAction": {
    "admin": "บริหาร",
    "approve": "อนุมัติ",
    "collect": "รับเงิน",
    "discount": "ให้ส่วนลด",
    "dispense": "จ่ายยา",
    "enter": "บันทึกผล",
    "global": "ทุกโรงพยาบาล",
    "manage": "จัดการ",
    "merge": "รวมระเบียน",
    "order": "สั่ง",
    "perform": "ดำเนินการ",
    "prepare": "เตรียม",
    "read": "ดู",
    "refund": "คืนเงิน",
    "request": "ขอ",
    "sell": "ขาย",
    "sensitive": "ข้อมูลอ่อนไหว",
    "session": "เปิดและปิด",
    "sign": "ลงนาม",
    "stock": "สต็อก",
    "submit": "ส่ง",
    "surgery": "ผ่าตัด",
    "verify": "ยืนยัน",
    "void": "ยกเลิก",
    "write": "สร้างและแก้ไข",
    "kiosk": "ใช้ตู้บริการ",
    "display": "แสดงจอคิว",
    "triage": "ลำดับความสำคัญทางคลินิก",
    "configure": "ตั้งค่า"
  },
  "apptDash": {
    "title": "แดชบอร์ดนัดหมาย",
    "subtitle": "ตารางนัดวันนี้ ภาพรวมรายเดือน และการนัดติดตามที่ต้องดูแล",
    "followUpWatch": "เฝ้าระวังการนัดติดตาม",
    "followUpWatchHint": "การนัดติดตามที่เกินกำหนดหรือใกล้ถึงกำหนด",
    "followUpRestOfWeek": "วันอื่นใน 7 วันข้างหน้า",
    "patients": "ผู้ป่วย {{value}} ราย",
    "openFollowUps": "นัดติดตามที่ยังเปิดอยู่",
    "needsAttention": "ต้องดูแล",
    "noOverdue": "ไม่มีการนัดติดตามที่เกินกำหนด",
    "otherDepartments": "อื่น ๆ",
    "byDepartment": "นัดหมายตามแผนก",
    "byDepartmentHint": "สัดส่วนนัดหมายเดือน {{month}}",
    "lastMonth": "เดือนก่อน",
    "pillHint": "ตัวเลขในแท่งแสดงการเปลี่ยนแปลงเทียบกับเดือนก่อน",
    "scheduled": "นัดทั้งหมด",
    "overview": "สรุปนัดหมาย",
    "overviewHint": "ยอดรวมเดือน {{month}} · ตารางวันที่ {{date}}",
    "calendar": "ปฏิทินนัดหมาย",
    "calendarHint": "เลือกวันเพื่อดูตารางนัด",
    "more": "+อีก {{value}} รายการ",
    "legend": "คำอธิบายสี",
    "legendHint": "สีในปฏิทินแยกตามแผนก",
    "waiting": "รอ",
    "arrived": "มาถึงแล้ว",
    "patientsBooked": "ผู้ป่วย",
    "beds": "เตียง",
    "bedsHint": "หอผู้ป่วยใน",
    "doctorsOnDuty": "แพทย์เข้าเวร",
    "activeDoctors": "แพทย์ที่ปฏิบัติงาน",
    "departmentsOpen": "แผนก",
    "upcoming": "นัดที่กำลังจะมาถึง",
    "next7Days": "7 วันข้างหน้า",
    "weekdays": {
      "1": "จ.",
      "2": "อ.",
      "3": "พ.",
      "4": "พฤ.",
      "5": "ศ.",
      "6": "ส.",
      "7": "อา."
    }
  },
  "disabilityTypes": {
    "title": "ประเภทความพิการ",
    "subtitle": "การจำแนกที่ใช้เมื่อลงทะเบียนผู้ป่วย ใช้ร่วมกันทุกโรงพยาบาล",
    "new": "เพิ่มประเภทความพิการ",
    "deleted": "ลบประเภทความพิการแล้ว",
    "inUseHint": "มีผู้ป่วย {{count}} รายที่มีประเภทนี้ จึงลบไม่ได้ ยกเลิก \"ใช้งาน\" เพื่อซ่อนจากการลงทะเบียน",
    "codeHint": "อักษรตัวใหญ่ ตัวเลข - หรือ _ (เช่น PWD11)",
    "sortOrder": "ลำดับการแสดง",
    "nameLa": "ชื่อ (ลาว)",
    "nameEn": "ชื่อ (อังกฤษ)",
    "activeLabel": "ใช้งาน (แสดงเมื่อลงทะเบียนผู้ป่วย)",
    "deleteTitle": "ลบประเภทความพิการหรือไม่?",
    "deleteMessage": "{{code}} จะถูกลบ ไม่มีผู้ป่วยรายใดมีประเภทนี้",
    "patients": "ผู้ป่วย",
    "parent": "เป็นประเภทย่อยของ",
    "noParent": "— ประเภทหลัก —",
    "icd11Code": "รหัส ICD-11",
    "exclusiveLabel": "เลือกร่วมกับประเภทอื่นไม่ได้ (เช่น ไม่ทราบ / ยังไม่ได้ประเมิน)",
    "singleChoiceLabel": "เลือกประเภทย่อยได้เพียงข้อเดียว",
    "exclusiveBadge": "เลือกเดี่ยว",
    "singleChoiceBadge": "ประเภทย่อยเดียว"
  },
  "queueServices": {
    "title": "จุดบริการคิว",
    "subtitle": "แต่ละจุดบริการมีคิวของตนเองทุกวัน ผู้ป่วยใช้หมายเลขเดียวขณะย้ายระหว่างจุด",
    "add": "เพิ่มจุดบริการ",
    "edit": "แก้ไข {{code}}",
    "prefix": "อักษรนำหน้าหมายเลข",
    "prefixHint": "ตัวอักษรหรือตัวเลข เช่น R ได้ R-001",
    "nameLocal": "ชื่อ (ลาว)",
    "nameEn": "ชื่อ (อังกฤษ)",
    "departmentHint": "นัดหมายและผู้ป่วย walk-in ของแผนกเริ่มที่จุดบริการแรกของแผนก",
    "noDepartment": "ไม่มีแผนก",
    "counters": "เคาน์เตอร์ / ห้อง",
    "countersHint": "คั่นด้วยจุลภาค เช่น ห้อง 1, ห้อง 2",
    "sortOrder": "ลำดับ",
    "sortOrderHint": "เลขน้อยมาก่อน",
    "kiosk": "ตู้บริการ",
    "kioskEnabled": "ผู้ป่วย walk-in เลือกได้ที่ตู้บริการ"
  }
}
